/* eslint-disable jsx-quotes */
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
import moment from 'moment';
import { useRouter } from 'next/router';
import Slider from 'react-slick';
import useTrans from '../../hooks/useTrans';
import MetaSeo from '../MetaSeo';
import { formatMoney, trimText } from '../../lib/common';
import { getListJob } from '../../redux/actions/job';
import { getListPostHot, getListPostNew } from '../../redux/actions/news';
import { getListProjectFeature } from '../../redux/actions/project';
import { getImageOffice } from '../../redux/actions/upload';
import Link from 'next/link';
import { isMobile } from 'react-device-detect';
import { ArrowRightOutlined } from '@ant-design/icons';

const dataBaner = [
  {
    id: 1,
    imgDesktop: '/assets/images/home/slide-web-tcom-01.png',
    imgMobile: '/assets/images/home/slide-header-mobile-01.png',
    trans: 'solution',
    links: '/solution',
  },
  {
    id: 2,
    imgDesktop: '/assets/images/home/slide-web-tcom-03.png',
    imgMobile: '/assets/images/home/slide-header-mobile-02.png',
    trans: 'ai',
    links: 'https://eyefire.vn/',
  },
  {
    id: 3,
    imgDesktop: '/assets/images/home/slide-web-tcom-02.png',
    imgMobile: '/assets/images/home/slide-header-mobile-03.png',
    trans: 'blockchain',
    links: '/service/blockchain',
  },
  // {
  //   id: 4,
  //   imgDesktop: '/assets/images/home/slide-web-tcom-04.jpg',
  //   imgMobile: '/assets/images/home/slide-header-mobile-04.png',
  //   trans: 'factory',
  //   links: 'https://safety.eyefire.vn/',
  //   newpage: true,
  // },
  {
    id: 5,
    imgDesktop: '/assets/images/home/slide-web-tcom-05.jpg',
    imgMobile: '/assets/images/home/slide-header-mobile-05.png',
    trans: 'school',
    links: 'https://sc.eyefire.vn/',
    newpage: true,
  },
  {
    id: 6,
    imgDesktop: '/assets/images/home/slide-web-tcom-06.jpg',
    imgMobile: '/assets/images/home/slide-header-mobile-06.png',
    trans: 'solution1',
    links: 'https://aiot.eyefire.vn/',
    newpage: true,
  },
  {
    id: 7,
    imgDesktop: '/assets/images/home/slide-web-tcom-07.jpg',
    imgMobile: '/assets/images/home/slide-header-mobile-07.png',
    trans: 'solution2',
    links: 'https://safety.eyefire.vn/',
    newpage: true,
  },
];
export default function Home(props) {
  const current = moment();
  const slider = useRef();
  const dispatch = useDispatch();
  const trans = useTrans();
  const slider_feature = useRef();
  const [list_project, setListProject] = useState([]);
  const [list_new, setListNew] = useState([]);
  const [list_new_post, setListNewPost] = useState([]);
  const [total_new_post, setTotalNewPost] = useState();
  const [list_job, setListJob] = useState([]);
  const [list_image_office, setListImageOffice] = useState([]);
  const [isShowModal, setIsShowModal] = useState(false);
  const [countSlider, setCountSlider] = useState(1);
  const [dotKey, setDotKey] = useState(0);
  const [dotMb, setDotMb] = useState(0);

  const refYoutobe = useRef();
  const router = useRouter();
  const refClickYoutobe = useRef();

  useEffect(() => {
    getListProjectFeatureHome(router.locale);
    getListJobSlide();
    getNewHot(router.locale);
    getPostNew(router.locale);
    getListImageOffice();
  }, [router.locale]);

  const handleClickOut = event => {
    const { target } = event;
    if (
      refYoutobe &&
      refClickYoutobe &&
      refClickYoutobe.current &&
      refYoutobe.current &&
      !refYoutobe.current.contains(target) &&
      !refClickYoutobe.current.contains(target)
    ) {
      setIsShowModal(false);
    }
  };
  useEffect(() => {
    window.addEventListener('click', handleClickOut);
    return () => {
      window.removeEventListener('click', handleClickOut);
    };
  }, []);
  const getNewHot = async locale => {
    const data = await getListPostHot({ sign: locale });
    setListNew(data);
  };
  const getListImageOffice = async () => {
    const data = await getImageOffice();
    setListImageOffice(data);
  };
  // useEffect(() => {
  //   getListJob({ type: 'home' }, dispatch);
  // }, []);
  const getListJobSlide = async () => {
    const data = await getListJob({ limit: 20, type: 'home' }, dispatch);
    if (data) setListJob(data.rows);
  };
  if (list_job && list_job.rows && list_job.rows.length === 2) {
    list_job.rows = [...list_job.rows, ...list_job.rows];
  }
  if (list_job && list_job.rows && list_job.rows.length === 3) {
    list_job.rows = [...list_job.rows, ...list_job.rows];
  }
  if (list_job && list_job.rows && list_job.rows.length === 1) {
    list_job.rows = [
      ...list_job.rows,
      ...list_job.rows,
      ...list_job.rows,
      ...list_job.rows,
    ];
  }
  const getPostNew = async locale => {
    const data = await getListPostNew({ sign: locale });
    if (data) {
      setListNewPost(data.rows);
      setTotalNewPost(data.total);
    }
  };
  const getListProjectFeatureHome = async locale => {
    const data = await getListProjectFeature({ sign: locale });
    setListProject(data);
  };
  const stripHtml = html => {
    let tmp = document.createElement('p');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };
  const settings = {
    dots: false,
    speed: 300,
    // autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: (
      <button
        className="slick-prev slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/images/home/icon-next.svg" />
      </button>
    ),
    nextArrow: (
      <button
        className="slick-next slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/images/home/icon-next.svg" />
      </button>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // console.log(list_new,'checkkkkkkk newLIST5555555555');
  const setting_office = {
    dots: false,
    infinite: true,
    // autoplay: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <button
        className="slick-prev slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/images/home/icon-next.svg" />
      </button>
    ),
    nextArrow: (
      <button
        className="slick-next slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/images/home/icon-next.svg" />
      </button>
    ),
  };
  const setting_project_feature = {
    dots: false,
    infinite: true,
    // autoplay: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: currentSlide => {
      setCountSlider(currentSlide + 1);
    },
  };
  const setting_job = {
    loop: false,
    margin: 50,
    infinite: true,
    // autoplay: true,
    speed: 500,
    slidesToShow: 3,
    // autoWidth:true,
    nav: true,
    dots: false,
    nextArrow: (
      <button
        className="slick-next slick-arrow"
        aria-label="Next"
        type="button"
      >
        <svg
          width={41}
          height={41}
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_400_1139)">
            <path
              d="M20.4414 0.141117C9.39594 0.141115 0.441405 9.09564 0.441403 20.1411C0.441401 31.1866 9.39593 40.1411 20.4414 40.1411C31.4869 40.1411 40.4414 31.1866 40.4414 20.1411C40.4414 9.09565 31.4869 0.141119 20.4414 0.141117ZM20.4414 36.8078C11.2369 36.8078 3.77476 29.3456 3.77476 20.1411C3.77476 10.9366 11.2369 3.47447 20.4414 3.47448C29.6459 3.47448 37.108 10.9366 37.108 20.1411C37.108 29.3456 29.6459 36.8078 20.4414 36.8078Z"
              fill="white"
            />
            <path
              d="M18.2866 10.6293C17.6357 9.9784 16.5804 9.9784 15.9296 10.6293C15.2787 11.2801 15.2787 12.3354 15.9296 12.9863L23.0844 20.1411L15.9295 27.296C15.2787 27.9468 15.2787 29.0021 15.9295 29.653C16.5804 30.3039 17.6357 30.3039 18.2866 29.653L26.6199 21.3196C27.2708 20.6688 27.2708 19.6135 26.6199 18.9626L18.2866 10.6293Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_400_1139">
              <rect
                width={40}
                height={40}
                fill="white"
                transform="translate(0.441406 0.141113)"
              />
            </clipPath>
          </defs>
        </svg>
      </button>
    ),
    prevArrow: (
      <button
        className="slick-prev slick-arrow"
        aria-label="Pevious"
        type="button"
      >
        <svg
          width={41}
          height={41}
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_400_1146)">
            <path
              d="M20.4414 40.1411C31.4869 40.1411 40.4414 31.1866 40.4414 20.1411C40.4414 9.09565 31.4869 0.141116 20.4414 0.141115C9.39594 0.141114 0.441413 9.09564 0.441412 20.1411C0.441411 31.1866 9.39594 40.1411 20.4414 40.1411ZM20.4414 3.47447C29.6459 3.47447 37.108 10.9366 37.108 20.1411C37.108 29.3456 29.6459 36.8078 20.4414 36.8078C11.2369 36.8078 3.77477 29.3456 3.77477 20.1411C3.77477 10.9366 11.2369 3.47447 20.4414 3.47447Z"
              fill="white"
            />
            <path
              d="M22.5962 29.653C23.2471 30.3038 24.3024 30.3038 24.9533 29.653C25.6041 29.0021 25.6041 27.9468 24.9533 27.2959L17.7984 20.1411L24.9533 12.9863C25.6041 12.3354 25.6041 11.2801 24.9533 10.6292C24.3024 9.97836 23.2471 9.97836 22.5962 10.6292L14.2629 18.9626C13.612 19.6134 13.612 20.6688 14.2629 21.3196L22.5962 29.653Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_400_1146">
              <rect
                width={40}
                height={40}
                fill="white"
                transform="translate(40.4414 40.1411) rotate(-180)"
              />
            </clipPath>
          </defs>
        </svg>
      </button>
    ),
    responsive: [
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          // margin: 120,
        },
      },
    ],
  };
  const mySettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <></>,
    prevArrow: <></>,
    appendDots: dots => {
      return (
        <div
          style={{
            borderRadius: '10px',
            position: 'absolute',
            top: '95%',
            left: 'calc(50% - 0px)',
            transform: 'translateX(-50%)',
          }}
        >
          <ul style={{ margin: '0px', display: 'flex' }} className="pagi-slick">
            {' '}
            {dots}{' '}
          </ul>
        </div>
      );
    },
    customPaging: dots => {
      return <button className="LiSlick"></button>;
      // use asNarFor to paginator
    },
  };
  const formatSalary = item => {
    let sal = `${
      (item?.salary_start === null || item?.salary_start === 0) &&
      item.salary_unit === 2
        ? '$'
        : ''
    }
               ${
                 item?.salary_start === null || item?.salary_start === 0
                   ? 'Upto '
                   : ''
               }
               ${
                 item?.salary_start === null || item?.salary_start === 0
                   ? ''
                   : formatMoney(Number(item.salary_start))
               }`;
    if (item.salary_end && item.salary_end > 0) {
      let sal_end = `${item.salary_unit === 2 ? '$' : ''}${formatMoney(
        Number(item?.salary_end),
      )}${item.salary_unit === 1 ? ' VNĐ' : ''} ${
        item.salary_unit === 3 ? ' Triệu ' : ''
      }`;
      sal = `${sal} ${
        item?.salary_start === null || item.salary_start === 0
          ? ' '
          : item.salary_unit === 1
          ? ' VNĐ -'
          : item.salary_unit === 3 && item?.salary_start !== null
          ? ' Triệu -'
          : ''
      } ${sal_end}`;
    } else {
      sal = 'Thỏa thuận';
    }
    return sal;
  };
  const trimAddress_detail = str => {
    let countText = str.length;
    const lastSpace = str.lastIndexOf(',');
    if (countText > 0 && lastSpace === -1) {
      return (str = str.slice(0));
    }
    return str.slice(lastSpace + 2);
  };
  const dataSeo = {
    url: `https://tcom.vn`,
    type: 'website',
    description:
      'TCOM là công ty công nghệ hàng đầu tại Việt Nam, tập trung vào các giải pháp Chuyển đổi số, tư vấn hệ thống IT, dịch vụ Offshore, phát triển công nghệ tiên tiến như AIOT, Blockchain',
    domain: 'tcom.vn',
  };

  const dataSeoEN = {
    url: `https://tcom.vn`,
    type: 'website',
    description:
      'TCOM is a leading technology company in Vietnam, specializing in Digital Transformation, IT System Consulting, Offshore Services, and Developing cutting-edge technologies such as AIOT and Blockchain',
    domain: 'tcom.vn',
  };

  return (
    <>
      {trans.seoVN ? <MetaSeo {...dataSeo} /> : <MetaSeo {...dataSeoEN} />}
      <div className="main-content">
        {/* banner */}
        <div className="r-big-banner">
          <div className="container-fluid">
            {/* <img className='w-100 customHeight' src='/assets/images/home/big-banner-bg.webp' alt='' />*/}
            <div className="slider-desktop">
              <Slider
                {...mySettings}
                afterChange={idx => {
                  setDotKey(Number(idx));
                }}
              >
                {dataBaner.map((item, index) => (
                  <img
                    key={index}
                    style={{ width: '100%' }}
                    src={item.imgDesktop}
                  />
                ))}
              </Slider>
            </div>
            <div className="slider-mobile">
              <Slider
                {...mySettings}
                afterChange={idx => {
                  setDotMb(Number(idx));
                }}
              >
                {dataBaner.map((item, index) => (
                  <img
                    key={index}
                    style={{ width: '100%' }}
                    src={item.imgMobile}
                  />
                ))}
              </Slider>
            </div>
            {/* <Slider {...mySettings}></Slider> */}
            <div className="content container">
              <div className="slide-content-desktop">
                <h2 className="title">
                  {trans.slider[dataBaner[dotKey].trans].title}
                </h2>
                <div className="main-content">
                  <p className="desc">
                    {trans.slider[dataBaner[dotKey].trans].desc}
                  </p>
                  {dotKey === 3 && (
                    <div>
                      <img
                        class="img-vi"
                        src="/assets/images/home/img_prize_2023_vi.png"
                        alt="imgPrize"
                      />
                      <img
                        class="img-en"
                        src="/assets/images/home/img_prize_2023_en.png"
                        alt="imgPrize"
                      />
                    </div>
                  )}
                  {dotKey === 4 && (
                    <div>
                      <img
                        class="img-vi"
                        src="/assets/images/home/img_prize_2024_vi.png"
                        alt="imgPrize"
                      />
                      <img
                        class="img-en"
                        src="/assets/images/home/img_prize_2024_en.png"
                        alt="imgPrize"
                      />
                    </div>
                  )}
                  {dotKey === 5 && (
                    <div>
                    <img
                        class="img-vi"
                        src="/assets/images/home/img_prize_2024_vi.png"
                        alt="imgPrize"
                      />
                      <img
                        class="img-en"
                        src="/assets/images/home/img_prize_2024_en.png"
                        alt="imgPrize"
                      />
                    </div>
                  )}
                  <p className="sortContent">
                    {trans.slider[dataBaner[dotKey].trans].content}
                  </p>
                  <a
                    href={dataBaner[dotKey].links}
                    target={dataBaner[dotKey].newpage ? '_blank' : '_self'}
                  >
                    <p className="readMore">
                      {trans.text_button.read_more}
                      <span>
                        <ArrowRightOutlined />
                      </span>
                    </p>
                  </a>
                </div>
              </div>
              <div className="slide-content-mobile">
                <h2 className="title">
                  {trans.slider[dataBaner[dotMb].trans].title}
                </h2>
                <div className="main-content">
                  <p className="desc">
                    {trans.slider[dataBaner[dotMb].trans].desc}
                  </p>
                  {dotMb === 3 && (
                    <div>
                    <img
                      class="img-vi"
                      src="/assets/images/home/img_prize_2023_vi.png"
                      alt="imgPrize"
                    />
                    <img
                      class="img-en"
                      src="/assets/images/home/img_prize_2023_en.png"
                      alt="imgPrize"
                    />
                  </div>
                  )}
                  {dotMb === 4 && (
                    <div>
                      <img
                        class="img-vi"
                        src="/assets/images/home/img_prize_2024_vi.png"
                        alt="imgPrize"
                      />
                      <img
                        class="img-en"
                        src="/assets/images/home/img_prize_2024_en.png"
                        alt="imgPrize"
                      />
                    </div>
                  )}
                  {dotMb === 5 && (
                    <div>
                    <img
                        class="img-vi"
                        src="/assets/images/home/img_prize_2024_vi.png"
                        alt="imgPrize"
                      />
                      <img
                        class="img-en"
                        src="/assets/images/home/img_prize_2024_en.png"
                        alt="imgPrize"
                      />
                    </div>
                  )}
                  <p className="sortContent">
                    {trans.slider[dataBaner[dotMb].trans].content}
                  </p>
                  <a
                    href={dataBaner[dotMb].links}
                    target={dataBaner[dotMb].newpage ? '_blank' : '_self'}
                  >
                    <p className="readMore">
                      {trans.text_button.read_more}
                      <span>
                        <ArrowRightOutlined />
                      </span>
                    </p>
                  </a>
                </div>
              </div>

              {/* <div className='service'>*/}
              {/*  <div className='row'>*/}
              {/*    <div className='col'>*/}
              {/*      <img src='/assets/images/home/service-1.png' alt='Chi phí tối ưu' />*/}
              {/*      <h3>{trans.home.fee_sub1}<br />*/}
              {/*        {trans.home.fee_sub2}</h3>*/}
              {/*    </div>*/}
              {/*    <div className='col'>*/}
              {/*      <img src='/assets/images/home/service-2.png' alt='Chất lượng tốt nhất' />*/}
              {/*      <h3>{trans.home.quality_sub1} <br />*/}
              {/*        {trans.home.quality_sub2}</h3>*/}
              {/*    </div>*/}
              {/*    <div className='col'>*/}
              {/*      <img src='/assets/images/home/service-3.png' alt='Triển khai nhanh nhất' />*/}
              {/*      <h3>{trans.home.implementation_sub1} <br />*/}
              {/*        {trans.home.implementation_sub2}</h3>*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/* </div>*/}
            </div>
            {/* <a href='#our-service' className='scroll-link'>*/}
            {/*  <svg width={24} height={53} viewBox='0 0 24 53' fill='none' xmlns='http://www.w3.org/2000/svg'>*/}
            {/*    <path d='M11.8715 1.73628C6.42606 1.73628 1.99488 6.16747 1.99488 11.6129V24.9894C1.99488 30.4348 6.42606 34.866 11.8715 34.866C17.3169 34.866 21.7481 30.4348 21.7481 24.9894V11.6129C21.7481 6.16747 17.3169 1.73628 11.8715 1.73628ZM11.8715 0.183594C18.1838 0.183594 23.3008 5.30053 23.3008 11.6129V24.9894C23.3008 31.3018 18.1838 36.4187 11.8715 36.4187C5.55913 36.4187 0.442188 31.3018 0.442188 24.9894V11.6129C0.442188 5.30053 5.55913 0.183594 11.8715 0.183594Z' fill='white' />*/}
            {/*    <path d='M11.8008 17.1836C12.6288 17.1836 13.3008 16.6076 13.3008 15.8979V12.4693C13.3008 11.7596 12.6288 11.1836 11.8008 11.1836C10.9728 11.1836 10.3008 11.7596 10.3008 12.4693V15.8979C10.3008 16.6076 10.9728 17.1836 11.8008 17.1836Z' fill='white' />*/}
            {/*    <path d='M5.89015 44.4034C6.61485 45.1281 7.33956 45.8528 8.06426 46.5775C9.21904 47.7322 10.3738 48.887 11.5286 50.0418C11.7944 50.3076 12.0586 50.5718 12.3244 50.8376C11.9655 50.8376 11.6065 50.8376 11.2475 50.8376C11.9722 50.1129 12.6969 49.3882 13.4216 48.6635C14.5764 47.5087 15.7312 46.354 16.886 45.1992C17.1518 44.9333 17.416 44.6692 17.6818 44.4034C17.9646 44.1206 18.481 44.1003 18.7587 44.4034C19.0381 44.7081 19.0601 45.1805 18.7587 45.4802C18.034 46.2049 17.3093 46.9297 16.5846 47.6544C15.4298 48.8091 14.275 49.9639 13.1202 51.1187C12.8544 51.3845 12.5903 51.6487 12.3244 51.9145C12.0332 52.2058 11.5388 52.2058 11.2475 51.9145C10.5228 51.1898 9.79813 50.4651 9.07342 49.7404C7.91864 48.5856 6.76386 47.4308 5.60908 46.2761C5.34324 46.0102 5.0791 45.7461 4.81326 45.4802C4.53049 45.1975 4.51017 44.681 4.81326 44.4034C5.11635 44.124 5.58876 44.102 5.89015 44.4034Z' fill='white' />*/}
            {/*  </svg>*/}
            {/* </a>*/}
            <div className="follow-link">
              <label>Follow Us</label>
              <svg
                width={2}
                height={30}
                viewBox="0 0 2 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line
                  x1="0.941406"
                  y1="-2.18556e-08"
                  x2="0.941408"
                  y2={30}
                  stroke="white"
                />
              </svg>
              <ul>
                <li className="facebook">
                  <a
                    href="https://www.facebook.com/TCOM.Corporation"
                    target="_blank"
                  >
                    <svg
                      width={11}
                      height={20}
                      viewBox="0 0 11 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.55303 3.29509H10.3647V0.139742C10.0522 0.0967442 8.97722 0 7.72533 0C5.11324 0 3.32389 1.643 3.32389 4.66274V7.44186H0.441406V10.9693H3.32389V19.845H6.85794V10.9701H9.62384L10.0629 7.44269H6.85712V5.01251C6.85794 3.99297 7.13247 3.29509 8.55303 3.29509Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </li>
                <li className="linkedin">
                  <a
                    href="https://www.linkedin.com/company/tcom-corporation"
                    target="_blank"
                  >
                    <svg
                      width={17}
                      height={16}
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.739195 15.2647H3.82885V4.96661H0.739195V15.2647ZM12.776 4.6099C11.2765 4.6099 9.93487 5.15749 8.98311 6.36616V4.93274H5.88212V15.2648H8.98311V9.6775C8.98311 8.49669 10.0649 7.34477 11.4199 7.34477C12.775 7.34477 13.1091 8.49669 13.1091 9.64861V15.2638H16.1988V9.41866C16.1987 5.35855 14.2765 4.6099 12.776 4.6099ZM2.26958 3.93748C3.12347 3.93748 3.8165 3.24445 3.8165 2.39056C3.8165 1.53667 3.12347 0.84375 2.26958 0.84375C1.41569 0.84375 0.722656 1.53678 0.722656 2.39067C0.722656 3.24456 1.41569 3.93748 2.26958 3.93748Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </li>
                <li className="youtobe">
                  <a href="https://www.youtube.com/channel/UCmeadb8H2pD_05cFz0qvDVw">
                    <svg
                      width="23"
                      height="16"
                      viewBox="0 0 23 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.2323 2.88581C22.107 2.41607 21.8615 1.98769 21.5202 1.64355C21.1789 1.29941 20.7539 1.05158 20.2876 0.924854C18.5713 0.459961 11.6914 0.459961 11.6914 0.459961C11.6914 0.459961 4.8115 0.459961 3.0952 0.922381C2.62873 1.04869 2.20348 1.29639 1.86213 1.64059C1.52079 1.9848 1.27539 2.41339 1.15056 2.88334C0.691406 4.61433 0.691406 8.22467 0.691406 8.22467C0.691406 8.22467 0.691406 11.835 1.15056 13.5635C1.40346 14.518 2.14989 15.2698 3.0952 15.5245C4.8115 15.9894 11.6914 15.9894 11.6914 15.9894C11.6914 15.9894 18.5713 15.9894 20.2876 15.5245C21.2354 15.2698 21.9794 14.518 22.2323 13.5635C22.6914 11.835 22.6914 8.22467 22.6914 8.22467C22.6914 8.22467 22.6914 4.61433 22.2323 2.88581ZM9.50614 11.5383V4.91107L15.2026 8.19994L9.50614 11.5383Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* end banner */}
        {/* slider */}
        {/* <div className='r-slider'>
        <div className='container-fluid'>
          <Slider ref={slider} {...settings}>
            {list_new.map((item, index) => {
              return (
                <div className='item item-1'>
                  <div className='featured-news'>
                    <img src='/assets/images/home/featured-news-bg.png' className='shape' />
                    <h3>{trans.home.hot_new}</h3>
                  </div>
                  <img className='w-100' src={item?.image} alt='' />
                  <a href='true' className='title'>
                    {item?.title}
                    <svg width={41} height={40} viewBox='0 0 41 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path d='M21.9688 13L28.9688 20L21.9688 27M12.9688 20H28.9688H12.9688Z' stroke='white' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
                      <circle cx='20.9688' cy={20} r='19.5' stroke='white' />
                    </svg>
                  </a>
                </div>
              );
            })
            }


          </Slider>
          <div className='owl-nav'><button onClick={() => slider?.current?.slickPrev()} type='button' role='presentation' className='owl-prev disabled'><svg width={39} height={22} viewBox='0 0 39 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0.929688 18.9L4.02969 22L19.9297 6.1L35.8297 22L38.9297 18.9L19.9297 2.49155e-06L0.929688 18.9Z' fill='#FDFDFD' />
          </svg>
          </button><button onClick={() => slider?.current?.slickNext()} type='button' role='presentation' className='owl-next'><svg width={39} height={22} viewBox='0 0 39 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M38.9297 3.1L35.8297 -6.77527e-07L19.9297 15.9L4.02969 -7.62764e-06L0.929687 3.09999L19.9297 22L38.9297 3.1Z' fill='#FDFDFD' />
          </svg>
            </button></div>
        </div>
      </div> */}
        {/* end slider */}
        {list_new && list_new.length > 0 && (
          <div className="r-featured-news">
            <div className="container">
              <div className="title-left">
                <h3>{trans.home.hot_new}</h3>
                <p className="desc">
                  {trans.home.hot_new_description_sub1}
                  <br /> {trans.home.hot_new_description_sub2}
                </p>
                <Link href="/news">
                  <a className="read-more">
                    {trans.text_button.read_more}
                    <svg
                      width={33}
                      height={33}
                      viewBox="0 0 33 33"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="16.4414" cy="16.1406" r={16} fill="#0063AA" />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.44141 16.3897C5.44141 16.1908 5.52042 16 5.66108 15.8593C5.80173 15.7187 5.99249 15.6397 6.19141 15.6397L23.8809 15.6397L19.1604 10.9207C19.0196 10.7798 18.9405 10.5888 18.9405 10.3897C18.9405 10.1905 19.0196 9.99951 19.1604 9.85868C19.3012 9.71785 19.4922 9.63873 19.6914 9.63873C19.8906 9.63873 20.0816 9.71785 20.2224 9.85868L26.2224 15.8587C26.2923 15.9283 26.3477 16.0111 26.3855 16.1022C26.4233 16.1933 26.4427 16.291 26.4427 16.3897C26.4427 16.4883 26.4233 16.586 26.3855 16.6771C26.3477 16.7682 26.2923 16.851 26.2224 16.9207L20.2224 22.9207C20.0816 23.0615 19.8906 23.1406 19.6914 23.1406C19.4922 23.1406 19.3012 23.0615 19.1604 22.9207C19.0196 22.7798 18.9405 22.5888 18.9405 22.3897C18.9405 22.1905 19.0196 21.9995 19.1604 21.8587L23.8809 17.1397L6.19141 17.1397C5.99249 17.1397 5.80173 17.0607 5.66108 16.92C5.52042 16.7794 5.44141 16.5886 5.44141 16.3897Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </Link>
              </div>
            </div>
            <div className="container-custom">
              <div className="news-slider">
                <Slider ref={slider} {...settings}>
                  {list_new.length &&
                    list_new.map((item, index) => {
                      return (
                        <div className="item">
                          <Link href={`/news/${item.seo_url}`}>
                            <a>
                              <div className="image">
                                <img
                                  href={`/news/${item.seo_url}`}
                                  src={item.image}
                                  alt={item.title}
                                />
                              </div>
                              <div className="content">
                                <h3>{item.title}</h3>
                              </div>
                            </a>
                          </Link>
                        </div>
                      );
                    })}
                </Slider>
              </div>
            </div>
            <div className="container bottom">
              <Link href="/news">
                <a className="read-more">
                  {trans.text_button.read_more}
                  <svg
                    width={33}
                    height={33}
                    viewBox="0 0 33 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="16.4414" cy="16.1406" r={16} fill="#0063AA" />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.44141 16.3897C5.44141 16.1908 5.52042 16 5.66108 15.8593C5.80173 15.7187 5.99249 15.6397 6.19141 15.6397L23.8809 15.6397L19.1604 10.9207C19.0196 10.7798 18.9405 10.5888 18.9405 10.3897C18.9405 10.1905 19.0196 9.99951 19.1604 9.85868C19.3012 9.71785 19.4922 9.63873 19.6914 9.63873C19.8906 9.63873 20.0816 9.71785 20.2224 9.85868L26.2224 15.8587C26.2923 15.9283 26.3477 16.0111 26.3855 16.1022C26.4233 16.1933 26.4427 16.291 26.4427 16.3897C26.4427 16.4883 26.4233 16.586 26.3855 16.6771C26.3477 16.7682 26.2923 16.851 26.2224 16.9207L20.2224 22.9207C20.0816 23.0615 19.8906 23.1406 19.6914 23.1406C19.4922 23.1406 19.3012 23.0615 19.1604 22.9207C19.0196 22.7798 18.9405 22.5888 18.9405 22.3897C18.9405 22.1905 19.0196 21.9995 19.1604 21.8587L23.8809 17.1397L6.19141 17.1397C5.99249 17.1397 5.80173 17.0607 5.66108 16.92C5.52042 16.7794 5.44141 16.5886 5.44141 16.3897Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </Link>
            </div>
          </div>
        )}

        {/* our service */}
        <div className="r-our-service" id="our-service">
          <div className="container">
            <div className="title-left">
              <h3>{trans.home.my_service} </h3>
              <p className="desc">
                {trans.home.my_service_sub1}
                <br /> {trans.home.my_service_sub2}
              </p>
            </div>
            <div className="service">
              <div className="row">
                <div className="col-4">
                  <div className="service-box">
                    <img
                      className="w-100"
                      src="/assets/images/home/img-box2.webp"
                      alt="Offshore & phát triển phần mềm"
                    />
                    <div className="inner">
                      <div className="image">
                        <img src="/assets/images/home/sv-icon-1.png" alt="" />
                      </div>
                      <h3>Offshore {trans.home.service_development}</h3>
                    </div>
                    <div className="hover-content">
                      <ul>
                        <li>Web Development</li>
                        <li>Mobile App Development</li>
                        <li>Video Solutions</li>
                        <li>Realtime Solutions</li>
                        <li>A.I Research & Development</li>
                        <li>Blockchain Development</li>
                        <li>QA & Testing</li>
                        <li>Maintenance & IT Managed</li>
                        <li>UI/UX Design</li>
                      </ul>
                      <h3>Offshore &amp; {trans.home.service_development}</h3>
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="service-box">
                    <div className="image">
                      <img
                        className="w-100"
                        src="/assets/images/home/img-box3.webp"
                        alt="Công nghệ tiên tiến"
                      />
                    </div>
                    <div className="inner">
                      <div className="image">
                        <img src="/assets/images/home/sv-icon-2.png" alt="" />
                      </div>
                      <h3>{trans.home.service_development_tech}</h3>
                    </div>
                    <div className="hover-content">
                      <ul>
                        <li>Artificial Intelligence</li>
                        <li>IoT</li>
                        <li>BigData</li>
                        <li>Blockchain</li>
                        <li>AR/VR/360VR</li>
                      </ul>
                      <h3>{trans.home.service_tech_development}</h3>
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="service-box">
                    <div className="image">
                      <img
                        className="w-100"
                        src="/assets/images/home/img-box1.webp"
                        alt="Tư vấn hệ thống IT & Chuyển đổi số"
                      />
                    </div>
                    <div className="inner">
                      <div className="image">
                        <img src="/assets/images/home/sv-icon-3.png" alt="" />
                      </div>
                      <h3>{trans.home.advise}</h3>
                    </div>
                    <div className="hover-content">
                      <ul>
                        <li>{trans.home.advise_solution}</li>
                        <li>{trans.home.travel_number_conversion}</li>
                        <li>{trans.home.travel_number_education}</li>
                        <li>{trans.home.digital_manufacture}</li>
                        <li>{trans.home.smart_operation_center}</li>
                      </ul>
                      <h3>
                        {trans.home.advise} &amp; {trans.home.digital}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Link href="/service">
              <a className="read-more">
                {trans.text_button.read_more}
                <svg
                  width={33}
                  height={32}
                  viewBox="0 0 33 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="16.4414" cy={16} r={16} fill="#0063AA" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.44141 16.2491C5.44141 16.0501 5.52042 15.8594 5.66108 15.7187C5.80173 15.5781 5.99249 15.4991 6.19141 15.4991L23.8809 15.4991L19.1604 10.7801C19.0196 10.6392 18.9405 10.4482 18.9405 10.2491C18.9405 10.0499 19.0196 9.85888 19.1604 9.71805C19.3012 9.57722 19.4922 9.49811 19.6914 9.49811C19.8906 9.49811 20.0816 9.57722 20.2224 9.71805L26.2224 15.7181C26.2923 15.7877 26.3477 15.8705 26.3855 15.9616C26.4233 16.0527 26.4427 16.1504 26.4427 16.2491C26.4427 16.3477 26.4233 16.4454 26.3855 16.5365C26.3477 16.6276 26.2923 16.7104 26.2224 16.7801L20.2224 22.7801C20.0816 22.9209 19.8906 23 19.6914 23C19.4922 23 19.3012 22.9209 19.1604 22.7801C19.0196 22.6392 18.9405 22.4482 18.9405 22.2491C18.9405 22.0499 19.0196 21.8589 19.1604 21.7181L23.8809 16.9991L6.19141 16.9991C5.99249 16.9991 5.80173 16.92 5.66108 16.7794C5.52042 16.6387 5.44141 16.448 5.44141 16.2491Z"
                    fill="white"
                  />
                </svg>
              </a>
            </Link>
          </div>
        </div>
        {/* end our service */}
        {/* solution */}
        <div className="r-solution">
          <div className="container">
            {/* <div className='label'>
              <svg
                width='62'
                height='485'
                viewBox='0 0 62 485'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M42.8489 42.9824L43.6954 41.4952C46.53 36.5155 47.8821 31.4294 47.8821 26.7768C47.8821 23.1044 47.1878 20.7984 46.2703 19.4538C45.4028 18.1825 44.2796 17.6777 43.0067 17.6777C42.1812 17.6777 41.5515 17.9784 40.9734 18.5963C40.3476 19.265 39.7856 20.3098 39.262 21.7562C38.5668 23.6767 38.0449 25.9624 37.4681 28.4881C37.157 29.8509 36.8298 31.2836 36.4509 32.7665C35.4075 36.8496 33.9929 41.1661 31.4129 44.4682C28.7626 47.8603 24.9356 50.1127 19.3379 50.1127C14.2323 50.1127 9.47518 47.9825 6.02604 43.6955C2.59623 39.4326 0.544585 33.1504 0.544585 24.9439C0.544586 15.8784 3.22518 6.59407 7.31362 1.31318L8.03777 0.377805L20.5219 6.0059L19.4344 7.49802C16.1979 11.9389 13.9047 18.6415 13.9047 25.0236C13.9047 28.7215 14.5277 31.0906 15.3858 32.4861C16.1888 33.7918 17.2082 34.2821 18.3816 34.2821C19.2353 34.2821 19.8835 33.9744 20.4729 33.3547C21.1097 32.6851 21.6807 31.6407 22.2125 30.1959C22.7393 28.7651 23.1846 27.0657 23.6369 25.1712C23.7783 24.5791 23.9208 23.9655 24.0665 23.3383C24.3794 21.9919 24.7068 20.5827 25.0682 19.1882C26.1268 15.1045 27.5601 10.7869 30.1713 7.48471C32.8528 4.09354 36.7186 1.84714 42.3692 1.84714C47.5427 1.84714 52.3219 3.94825 55.7771 8.2101C59.2114 12.4461 61.2422 18.6919 61.2422 26.8565C61.2422 34.0706 59.527 41.5414 56.0699 47.0221L55.3999 48.0844L42.8489 42.9824ZM8.4997 2.23144L18.2222 6.61454C17.9284 7.01767 17.6422 7.43779 17.3645 7.87325C14.4031 12.5166 12.4047 18.9033 12.4047 25.0236C12.4047 32.6741 14.9548 35.7821 18.3816 35.7821C22.7156 35.7821 24.0143 30.1921 25.5333 23.6535C27.6734 14.4417 30.2509 3.34714 42.3692 3.34714C51.8526 3.34714 59.7422 10.9976 59.7422 26.8565C59.7422 33.8695 58.0686 41.0418 54.8012 46.2219L44.999 42.2372C45.2501 41.7961 45.4902 41.3539 45.7194 40.9109C48.1815 36.1508 49.3821 31.2971 49.3821 26.7768C49.3821 19.1263 46.5132 16.1777 43.0067 16.1777C38.7436 16.1777 37.468 21.7553 35.9748 28.2847C33.8671 37.5006 31.3258 48.6127 19.3379 48.6127C10.0139 48.6127 2.04458 40.8825 2.04459 24.9439C2.04459 16.098 4.67445 7.17239 8.4997 2.23144ZM30.8934 116.472C13.3278 116.472 0.544582 102.727 0.544583 84.4501C0.544583 66.0879 13.4126 52.4278 30.8934 52.4278C48.3741 52.4278 61.2422 66.0879 61.2422 84.4501C61.2422 102.727 48.459 116.472 30.8934 116.472ZM30.8934 68.4974C21.1136 68.4974 14.5422 75.326 14.5422 84.4501C14.5422 93.5743 21.1136 100.403 30.8934 100.403C40.6731 100.403 47.2446 93.5743 47.2446 84.4501C47.2446 75.326 40.6731 68.4974 30.8934 68.4974ZM1.50089 123.175L60.2859 123.175L60.2859 139.085L15.0203 139.085L15.0203 167.058L1.50089 167.058L1.50089 123.175ZM13.5203 165.558L3.00089 165.558L3.00089 124.675L58.7859 124.675L58.7859 137.585L13.5203 137.585L13.5203 165.558ZM60.2859 223.618L27.5463 223.618C19.0544 223.618 12.2539 221.18 7.57728 216.493C2.90162 211.806 0.544577 205.067 0.544578 196.855C0.544578 188.643 2.90163 181.904 7.57728 177.217C12.2539 172.53 19.0544 170.092 27.5463 170.092L60.2859 170.092L60.2859 186.003L28.0244 186.003C22.909 186.003 19.5861 187.123 17.55 188.916C15.5511 190.676 14.5422 193.309 14.5422 196.935C14.5422 200.604 15.5531 203.233 17.5474 204.981C19.5814 206.764 22.9031 207.867 28.0244 207.867L60.2859 207.867L60.2859 223.618ZM27.5463 171.592C11.1296 171.592 2.04458 180.996 2.04458 196.855C2.04458 212.714 11.1296 222.118 27.5463 222.118L58.7859 222.118L58.7859 209.367L28.0244 209.367C17.4253 209.367 13.0422 204.824 13.0422 196.935C13.0422 189.125 17.4253 184.503 28.0244 184.503L58.7859 184.503L58.7859 171.592L27.5463 171.592ZM1.50089 243.997L46.7664 243.997L46.7664 226.146L60.2859 226.146L60.2859 277.758L46.7664 277.758L46.7664 259.907L1.50089 259.907L1.50089 243.997ZM3.00089 258.407L3.00089 245.497L48.2664 245.497L48.2664 227.646L58.7859 227.646L58.7859 276.258L48.2664 276.258L48.2664 258.407L3.00089 258.407ZM1.50089 281.705L60.2859 281.705L60.2859 297.615L1.50089 297.615L1.50089 281.705ZM3.00089 296.115L3.00089 283.205L58.7859 283.205L58.7859 296.115L3.00089 296.115ZM30.8934 368.392C13.3277 368.392 0.544571 354.647 0.544571 336.37C0.544572 318.008 13.4126 304.347 30.8934 304.347C48.3741 304.347 61.2422 318.008 61.2422 336.37C61.2422 354.647 48.459 368.392 30.8934 368.392ZM30.8934 320.417C21.1136 320.417 14.5422 327.246 14.5422 336.37C14.5422 345.494 21.1136 352.322 30.8934 352.322C40.6731 352.322 47.2446 345.494 47.2446 336.37C47.2446 327.246 40.6731 320.417 30.8934 320.417ZM60.2859 413.507L60.2859 429.257L1.50088 429.257L1.50088 416.449L32.6801 390.846L1.50088 390.846L1.50088 375.095L60.2859 375.095L60.2859 387.984L29.116 413.507L60.2859 413.507ZM24.9164 415.007L58.7859 387.273L58.7859 376.595L3.00088 376.595L3.00088 389.346L36.8703 389.346L3.00088 417.158L3.00088 427.757L58.7859 427.757L58.7859 415.007L24.9164 415.007ZM42.8488 477.324L43.6954 475.837C46.53 470.857 47.8821 465.771 47.8821 461.118C47.8821 457.446 47.1878 455.14 46.2703 453.795C45.4028 452.524 44.2796 452.019 43.0067 452.019C42.1811 452.019 41.5515 452.32 40.9734 452.938C40.3476 453.606 39.7856 454.651 39.262 456.098C38.5668 458.018 38.0448 460.304 37.4681 462.83C37.1569 464.192 36.8298 465.625 36.4509 467.108C35.4075 471.191 33.9929 475.508 31.4129 478.81C28.7626 482.202 24.9355 484.454 19.3379 484.454C14.2323 484.454 9.47516 482.324 6.02602 478.037C2.59621 473.774 0.544566 467.492 0.544566 459.285C0.544567 450.22 3.22516 440.935 7.3136 435.655L8.03775 434.719L20.5219 440.347L19.4344 441.839C16.1978 446.28 13.9046 452.983 13.9046 459.365C13.9046 463.063 14.5277 465.432 15.3858 466.827C16.1888 468.133 17.2081 468.624 18.3816 468.624C19.2353 468.624 19.8835 468.316 20.4729 467.696C21.1097 467.027 21.6806 465.982 22.2125 464.537C22.7392 463.107 23.1846 461.407 23.6369 459.513C23.7782 458.921 23.9208 458.307 24.0665 457.68C24.3793 456.333 24.7068 454.924 25.0682 453.53C26.1268 449.446 27.5601 445.128 30.1713 441.826C32.8528 438.435 36.7186 436.189 42.3691 436.189C47.5427 436.189 52.3219 438.29 55.7771 442.552C59.2114 446.787 61.2422 453.033 61.2422 461.198C61.2422 468.412 59.527 475.883 56.0699 481.364L55.3998 482.426L42.8488 477.324ZM8.49968 436.573L18.2222 440.956C17.9284 441.359 17.6422 441.779 17.3645 442.215C14.403 446.858 12.4046 453.245 12.4046 459.365C12.4046 467.016 14.9548 470.124 18.3816 470.124C22.7156 470.124 24.0142 464.534 25.5333 457.995C27.6734 448.783 30.2508 437.689 42.3691 437.689C51.8526 437.689 59.7422 445.339 59.7422 461.198C59.7422 468.211 58.0686 475.383 54.8012 480.563L44.999 476.579C45.2501 476.138 45.4902 475.695 45.7193 475.252C48.1815 470.492 49.3821 465.638 49.3821 461.118C49.3821 453.468 46.5132 450.519 43.0067 450.519C38.7436 450.519 37.468 456.097 35.9747 462.626C33.8671 471.842 31.3258 482.954 19.3379 482.954C10.0138 482.954 2.04457 475.224 2.04457 459.285C2.04457 450.439 4.67443 441.514 8.49968 436.573ZM30.8934 114.972C14.2376 114.972 2.04458 101.983 2.04458 84.4501C2.04458 66.838 14.3173 53.9278 30.8934 53.9278C47.4695 53.9278 59.7422 66.838 59.7422 84.4501C59.7422 101.983 47.5492 114.972 30.8934 114.972ZM30.8934 66.9974C20.2942 66.9974 13.0422 74.4885 13.0422 84.4501C13.0422 94.4117 20.2942 101.903 30.8934 101.903C41.4925 101.903 48.7446 94.4118 48.7446 84.4501C48.7446 74.4885 41.4925 66.9974 30.8934 66.9974ZM30.8934 366.892C14.2376 366.892 2.04457 353.902 2.04457 336.37C2.04457 318.758 14.3173 305.847 30.8934 305.847C47.4695 305.847 59.7422 318.758 59.7422 336.37C59.7422 353.902 47.5492 366.892 30.8934 366.892ZM30.8934 318.917C20.2942 318.917 13.0422 326.408 13.0422 336.37C13.0422 346.331 20.2942 353.822 30.8934 353.822C41.4925 353.822 48.7446 346.331 48.7446 336.37C48.7446 326.408 41.4925 318.917 30.8934 318.917Z'
                  fill='#DEDEDE'
                />
              </svg>
            </div> */}
            <div className="title-left">
              <h3>{trans.home.solutions}</h3>
              <p className="desc">
                {' '}
                {trans.home.solution_sub1}
                <br />
                {trans.home.solution_sub2}
              </p>
            </div>
            <div className="row">
              <div className="col-12 col-lg-6">
                <div className="box livestream">
                  <img
                    src="/assets/images/home/solution-1.png"
                    alt="livestream"
                  />
                  <div className="inner">
                    <div className="image">
                      <img
                        src="/assets/images/home/livestream.png"
                        alt="livestream"
                      />
                    </div>
                    <h5>{trans.home.solution_livestream}</h5>
                    <p>{trans.home.solution_livestream_description}</p>
                    <Link href="/solution">
                      <a className="btn-readmore">
                        {' '}
                        {trans.text_button.read_more}
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="box travel">
                  <img src="/assets/images/home/solution-2.png" alt="travel" />
                  <div className="inner">
                    <div className="image">
                      <img src="/assets/images/home/travel.png" alt="travel" />
                    </div>
                    <h5>{trans.home.solution_service}</h5>
                    <p>{trans.home.solution_service_description}</p>
                    <Link href="/solution">
                      <a className="btn-readmore">
                        {' '}
                        {trans.text_button.read_more}
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="box digital">
                  <img src="/assets/images/home/solution-3.png" alt="digital" />
                  <div className="inner">
                    <div className="image">
                      <img src="/assets/images/home/360.png" alt="digital" />
                    </div>
                    <h5>{trans.home.solution_number}</h5>
                    <p>{trans.home.solution_number_description}</p>
                    <Link href="/solution">
                      <a className="btn-readmore">
                        {' '}
                        {trans.text_button.read_more}
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="box school">
                  <img src="/assets/images/home/solution-4.png" alt="school" />
                  <div className="inner">
                    <div className="image">
                      <img src="/assets/images/home/school.png" alt="school" />
                    </div>
                    <h5>{trans.home.solution_school}</h5>
                    <p>{trans.home.solution_school_description}</p>
                    <Link href="/solution">
                      <a className="btn-readmore">
                        {' '}
                        {trans.text_button.read_more}
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <Link href="/solution">
              <a className="read-more">
                {trans.text_button.read_more}
                <svg
                  width={33}
                  height={33}
                  viewBox="0 0 33 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="16.4414" cy="16.1404" r={16} fill="white" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.44141 16.3894C5.44141 16.1905 5.52042 15.9998 5.66108 15.8591C5.80173 15.7185 5.99249 15.6394 6.19141 15.6394L23.8809 15.6394L19.1604 10.9204C19.0196 10.7796 18.9405 10.5886 18.9405 10.3894C18.9405 10.1903 19.0196 9.99926 19.1604 9.85843C19.3012 9.7176 19.4922 9.63849 19.6914 9.63849C19.8906 9.63849 20.0816 9.7176 20.2224 9.85843L26.2224 15.8584C26.2923 15.9281 26.3477 16.0109 26.3855 16.102C26.4233 16.1931 26.4427 16.2908 26.4427 16.3894C26.4427 16.4881 26.4233 16.5858 26.3855 16.6769C26.3477 16.768 26.2923 16.8508 26.2224 16.9204L20.2224 22.9204C20.0816 23.0613 19.8906 23.1404 19.6914 23.1404C19.4922 23.1404 19.3012 23.0613 19.1604 22.9204C19.0196 22.7796 18.9405 22.5886 18.9405 22.3894C18.9405 22.1903 19.0196 21.9993 19.1604 21.8584L23.8809 17.1394L6.19141 17.1394C5.99249 17.1394 5.80173 17.0604 5.66108 16.9198C5.52042 16.7791 5.44141 16.5883 5.44141 16.3894Z"
                    fill="#061A35"
                  />
                </svg>
              </a>
            </Link>
          </div>
        </div>
        {/* end solution */}
        {/* fields */}
        <div className="r-fields">
          <div className="container">
            {/* <div className="label">
              <svg
                width="61"
                height="352"
                viewBox="0 0 61 352"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M59.9773 0.534668L59.9773 27.377C59.9773 33.6251 58.7713 39.2003 56.314 44.063C53.9126 48.9735 50.4849 52.8053 46.0332 55.5117C41.5702 58.2783 36.4031 59.6384 30.5848 59.6384C24.7664 59.6384 19.5992 58.2783 15.1362 55.5116C10.6849 52.8054 7.23179 48.9747 4.77746 44.0661L4.77437 44.0599C2.37131 39.1979 1.19231 33.6241 1.19231 27.377L1.19231 0.534665L59.9773 0.534668ZM15.9213 54.2335C20.1185 56.8368 25.0063 58.1384 30.5848 58.1384C36.1633 58.1384 41.0511 56.8368 45.2483 54.2335C49.4454 51.6833 52.6863 48.0706 54.9708 43.3952C57.3085 38.7731 58.4773 33.4336 58.4773 27.377L58.4773 2.03467L2.69231 2.03467L2.69231 27.377C2.69231 33.4336 3.83457 38.7731 6.11909 43.3952C8.45675 48.0706 11.7242 51.6833 15.9213 54.2335ZM42.0811 39.0231L42.0896 39.0141C44.9015 36.0592 46.3781 32.0251 46.3781 26.7394L46.3781 16.4449L14.7914 16.4449L14.7914 26.7394C14.7914 32.0316 16.2454 36.0689 19.0085 39.0228M13.2914 26.7394C13.2914 32.3179 14.8322 36.7542 17.9136 40.0481C21.0482 43.3952 25.2719 45.0688 30.5848 45.0688C35.8976 45.0688 40.0948 43.3952 43.1763 40.0481C46.3108 36.7542 47.8781 32.3179 47.8781 26.7394L47.8781 14.9449L13.2914 14.9449L13.2914 26.7394ZM42.0811 39.0231L42.0727 39.0322ZM19.0085 39.0228C21.8137 42.0179 25.6152 43.5688 30.5848 43.5688C35.5553 43.5688 39.3235 42.0184 42.0727 39.0322M4.15844 78.4843L4.16181 78.478C6.78115 73.6295 10.3909 69.7913 14.981 66.9924L14.9901 66.9868L14.9994 66.9814C19.6559 64.2323 24.8634 62.8681 30.5848 62.8681C36.306 62.8681 41.4901 64.2323 46.0974 66.9855L46.102 66.9882C50.7463 69.786 54.386 73.625 57.0078 78.4781L57.0112 78.4843C59.6348 83.3968 60.9336 88.8763 60.9336 94.8905C60.9336 100.904 59.6349 106.36 57.0078 111.223C54.3867 116.075 50.7485 119.913 46.1061 122.711C41.4979 125.52 36.3106 126.913 30.5848 126.913C24.8577 126.913 19.6461 125.519 14.9879 122.713L14.981 122.709C10.3909 119.91 6.78115 116.072 4.16182 111.223C1.53469 106.36 0.235988 100.904 0.235988 94.8905C0.235989 88.8763 1.53475 83.3968 4.15844 78.4843ZM22.0721 108.723L22.0819 108.728C24.5417 110.127 27.3627 110.843 30.5848 110.843C33.8069 110.843 36.6279 110.127 39.0877 108.728L39.0974 108.723L39.1073 108.717C41.5745 107.363 43.468 105.491 44.8161 103.083L44.8217 103.073L44.8273 103.064C46.2258 100.652 46.936 97.94 46.936 94.8905C46.936 91.841 46.2258 89.1287 44.8273 86.7175L44.8217 86.7077L44.8161 86.6978C43.4672 84.2889 41.5706 82.3871 39.0975 80.9787C36.6364 79.6298 33.8116 78.9378 30.5848 78.9378C27.358 78.9378 24.5332 79.6298 22.0721 80.9787C19.5979 82.3877 17.6713 84.2924 16.2682 86.7076C14.9198 89.1196 14.2336 91.8357 14.2336 94.8905C14.2336 97.9454 14.9199 100.662 16.2684 103.074C17.6706 105.487 19.594 107.362 22.0623 108.717L22.0721 108.723ZM21.3404 79.6692C24.05 78.1816 27.1314 77.4378 30.5848 77.4378C34.0381 77.4378 37.1196 78.1816 39.8292 79.6692C42.5387 81.2099 44.6373 83.3085 46.1249 85.9649C47.6656 88.6213 48.436 91.5965 48.436 94.8905C48.436 98.1845 47.6656 101.16 46.1249 103.816C44.6373 106.473 42.5387 108.545 39.8292 110.032C37.1196 111.573 34.0381 112.343 30.5848 112.343C27.1314 112.343 24.05 111.573 21.3404 110.032C18.6309 108.545 16.5057 106.473 14.965 103.816C13.4774 101.16 12.7336 98.1845 12.7336 94.8905C12.7336 91.5965 13.4774 88.6213 14.965 85.9649C16.5057 83.3085 18.6309 81.2099 21.3404 79.6692ZM1.1923 184.383L30.7334 184.313L7.08957 170.236L7.08957 162.723L30.0939 148.729L1.1923 148.729L1.1923 133.615L59.9773 133.615L59.9773 146.642L26.7346 166.664L59.9773 186.38L59.9773 199.329L1.1923 199.497L1.1923 184.383ZM58.4773 187.235L58.4773 197.834L2.6923 197.993L2.6923 185.88L36.1633 185.8L8.58957 169.383L8.58957 163.566L35.446 147.229L2.6923 147.229L2.6923 135.115L58.4773 135.115L58.4773 145.794L23.8109 166.674L58.4773 187.235ZM58.4773 228.761L58.4773 241.512L2.69229 266.455L2.6923 252.908L14.6462 247.967L14.6462 222.067L2.6923 217.126L2.6923 203.897L58.4773 228.761ZM13.1462 223.07L1.1923 218.129L1.1923 201.586L59.9773 227.787L59.9773 242.484L1.19229 268.769L1.1923 251.905L13.1462 246.964L13.1462 223.07ZM45.8061 235.056L24.4484 226.211L24.4484 243.902L45.8061 235.056ZM41.8861 235.056L25.9484 228.455L25.9484 241.658L41.8861 235.056ZM59.9773 270.743L59.9773 286.653L1.19229 286.653L1.19229 270.743L59.9773 270.743ZM59.9773 351.055L1.19229 351.055L1.19229 338.247L32.3715 312.643L1.19229 312.643L1.19229 296.892L59.9773 296.892L59.9773 309.782L28.8074 335.304L59.9773 335.304L59.9773 351.055ZM58.4773 336.804L58.4773 349.555L2.69229 349.555L2.69229 338.956L36.5617 311.143L2.69229 311.143L2.69229 298.392L58.4773 298.392L58.4773 309.071L24.6078 336.804L58.4773 336.804ZM5.48155 79.191C2.98451 83.8663 1.73599 89.0995 1.73599 94.8905C1.73599 100.682 2.98451 105.888 5.48155 110.51C7.97859 115.132 11.4054 118.772 15.7619 121.428C20.1716 124.085 25.1125 125.413 30.5848 125.413C36.057 125.413 40.9714 124.085 45.328 121.428C49.7376 118.772 53.191 115.132 55.688 110.51C58.1851 105.888 59.4336 100.682 59.4336 94.8905C59.4336 89.0995 58.1851 83.8663 55.688 79.191C53.191 74.5688 49.7376 70.9295 45.328 68.2731C40.9714 65.6698 36.057 64.3681 30.5848 64.3681C25.1125 64.3681 20.1716 65.6698 15.7619 68.2731C11.4054 70.9295 7.9786 74.5688 5.48155 79.191ZM58.4773 272.243L2.69229 272.243L2.69229 285.153L58.4773 285.153L58.4773 272.243Z"
                  fill="#E2E2E2"
                />
              </svg>
            </div> */}
            <div className="row">
              <div className="col-12 col-md-4 col-left">
                <div className="title-left">
                  <h3>{trans.home.field}</h3>
                  <p className="desc">{trans.home.field_description}</p>
                  <img src="/assets/images/home/fields-img-1.png" alt="" />
                </div>
              </div>
              <div className="col-12 col-md-8 col-right">
                <div className="row">
                  <div className="col-6 col-md-4">
                    <div className="field-item">
                      <div className="icon">
                        <svg
                          width={57}
                          height={57}
                          viewBox="0 0 57 57"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_400_526)">
                            <path
                              d="M50.8149 31.5454C51.5364 29.2627 51.9026 26.8911 51.9026 24.4748C51.9026 18.4904 49.6767 12.849 45.6191 8.49306C45.604 8.47523 45.5878 8.45882 45.5717 8.44209C45.3944 8.25287 45.215 8.06518 45.0309 7.881C40.5994 3.44847 34.7072 1.00732 28.4398 1.00732C21.7426 1.00732 15.6924 3.82964 11.414 8.34715C11.3325 8.41245 11.2593 8.49011 11.1977 8.57958C7.34045 12.7633 4.98025 18.3482 4.98025 24.4748C4.98025 26.8949 5.34545 29.2667 6.06514 31.5458C2.88277 32.0488 0.441406 34.8111 0.441406 38.1336V50.009C0.441406 53.687 3.43281 56.6792 7.10956 56.6792H23.5227C24.1267 56.6792 24.6165 56.1894 24.6165 55.5855C24.6165 54.9815 24.1267 54.4917 23.5227 54.4917H7.10956C4.63889 54.4917 2.62891 52.4807 2.62891 50.0091V38.1336C2.62891 35.6618 4.63889 33.651 7.10956 33.651H17.6229C17.6245 33.651 17.6262 33.6512 17.6278 33.6512C17.6292 33.6512 17.6307 33.651 17.6321 33.651H39.2477C39.2491 33.651 39.2505 33.6512 39.2519 33.6512C39.2536 33.6512 39.2552 33.651 39.2568 33.651H49.2948C49.2971 33.651 49.2995 33.6513 49.3018 33.6513C49.3047 33.6513 49.3075 33.651 49.3104 33.651H49.7734C52.244 33.651 54.254 35.6619 54.254 38.1336V50.009C54.254 52.4807 52.244 54.4916 49.7734 54.4916H33.3476C32.7437 54.4916 32.2539 54.9814 32.2539 55.5853C32.2539 56.1893 32.7437 56.6791 33.3476 56.6791H49.7733C53.45 56.6791 56.4414 53.6869 56.4414 50.009V38.1336C56.4414 34.8101 53.9986 32.0472 50.8149 31.5454ZM40.5627 31.4635C40.879 29.5584 41.0635 27.5844 41.1124 25.5686H49.6865C49.5844 27.5851 49.199 29.5607 48.5373 31.4635H40.5627ZM29.5335 31.4635V25.5686H38.9235C38.8721 27.5906 38.6777 29.5658 38.3435 31.4635H29.5335ZM18.5372 31.4635C18.2026 29.5567 18.008 27.5816 17.9564 25.5686H27.3461V31.4635H18.5372ZM8.34255 31.4635C7.68236 29.5638 7.29791 27.5882 7.19619 25.5686H15.7675C15.8165 27.5763 16.0013 29.5502 16.3182 31.4635H8.34255ZM12.3494 10.5704C13.9046 11.3573 15.63 12.0162 17.4829 12.5385C16.4529 15.8041 15.8613 19.509 15.7675 23.3812H7.19553C7.44381 18.4982 9.3453 14.0447 12.3494 10.5704ZM49.6873 23.3812H41.1122C41.0183 19.5091 40.4267 15.8043 39.3967 12.5387C41.2502 12.0164 42.9765 11.3574 44.5327 10.5705C47.5373 14.0448 49.439 18.4984 49.6873 23.3812ZM27.346 11.7704C24.9362 11.7072 22.5788 11.4361 20.3713 10.9793C20.6328 10.3465 20.9135 9.73775 21.214 9.15762C22.9321 5.84148 25.0772 3.8117 27.3459 3.31557V11.7704H27.346ZM27.346 13.9586V23.3811H17.9553C18.0491 19.6759 18.62 16.1488 19.6093 13.0657C22.0407 13.5899 24.6471 13.894 27.346 13.9586ZM29.5335 13.9586C32.2321 13.894 34.8385 13.5899 37.2704 13.0657C38.2597 16.1488 38.8304 19.6759 38.9242 23.3811H29.5335V13.9586ZM29.5335 11.7704V3.31546C31.8023 3.81159 33.9475 5.84137 35.6655 9.15751C35.9661 9.73764 36.2467 10.3464 36.5083 10.9792C34.3004 11.436 31.943 11.7072 29.5335 11.7704ZM38.6585 10.4621C38.3372 9.65582 37.9872 8.88331 37.6079 8.15126C36.7993 6.59048 35.8906 5.26814 34.9058 4.20075C37.9311 5.16828 40.6637 6.79567 42.9346 8.91317C41.6324 9.51954 40.1945 10.0387 38.6585 10.4621ZM19.2717 8.15126C18.8925 8.88331 18.5424 9.65572 18.2213 10.462C16.6858 10.0386 15.2486 9.51943 13.9473 8.91317C16.2173 6.796 18.9491 5.16872 21.9734 4.20118C20.9888 5.26857 20.0802 6.59081 19.2717 8.15126Z"
                              fill="#EB2725"
                            />
                            <path
                              d="M13.6785 39.2886V45.5238L8.6155 38.6406C8.33528 38.2598 7.84244 38.102 7.39334 38.2495C6.94436 38.3968 6.64062 38.816 6.64062 39.2886V48.8566C6.64062 49.4606 7.13041 49.9504 7.73438 49.9504C8.33834 49.9504 8.82813 49.4606 8.82813 48.8566V42.6215L13.8911 49.5047C14.1012 49.7903 14.4311 49.9505 14.7723 49.9505C14.8861 49.9505 15.001 49.9327 15.1133 49.8958C15.5622 49.7485 15.866 49.3293 15.866 48.8566V39.2886C15.866 38.6847 15.3762 38.1949 14.7722 38.1949C14.1683 38.1949 13.6785 38.6847 13.6785 39.2886Z"
                              fill="#EB2725"
                            />
                            <path
                              d="M24.2437 40.3823C24.8477 40.3823 25.3374 39.8925 25.3374 39.2886C25.3374 38.6846 24.8477 38.1948 24.2437 38.1948H19.8164C19.2124 38.1948 18.7227 38.6846 18.7227 39.2886V48.8566C18.7227 49.4606 19.2124 49.9503 19.8164 49.9503H24.2437C24.8477 49.9503 25.3374 49.4606 25.3374 48.8566C25.3374 48.2526 24.8477 47.7628 24.2437 47.7628H20.9102V45.1678H24.2437C24.8477 45.1678 25.3374 44.678 25.3374 44.0741C25.3374 43.4701 24.8477 42.9803 24.2437 42.9803H20.9102V40.3823H24.2437Z"
                              fill="#EB2725"
                            />
                            <path
                              d="M36.257 49.5992C36.4682 49.8276 36.7609 49.9503 37.0601 49.9503C37.194 49.9503 37.3292 49.9257 37.4588 49.8751C37.8779 49.7109 38.1537 49.3068 38.1537 48.8566V39.2886C38.1537 38.6846 37.6639 38.1948 37.06 38.1948C36.456 38.1948 35.9662 38.6846 35.9662 39.2886V46.0633L33.9814 43.9175C33.9702 43.9055 33.9599 43.8957 33.9498 43.8866C33.9401 43.877 33.9313 43.8667 33.9211 43.8573C33.4778 43.4471 32.7858 43.4739 32.3756 43.9175L30.3906 46.0634V39.2886C30.3906 38.6846 29.9008 38.1948 29.2969 38.1948C28.6929 38.1948 28.2031 38.6846 28.2031 39.2886V48.8566C28.2031 49.3067 28.4789 49.7109 28.8981 49.8751C29.0278 49.9258 29.1628 49.9503 29.2968 49.9503C29.5958 49.9503 29.8887 49.8276 30.0999 49.5992L33.1786 46.271L36.257 49.5992Z"
                              fill="#EB2725"
                            />
                            <path
                              d="M46.7567 47.7627H42.1094C41.5054 47.7627 41.0156 48.2525 41.0156 48.8565C41.0156 49.4605 41.5054 49.9502 42.1094 49.9502H46.7567C48.6779 49.9502 50.2409 48.3868 50.2409 46.4652C50.2409 44.5436 48.6779 42.9803 46.7567 42.9803H44.4997C43.7848 42.9803 43.2031 42.3983 43.2031 41.6829C43.2031 40.9657 43.7848 40.3823 44.4997 40.3823H49.1471C49.7511 40.3823 50.2409 39.8925 50.2409 39.2886C50.2409 38.6846 49.7511 38.1948 49.1471 38.1948H44.4997C42.5786 38.1948 41.0156 39.7595 41.0156 41.6829C41.0156 43.6045 42.5786 45.1678 44.4997 45.1678H46.7567C47.4717 45.1678 48.0534 45.7498 48.0534 46.4652C48.0534 47.1806 47.4717 47.7627 46.7567 47.7627Z"
                              fill="#EB2725"
                            />
                            <path
                              d="M28.4375 54.4937C27.8335 54.4937 27.3438 54.9834 27.3438 55.5874C27.3438 56.1914 27.8335 56.6812 28.4375 56.6812H28.4406C29.0445 56.6812 29.5328 56.1914 29.5328 55.5874C29.5328 54.9834 29.0415 54.4937 28.4375 54.4937Z"
                              fill="#EB2725"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_400_526">
                              <rect
                                width={56}
                                height={56}
                                fill="white"
                                transform="translate(0.441406 0.843262)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <h3>{trans.home.news}</h3>
                      <svg
                        width={114}
                        height={3}
                        viewBox="0 0 114 3"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.441406"
                          y="0.140137"
                          width="113.543"
                          height="2.31721"
                          fill="#EB2725"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="col-6 col-md-4">
                    <div className="field-item">
                      <div className="icon">
                        <svg
                          width={57}
                          height={57}
                          viewBox="0 0 57 57"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_400_564)">
                            <path
                              d="M53.4336 7.95542H38.6775C38.662 7.95542 38.6469 7.95684 38.6315 7.95771C38.0908 7.45011 37.5098 6.97881 36.8902 6.55006C36.5174 6.29248 36.0067 6.38556 35.7487 6.75787C35.4911 7.1304 35.584 7.64151 35.9566 7.89931C39.5798 10.406 41.7428 14.5291 41.7428 18.9285C41.7428 26.3182 35.7308 32.3302 28.3411 32.3302C20.9515 32.3302 14.9395 26.3182 14.9395 18.9285C14.9395 11.5389 20.9515 5.52686 28.3411 5.52686C29.808 5.52686 31.2497 5.76212 32.626 6.2262C33.0554 6.37134 33.5208 6.14034 33.6654 5.71104C33.8102 5.28175 33.5795 4.81636 33.1502 4.67165C31.6046 4.15048 29.9867 3.88623 28.3411 3.88623C20.0468 3.88623 13.2989 10.6341 13.2989 18.9285C13.2989 27.2228 20.0468 33.9708 28.3411 33.9708C36.6355 33.9708 43.3835 27.2228 43.3835 18.9285C43.3835 15.5 42.2123 12.2218 40.1359 9.59604H53.4336C54.1875 9.59604 54.8008 10.2093 54.8008 10.9632V36.7816H48.3124C47.8593 36.7816 47.4921 37.1488 47.4921 37.6019C47.4921 38.0551 47.8593 38.4223 48.3124 38.4223H54.8008V42.7303C54.8008 43.4842 54.1875 44.0975 53.4336 44.0975H3.44922C2.6953 44.0975 2.08203 43.4842 2.08203 42.7303V38.4223H44.1811C44.6343 38.4223 45.0014 38.0551 45.0014 37.6019C45.0014 37.1488 44.6343 36.7816 44.1811 36.7816H2.08203V10.9632C2.08203 10.2093 2.6953 9.59604 3.44922 9.59604H13.2315C13.6846 9.59604 14.0518 9.22887 14.0518 8.77573C14.0518 8.32259 13.6846 7.95542 13.2315 7.95542H3.44922C1.79066 7.95542 0.441406 9.30478 0.441406 10.9632V42.7302C0.441406 44.3887 1.79066 45.738 3.44922 45.738H21.43V52.1489H18.9536C18.5004 52.1489 18.1332 52.5161 18.1332 52.9692C18.1332 53.4224 18.5004 53.7896 18.9536 53.7896H37.7287C38.1818 53.7896 38.549 53.4224 38.549 52.9692C38.549 52.5161 38.1818 52.1489 37.7287 52.1489H35.2522V45.738H53.4336C55.0922 45.738 56.4414 44.3887 56.4414 42.7302V10.9632C56.4414 9.30478 55.0922 7.95542 53.4336 7.95542ZM33.6117 52.149H23.0707V45.7381H33.6117V52.149Z"
                              fill="#FDE002"
                            />
                            <path
                              d="M22.4956 12.3776C22.3206 11.4502 21.5086 10.7769 20.5647 10.7769H19.6875C19.2344 10.7769 18.8672 11.144 18.8672 11.5972C18.8672 12.0503 19.2344 12.4175 19.6875 12.4175H20.5647C20.7205 12.4175 20.8545 12.5286 20.8834 12.6818L23.3111 25.5404C23.3843 25.9279 23.7229 26.2085 24.1172 26.2085H24.6706C24.4284 26.4793 24.2797 26.8357 24.2797 27.2277C24.2797 28.0732 24.9652 28.7587 25.8106 28.7587C26.6561 28.7587 27.3416 28.0732 27.3416 27.2277C27.3416 26.8357 27.193 26.4793 26.9507 26.2085H30.3253C30.083 26.4793 29.9344 26.8357 29.9344 27.2277C29.9344 28.0732 30.6199 28.7587 31.4653 28.7587C32.3108 28.7587 32.9963 28.0732 32.9963 27.2277C32.9963 26.8357 32.8477 26.4793 32.6053 26.2085H33.3435C33.7967 26.2085 34.1638 25.8413 34.1638 25.3882C34.1638 24.935 33.7967 24.5678 33.3435 24.5678H24.7968L24.4622 22.7952H33.6298C34.0239 22.7952 34.3622 22.515 34.4357 22.1276L35.8917 14.4465C35.8926 14.4416 35.8936 14.4367 35.8944 14.4317C35.9433 14.1446 35.8637 13.8524 35.6759 13.6298C35.4881 13.4072 35.2134 13.2796 34.9221 13.2796H22.6659L22.4956 12.3776ZM23.7191 18.8577H25.9571L26.125 21.1546H24.1528L23.7191 18.8577ZM29.577 18.8577L29.4091 21.1546H27.77L27.6021 18.8577H29.577ZM27.4822 17.2171L27.3143 14.9203H29.8647L29.6968 17.2171H27.4822ZM31.0542 21.1546L31.2221 18.8577H33.386L32.9505 21.1546H31.0542ZM33.697 17.2171H31.3421L31.51 14.9203H34.1324L33.697 17.2171ZM25.6692 14.9203L25.8371 17.2171H23.4093L22.9756 14.9203H25.6692Z"
                              fill="#FDE002"
                            />
                            <path
                              d="M5.78516 30.9253H10.6371C11.0903 30.9253 11.4575 30.5581 11.4575 30.105C11.4575 29.6518 11.0903 29.2847 10.6371 29.2847H5.78516C5.33202 29.2847 4.96484 29.6518 4.96484 30.105C4.96484 30.5581 5.33202 30.9253 5.78516 30.9253Z"
                              fill="#FDE002"
                            />
                            <path
                              d="M5.78516 34.6284H14.8386C15.2917 34.6284 15.6589 34.2612 15.6589 33.8081C15.6589 33.355 15.2917 32.9878 14.8386 32.9878H5.78516C5.33202 32.9878 4.96484 33.355 4.96484 33.8081C4.96484 34.2612 5.33202 34.6284 5.78516 34.6284Z"
                              fill="#FDE002"
                            />
                            <path
                              d="M49.1039 12.6929C48.6507 12.6929 48.2835 13.06 48.2835 13.5132V15.5663H46.2305C45.7773 15.5663 45.4102 15.9334 45.4102 16.3866C45.4102 16.8397 45.7773 17.2069 46.2305 17.2069H48.2835V19.26C48.2835 19.7131 48.6507 20.0803 49.1039 20.0803C49.557 20.0803 49.9242 19.7131 49.9242 19.26V17.2069H51.9771C52.4303 17.2069 52.7975 16.8397 52.7975 16.3866C52.7975 15.9334 52.4303 15.5663 51.9771 15.5663H49.9242V13.5132C49.9242 13.0602 49.5569 12.6929 49.1039 12.6929Z"
                              fill="#FDE002"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_400_564">
                              <rect
                                width={56}
                                height={56}
                                fill="white"
                                transform="translate(0.441406 0.841309)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <h3>{trans.home.ecommerce}</h3>
                      <svg
                        width={114}
                        height={3}
                        viewBox="0 0 114 3"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.441406"
                          y="0.140137"
                          width="113.543"
                          height="2.31721"
                          fill="#FDE002"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="col-6 col-md-4">
                    <div className="field-item">
                      <div className="icon">
                        <svg
                          width={51}
                          height={57}
                          viewBox="0 0 51 57"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_400_594)">
                            <path
                              d="M41.5882 0.208496C42.3438 0.497385 43.1327 0.708496 43.8327 1.08627C45.3104 1.88627 46.2327 3.18627 46.6993 4.79738C47.2882 6.83072 47.8771 8.86405 48.466 10.8974C48.766 11.9418 48.4993 12.4196 47.466 12.7196C42.2104 14.2418 36.9549 15.7641 31.6993 17.2863C25.2105 19.1641 18.7105 21.0529 12.2216 22.9307C12.1327 22.9529 12.0549 22.9752 11.966 23.0085C11.966 23.0529 11.966 23.0863 11.966 23.1307C12.1438 23.1307 12.3327 23.1307 12.5105 23.1307C24.5438 23.1307 36.5771 23.1307 48.5993 23.1307C48.8438 23.1307 49.0771 23.1307 49.3216 23.1529C49.9549 23.2085 50.2771 23.5196 50.3993 24.1418C50.4327 24.3085 50.4327 24.4752 50.4327 24.6418C50.4327 33.3085 50.4438 41.9752 50.4327 50.6418C50.4327 53.6752 48.5438 56.1196 45.6993 56.8196C45.3104 56.9196 44.8993 56.9863 44.4993 56.9863C40.0327 56.9863 35.5549 56.9863 31.0882 56.9863C30.3105 56.9863 29.8327 56.5641 29.8327 55.8974C29.8327 55.3307 30.2216 54.8641 30.7882 54.7974C30.966 54.7752 31.1549 54.7863 31.3438 54.7863C35.5438 54.7863 39.7327 54.7863 43.9327 54.7863C45.6438 54.7863 47.0104 54.1307 47.766 52.5529C48.0327 52.0085 48.166 51.3529 48.1771 50.7418C48.2104 45.8641 48.1993 40.9863 48.1993 36.1085C48.1993 36.0196 48.1771 35.9307 48.166 35.7863C33.7216 35.7863 19.2882 35.7863 4.82158 35.7863C4.81047 35.9641 4.79936 36.1307 4.79936 36.2863C4.79936 41.0529 4.79936 45.8196 4.79936 50.5863C4.79936 52.5863 5.89935 54.0974 7.72158 54.5974C8.17713 54.7196 8.66602 54.7641 9.1438 54.7641C13.3994 54.7752 17.6438 54.7641 21.8993 54.7752C22.8882 54.7752 23.4771 55.5974 23.0549 56.3863C22.7993 56.8641 22.366 56.9974 21.8438 56.9974C18.9105 56.9863 15.966 56.9974 13.0327 56.9974C11.5771 56.9974 10.1105 57.0085 8.65491 56.9974C5.35491 56.9752 2.61047 54.2529 2.59936 50.9641C2.57713 42.3307 2.59936 33.7085 2.58825 25.0752C2.58825 24.6752 2.52158 24.2641 2.42158 23.8863C1.77713 21.6974 1.05491 19.5641 0.577136 17.3641C-0.0784197 14.3529 1.69936 11.3418 4.6438 10.4307C8.37713 9.27516 12.1438 8.23072 15.8882 7.14183C23.5216 4.93072 31.1438 2.73072 38.7771 0.519607C39.1216 0.419607 39.466 0.308496 39.8216 0.208496C40.4104 0.208496 40.9993 0.208496 41.5882 0.208496ZM46.0771 10.7863C46.0549 10.6418 46.0549 10.5529 46.0216 10.4752C45.5216 8.74183 45.0438 7.0085 44.5104 5.28627C43.9882 3.63072 42.8104 2.69739 41.0993 2.47516C40.7438 2.43072 40.3549 2.44183 40.0104 2.54183C37.9216 3.1085 35.8327 3.7085 33.7216 4.3085C33.7882 4.4085 33.7993 4.46405 33.8438 4.49739C36.3993 6.95294 38.9549 9.4085 41.5104 11.8529C41.5993 11.9418 41.7771 12.0196 41.8771 11.9863C43.2771 11.5974 44.666 11.1863 46.0771 10.7863ZM14.1216 20.0418C14.0882 19.9529 14.0771 19.9085 14.0549 19.8863C11.4882 17.4085 8.91046 14.9418 6.33269 12.4752C6.2438 12.3974 6.07713 12.3307 5.96602 12.3529C3.87713 12.7085 2.37713 14.8085 2.76602 16.8752C2.91047 17.6307 3.13269 18.3752 3.3438 19.1196C3.69936 20.3529 4.06602 21.5863 4.43269 22.8529C7.68824 21.8974 10.8994 20.9752 14.1216 20.0418ZM4.81047 25.3974C4.81047 28.1196 4.81047 30.7863 4.81047 33.4863C6.3438 33.4863 7.83269 33.4752 9.33269 33.4974C9.69935 33.5085 9.88824 33.3863 10.066 33.0752C11.4327 30.6752 12.8216 28.2752 14.2105 25.8863C14.2882 25.7529 14.3549 25.6085 14.4549 25.4085C11.2105 25.3974 8.02158 25.3974 4.81047 25.3974ZM48.1327 33.4641C48.1327 30.7418 48.1327 28.0752 48.1327 25.3641C46.6104 25.3641 45.1438 25.3752 43.666 25.3529C43.2882 25.3529 43.0771 25.4641 42.8882 25.7974C41.5216 28.2085 40.1327 30.5974 38.7438 32.9974C38.666 33.1307 38.5993 33.2863 38.5216 33.4641C41.7438 33.4641 44.9216 33.4641 48.1327 33.4641ZM22.6105 17.5752C22.366 17.3863 22.2105 17.2863 22.0771 17.1641C19.8216 15.0085 17.5438 12.8752 15.3438 10.6641C14.7327 10.0529 14.2216 9.88627 13.3994 10.1752C11.866 10.7085 10.2882 11.1085 8.72158 11.5641C8.75491 11.6529 8.75491 11.6863 8.77713 11.7196C11.3438 14.1863 13.9105 16.6641 16.4882 19.1196C16.5993 19.2196 16.8549 19.2418 17.0105 19.1974C18.2549 18.8529 19.4882 18.4974 20.7327 18.1418C21.3105 17.9641 21.8771 17.7863 22.6105 17.5752ZM39.1882 12.7752C39.0771 12.6418 39.0327 12.5752 38.966 12.5085C36.4549 10.0974 33.9327 7.67516 31.4105 5.27516C31.2771 5.15294 30.9771 5.11961 30.7882 5.17516C29.1216 5.64183 27.466 6.13072 25.7993 6.6085C25.666 6.64183 25.5438 6.69738 25.4216 6.74183C25.4438 6.8085 25.4438 6.83072 25.4549 6.84183C28.0216 9.3085 30.5882 11.7863 33.166 14.2418C33.2771 14.3529 33.5438 14.3974 33.6993 14.3529C35.4993 13.8641 37.2993 13.3307 39.1882 12.7752ZM30.8105 15.1863C30.7549 15.0974 30.7327 15.0418 30.6993 15.0085C28.1549 12.5641 25.6216 10.1196 23.066 7.69739C22.9327 7.57516 22.6216 7.54183 22.4327 7.58627C20.766 8.04183 19.1105 8.53072 17.4438 9.01961C17.3105 9.05294 17.1993 9.11961 17.066 9.16405C17.1105 9.24183 17.1216 9.28627 17.1438 9.3085C19.6993 11.7641 22.2438 14.2196 24.8216 16.6641C24.9438 16.7752 25.2216 16.7974 25.3993 16.7529C26.6216 16.4196 27.8438 16.0641 29.066 15.7196C29.6438 15.5529 30.2216 15.3752 30.8105 15.1863ZM12.3994 33.4863C14.3438 33.4863 16.1882 33.4752 18.0327 33.4974C18.4105 33.4974 18.5882 33.3641 18.7549 33.0641C20.1216 30.6641 21.5105 28.2752 22.8882 25.8752C22.966 25.7307 23.0327 25.5863 23.1105 25.4529C23.0549 25.4196 23.0216 25.3863 22.9882 25.3863C21.1105 25.3863 19.2216 25.3752 17.3438 25.3863C17.1882 25.3863 16.9882 25.5529 16.8993 25.6974C16.5105 26.3196 16.1549 26.9641 15.7882 27.6085C14.6771 29.5307 13.566 31.4641 12.3994 33.4863ZM21.0882 33.4863C23.0327 33.4863 24.8549 33.4752 26.6771 33.4974C27.066 33.4974 27.266 33.3752 27.4549 33.0418C28.8216 30.6418 30.2105 28.2529 31.5993 25.8641C31.6771 25.7307 31.7438 25.5752 31.8216 25.4196C31.7327 25.3974 31.6771 25.3752 31.6327 25.3752C29.7882 25.3752 27.9438 25.3641 26.0993 25.3863C25.9105 25.3863 25.6549 25.5974 25.5438 25.7863C24.4882 27.5752 23.4549 29.3863 22.4105 31.1863C21.9882 31.9196 21.566 32.6529 21.0882 33.4863ZM40.5327 25.3641C38.5993 25.3641 36.766 25.3752 34.9327 25.3529C34.566 25.3529 34.3771 25.4752 34.1993 25.7863C32.8327 28.1863 31.4327 30.5863 30.0549 32.9752C29.9771 33.1085 29.9105 33.2641 29.8105 33.4529C29.966 33.4641 30.0771 33.4752 30.1771 33.4752C31.9549 33.4752 33.7216 33.4641 35.4993 33.4863C35.8549 33.4863 35.9771 33.3085 36.1216 33.0641C37.4993 30.6641 38.8882 28.2641 40.266 25.8752C40.3438 25.7418 40.4216 25.5974 40.5327 25.3641Z"
                              fill="#0EC1E9"
                            />
                            <path
                              d="M22.1869 45.1315C22.1869 43.3203 22.1869 41.5092 22.1869 39.6981C22.1869 38.5648 23.0424 38.0759 24.0202 38.6426C27.1536 40.4426 30.2869 42.2426 33.4091 44.0648C34.4202 44.6537 34.4091 45.6315 33.398 46.2204C30.2869 48.0204 27.1758 49.8204 24.0536 51.6092C22.998 52.2092 22.1758 51.7204 22.1758 50.4981C22.1869 48.7092 22.1869 46.9203 22.1869 45.1315ZM30.798 45.1315C28.6313 43.887 26.5536 42.687 24.4424 41.4648C24.4424 43.9426 24.4424 46.3426 24.4424 48.7981C26.5758 47.5759 28.6424 46.3759 30.798 45.1315Z"
                              fill="#0EC1E9"
                            />
                            <path
                              d="M25.3867 55.877C25.3867 55.277 25.8645 54.7881 26.4534 54.777C27.0534 54.7659 27.5978 55.2993 27.5867 55.8882C27.5867 56.4882 27.0423 56.9993 26.4423 56.9882C25.8534 56.9659 25.3867 56.477 25.3867 55.877Z"
                              fill="#0EC1E9"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_400_594">
                              <rect
                                width={50}
                                height="56.7778"
                                fill="white"
                                transform="translate(0.441406 0.208496)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <h3>
                        {trans.home.media} &amp;
                        <br /> {trans.home.entertainment}
                      </h3>
                      <svg
                        width={114}
                        height={3}
                        viewBox="0 0 114 3"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.441406"
                          y="0.140137"
                          width="113.543"
                          height="2.31721"
                          fill="#0EC1E9"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="col-6 col-md-4">
                    <div className="field-item">
                      <div className="icon">
                        <svg
                          width={57}
                          height={60}
                          viewBox="0 0 57 60"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_400_537)">
                            <path
                              d="M20.9314 41.0691C22.4633 43.3128 23.9023 45.4482 25.3569 47.5991C26.3782 49.1001 27.4304 50.5701 28.3898 52.1175C29.3646 53.6803 29.3801 55.3515 28.4671 56.9453C27.5697 58.5237 26.0996 59.2664 24.3356 59.2509C22.6025 59.2355 21.3027 58.307 20.3433 56.9144C17.7283 53.1078 15.1441 49.2857 12.56 45.4792C12.4362 45.2935 12.2969 45.1078 12.1422 44.8912C10.7805 45.7577 9.32593 46.16 7.73212 46.0981C3.87912 45.9434 1.32593 42.9879 0.645074 40.0633C-0.0512511 37.0304 1.14024 34.0595 3.72438 32.28C5.2563 31.2277 6.80369 30.2219 8.32013 29.1542C8.66055 28.9066 8.98551 28.5662 9.17119 28.1949C12.0958 22.2993 15.0049 16.3883 17.9139 10.4773C18.8114 8.65134 20.6219 7.69196 22.6644 7.90859C25.1557 8.17165 27.2911 9.25482 29.2099 10.7558C35.5851 15.7384 39.8869 22.1291 41.883 29.9898C42.3937 31.986 42.5484 34.0285 41.9449 36.0556C41.3879 37.9434 40.2428 39.3051 38.2157 39.6455C37.1944 39.8157 36.1422 39.8312 35.1054 39.9086C31.9178 40.1716 28.7302 40.4347 25.5271 40.6823C24.3356 40.7751 23.1441 40.8525 21.9526 40.9453C21.6432 40.9917 21.3337 41.0227 20.9314 41.0691ZM19.3066 14.3612C19.384 15.0575 19.3994 15.7384 19.5232 16.4038C19.6625 17.162 19.8172 17.9202 20.0493 18.6475C21.9681 24.7442 25.4033 29.8506 30.1693 34.0749C31.7012 35.4366 33.4033 36.5972 35.3995 37.2006C35.9565 37.3709 36.5909 37.5256 37.148 37.4328C38.5097 37.2316 39.2989 36.2722 39.6548 35.0034C40.1499 33.2239 39.9797 31.4289 39.4691 29.6958C37.3956 22.6707 33.4033 16.9299 27.6006 12.4734C26.3008 11.4676 24.8463 10.7094 23.206 10.338C21.2718 9.90472 19.8327 10.8486 19.4768 12.7829C19.384 13.2935 19.353 13.8351 19.3066 14.3612ZM17.2176 17.0846C17.1712 17.1465 17.1402 17.1929 17.1093 17.2393C15.1596 21.2007 13.2254 25.162 11.2756 29.1078C11.1054 29.4328 11.2292 29.6339 11.3994 29.8815C13.3646 32.7751 15.3453 35.6842 17.3105 38.5933C17.5271 38.9028 17.7283 39.0111 18.1151 38.9801C21.3956 38.7016 24.6915 38.454 27.972 38.191C29.1016 38.0981 30.2157 38.0053 31.3762 37.9124C24.1345 32.6359 19.4304 25.719 17.2176 17.0846ZM9.48067 31.1658C7.88686 32.2645 6.33947 33.2858 4.8385 34.3535C3.50775 35.3128 2.84237 36.6591 2.78047 38.2993C2.65668 41.5643 6.18473 45.278 10.2234 43.2974C12.0648 42.3999 13.6741 41.0846 15.4381 39.9241C13.4265 36.9685 11.4768 34.0904 9.48067 31.1658ZM14.0919 43.5914C14.2157 43.7925 14.3085 43.9473 14.4168 44.102C15.1441 45.1852 15.8869 46.2683 16.6296 47.3515C18.5329 50.1523 20.4362 52.9685 22.3395 55.7693C22.9739 56.6977 23.9178 57.1155 24.8617 56.8989C26.6567 56.4966 27.353 54.6242 26.2853 53.0614C23.7321 49.2703 21.1635 45.4946 18.5948 41.719C18.3008 41.2703 17.7747 41.1155 17.3259 41.4095C16.2428 42.1059 15.1905 42.8486 14.0919 43.5914Z"
                              fill="#0063AA"
                            />
                            <path
                              d="M53.3488 9.96849C53.1321 10.278 52.9619 10.6803 52.6679 10.8814C50.0838 12.6145 47.4687 14.3321 44.8536 16.0188C44.2501 16.4211 43.5229 16.2509 43.167 15.7093C42.8266 15.1832 42.9658 14.4869 43.5538 14.1C46.1689 12.3824 48.7685 10.6648 51.3836 8.96268C52.2192 8.4211 53.2095 8.93174 53.3488 9.96849Z"
                              fill="#0063AA"
                            />
                            <path
                              d="M55.0811 25.4428C53.7968 25.2106 52.4351 24.9785 51.0734 24.731C49.3867 24.437 47.7001 24.1275 46.0134 23.818C44.9767 23.6323 44.5124 22.6575 45.1159 21.9147C45.4718 21.4814 45.9515 21.466 46.4312 21.5433C47.8084 21.7909 49.1856 22.054 50.5782 22.3016C52.172 22.5956 53.7504 22.8741 55.3442 23.1526C56.0251 23.2764 56.4583 23.7406 56.4119 24.3596C56.3964 24.9785 55.8548 25.4428 55.0811 25.4428Z"
                              fill="#0063AA"
                            />
                            <path
                              d="M40.4437 1.27167C40.2735 2.95832 40.1187 4.55213 39.9485 6.14594C39.8093 7.43028 39.6855 8.71461 39.5307 9.99894C39.4534 10.6953 38.8963 11.0976 38.2309 11.0047C37.612 10.9274 37.1942 10.3703 37.2561 9.72041C37.5501 6.88869 37.8441 4.05697 38.1381 1.20977C38.2155 0.544397 38.7416 0.095654 39.3605 0.15755C39.995 0.203971 40.4437 0.71461 40.4437 1.27167Z"
                              fill="#0063AA"
                            />
                            <path
                              d="M27.7089 19.0815C30.3394 19.0969 32.676 20.7836 33.5116 23.3368C34.3317 25.89 33.4497 28.6598 31.2988 30.2381C30.7727 30.625 30.2311 30.6869 29.7978 30.3774C29.3491 30.0679 29.1789 29.6192 29.3646 29.1085C29.4729 28.83 29.7205 28.567 29.9526 28.3658C31.2214 27.329 31.7321 25.9828 31.3762 24.4045C31.0203 22.8261 29.9835 21.8049 28.3897 21.449C27.3684 21.2168 26.4245 21.4335 25.4961 21.9441C25.1557 22.1298 24.6141 22.2227 24.2582 22.0834C23.3916 21.7739 23.3607 20.6288 24.1499 20.0873C25.2021 19.4064 26.3472 19.0505 27.7089 19.0815Z"
                              fill="#0063AA"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_400_537">
                              <rect
                                width={56}
                                height="59.0948"
                                fill="white"
                                transform="translate(0.441406 0.140137)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <h3>
                        {trans.home.marketing} &amp; {trans.home.quang_ba}
                        <br /> {trans.home.image}
                      </h3>
                      <svg
                        width={114}
                        height={3}
                        viewBox="0 0 114 3"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.441406"
                          y="0.140137"
                          width="113.543"
                          height="2.31721"
                          fill="#0063AA"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="col-6 col-md-4">
                    <div className="field-item">
                      <div className="icon">
                        <svg
                          width={57}
                          height={41}
                          viewBox="0 0 57 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_400_574)">
                            <path
                              d="M56.4404 34.9658C56.1627 35.4626 55.7389 35.638 55.169 35.6234C53.7076 35.5942 52.2609 35.6088 50.8141 35.6088C49.7911 38.6923 48.0083 40.1829 45.3193 40.2706C42.7473 40.3583 40.9206 38.853 39.6638 35.6234C32.8245 35.6234 25.9707 35.6234 19.0876 35.6234C18.2546 38.5608 16.4133 40.2706 13.2567 40.2413C10.9769 40.2121 8.62411 38.6046 7.95188 35.6088C7.77651 35.6088 7.58653 35.6088 7.38194 35.6088C5.46754 35.6088 3.55313 35.6088 1.63873 35.6088C0.747284 35.6088 0.425781 35.2873 0.425781 34.3958C0.425781 24.6192 0.425781 14.8572 0.425781 5.08058C0.425781 4.15992 0.718057 3.85303 1.62411 3.85303C13.2713 3.85303 24.9185 3.85303 36.5657 3.85303C37.4717 3.85303 37.7786 4.15992 37.7786 5.08058C37.7786 6.62965 37.7786 8.17871 37.7786 9.72777C37.7786 9.91775 37.7786 10.1223 37.7786 10.3708C38.0417 10.3708 38.2316 10.3708 38.4362 10.3708C41.2128 10.3708 43.9748 10.3854 46.7515 10.3562C47.3652 10.3562 47.7744 10.5754 48.0959 11.0868C50.7556 15.2664 53.4446 19.4167 56.1189 23.5816C56.2212 23.7278 56.3381 23.8593 56.4404 24.0054C56.4404 27.6735 56.4404 31.3269 56.4404 34.9658ZM2.34019 5.76743C2.34019 13.8489 2.34019 21.8864 2.34019 29.9971C3.90386 29.9971 5.43831 29.9971 6.94353 29.9971C6.94353 30.6693 6.94353 31.2685 6.94353 31.9115C5.37985 31.9115 3.86002 31.9115 2.3548 31.9115C2.3548 32.5399 2.3548 33.1098 2.3548 33.6944C4.25459 33.6944 6.09593 33.6944 7.95188 33.6944C8.96023 30.7278 10.7577 29.1495 13.1836 29.0618C16.0479 28.9595 17.6847 30.2309 19.1022 33.6798C24.6847 33.6798 30.2817 33.6798 35.8642 33.6798C35.8642 33.066 35.8642 32.4814 35.8642 31.8676C30.5886 31.8676 25.3423 31.8676 20.0813 31.8676C20.0813 31.2246 20.0813 30.6401 20.0813 29.9679C25.3715 29.9679 30.6179 29.9679 35.8788 29.9679C35.8788 23.0994 35.8788 16.304 35.8788 9.45011C25.2984 9.45011 14.7619 9.45011 4.21075 9.45011C4.21075 8.8071 4.21075 8.23716 4.21075 7.59416C14.7765 7.59416 25.3277 7.59416 35.8788 7.59416C35.8788 6.95115 35.8788 6.38121 35.8788 5.78205C24.6847 5.76743 13.5343 5.76743 2.34019 5.76743ZM54.5845 29.9825C54.5845 28.3019 54.5845 26.7236 54.5845 25.1453C54.5845 24.4438 54.5552 24.4146 53.8391 24.4146C49.5573 24.4146 45.2755 24.4146 40.9936 24.4146C39.9268 24.4146 39.6346 24.1223 39.6346 23.0409C39.6346 20.5127 39.6346 17.9699 39.6346 15.4418C39.6346 14.4188 39.9414 14.1119 40.979 14.1119C43.025 14.1119 45.0563 14.1119 47.1022 14.1119C47.2922 14.1119 47.4822 14.0973 47.7598 14.0827C47.4383 13.5858 47.146 13.162 46.8976 12.7236C46.7222 12.4021 46.503 12.2706 46.1231 12.2852C43.5364 12.2998 40.9498 12.2998 38.3632 12.2998C38.2024 12.2998 38.0417 12.329 37.8663 12.329C37.8663 19.4605 37.8663 26.5628 37.8663 33.709C38.4947 33.709 39.0792 33.709 39.6784 33.709C41.0375 30.304 42.7034 29.0033 45.5531 29.0764C48.0083 29.1495 49.8204 30.7424 50.8141 33.6944C52.0563 33.6944 53.3131 33.6944 54.5552 33.6944C54.5552 33.0806 54.5552 32.496 54.5552 31.8676C53.6199 31.8676 52.7139 31.8676 51.8078 31.8676C51.8078 31.2246 51.8078 30.6255 51.8078 29.9971C52.7285 29.9825 53.6199 29.9825 54.5845 29.9825ZM41.5636 22.471C45.4216 22.471 49.2504 22.471 53.1231 22.471C53.0646 22.3541 53.05 22.2956 53.0062 22.2372C51.7348 20.2643 50.478 18.2768 49.192 16.3186C49.0897 16.1578 48.7828 16.0263 48.5636 16.0263C46.4738 16.0117 44.3694 16.0117 42.2796 16.0117C42.0458 16.0117 41.812 16.0117 41.5636 16.0117C41.5636 18.2038 41.5636 20.3228 41.5636 22.471ZM45.2462 38.3708C47.3068 38.3708 48.9728 36.7048 48.9728 34.6589C48.9728 32.6129 47.2776 30.9324 45.2462 30.9324C43.2003 30.9324 41.5343 32.5983 41.5343 34.6589C41.5343 36.734 43.1711 38.3708 45.2462 38.3708ZM17.217 34.6589C17.217 32.5983 15.551 30.9324 13.5051 30.9324C11.4592 30.9324 9.79321 32.6129 9.79321 34.6589C9.79321 36.7194 11.4446 38.3708 13.5051 38.3708C15.5803 38.3708 17.217 36.734 17.217 34.6589Z"
                              fill="#1A2DD8"
                            />
                            <path
                              d="M4.18359 1.98248C4.18359 1.35409 4.18359 0.784154 4.18359 0.155762C8.5385 0.155762 12.8642 0.155762 17.2629 0.155762C17.2629 0.477265 17.2629 0.784154 17.2629 1.09104C17.2629 1.38332 17.2629 1.66098 17.2629 1.98248C12.8788 1.98248 8.56773 1.98248 4.18359 1.98248Z"
                              fill="#1A2DD8"
                            />
                            <path
                              d="M0.46875 1.98147C0.46875 1.35308 0.46875 0.768529 0.46875 0.140137C1.08253 0.140137 1.66708 0.140137 2.28086 0.140137C2.28086 0.768529 2.28086 1.35308 2.28086 1.98147C1.68169 1.98147 1.09714 1.98147 0.46875 1.98147Z"
                              fill="#1A2DD8"
                            />
                            <path
                              d="M46.153 33.7808C46.153 34.4092 46.153 34.9791 46.153 35.5929C45.5538 35.5929 44.9692 35.5929 44.3555 35.5929C44.3555 35.0083 44.3555 34.4238 44.3555 33.7808C44.9254 33.7808 45.5246 33.7808 46.153 33.7808Z"
                              fill="#1A2DD8"
                            />
                            <path
                              d="M14.4098 33.7671C14.4098 34.3809 14.4098 34.9654 14.4098 35.5792C13.8106 35.5792 13.2261 35.5792 12.5977 35.5792C12.5977 34.9801 12.5977 34.3809 12.5977 33.7671C13.2114 33.7671 13.7814 33.7671 14.4098 33.7671Z"
                              fill="#1A2DD8"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_400_574">
                              <rect
                                width={56}
                                height="40.1441"
                                fill="white"
                                transform="translate(0.441406 0.140137)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <h3>
                        Logistics &amp;
                        <br /> Transportation
                      </h3>
                      <svg
                        width={114}
                        height={3}
                        viewBox="0 0 114 3"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.441406"
                          y="0.140137"
                          width="113.543"
                          height="2.31721"
                          fill="#1A2DD8"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="col-6 col-md-4">
                    <div className="field-item">
                      <div className="icon">
                        <svg
                          width={51}
                          height={51}
                          viewBox="0 0 51 51"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_400_602)">
                            <path
                              d="M49.297 40.5922H48.4937V14.7395C48.4937 12.0968 46.3437 9.94678 43.7009 9.94678H41.099C40.6939 9.94678 40.3655 10.2751 40.3655 10.6803C40.3655 11.0855 40.6939 11.4138 41.099 11.4138H43.7009C45.5348 11.4138 47.0267 12.9057 47.0267 14.7395V40.5923H30.6302C30.1296 40.5923 29.6626 40.8393 29.3812 41.253L29.1612 41.5763C28.9569 41.8766 28.618 42.0559 28.2546 42.0559H22.5302C22.167 42.0559 21.8281 41.8766 21.6237 41.5763L21.4038 41.2531C21.1224 40.8394 20.6555 40.5923 20.1548 40.5923H12.3396C11.9344 40.5923 11.6061 40.9206 11.6061 41.3258C11.6061 41.731 11.9344 42.0593 12.3396 42.0593H20.1548C20.1693 42.0593 20.1828 42.0663 20.191 42.0784L20.411 42.4016C20.8888 43.1037 21.681 43.5229 22.5302 43.5229H28.2546C29.104 43.5229 29.8963 43.1037 30.3741 42.4015L30.594 42.0783C30.6021 42.0663 30.6156 42.0593 30.6301 42.0593H48.9743V42.853C48.9743 44.805 47.3861 46.3932 45.434 46.3932H5.44868C3.49659 46.3932 1.90841 44.805 1.90841 42.853V42.0593H9.2136C9.61879 42.0593 9.9471 41.731 9.9471 41.3258C9.9471 40.9206 9.61879 40.5923 9.2136 40.5923H3.8561V14.7395C3.8561 12.9057 5.34805 11.4138 7.1819 11.4138H9.34495C9.75014 11.4138 10.0785 11.0855 10.0785 10.6803C10.0785 10.2751 9.75014 9.94678 9.34495 9.94678H7.1819C4.53924 9.94678 2.3891 12.0967 2.3891 14.7395V40.5923H1.58587C0.954858 40.5922 0.441406 41.1057 0.441406 41.7368V42.853C0.441406 45.614 2.68768 47.8602 5.44868 47.8602H45.4341C48.1951 47.8602 50.4414 45.614 50.4414 42.853V41.7368C50.4414 41.1057 49.928 40.5922 49.297 40.5922Z"
                              fill="#000959"
                            />
                            <path
                              d="M7.18262 14.5427H11.9069C12.3121 14.5427 12.6404 14.2144 12.6404 13.8092C12.6404 13.404 12.3121 13.0757 11.9069 13.0757H7.18262C6.26555 13.0757 5.51953 13.8218 5.51953 14.7389V38.1956C5.51953 38.6008 5.84785 38.9291 6.25303 38.9291H44.6314C45.0366 38.9291 45.3649 38.6008 45.3649 38.1956V31.9883C45.3649 31.5831 45.0366 31.2548 44.6314 31.2548C44.2262 31.2548 43.8979 31.5831 43.8979 31.9883V37.4621H6.98654V14.7389C6.98654 14.6306 7.07446 14.5427 7.18262 14.5427Z"
                              fill="#000959"
                            />
                            <path
                              d="M45.3623 14.7389C45.3623 13.8218 44.6162 13.0757 43.6991 13.0757H41.3233C40.9182 13.0757 40.5898 13.404 40.5898 13.8092C40.5898 14.2144 40.9182 14.5427 41.3233 14.5427H43.6991C43.8073 14.5427 43.8953 14.6306 43.8953 14.7389V28.8623C43.8953 29.2675 44.2236 29.5958 44.6288 29.5958C45.034 29.5958 45.3623 29.2675 45.3623 28.8623V14.7389Z"
                              fill="#000959"
                            />
                            <path
                              d="M12.7056 12.0055L14.4364 12.9348V19.766C14.4364 22.2665 16.4707 24.3007 18.9712 24.3007H31.9103C34.4107 24.3007 36.4451 22.2665 36.4451 19.766V12.8823L37.5081 12.3116V25.3709C36.3938 25.6905 35.5757 26.7177 35.5757 27.9333C35.5757 29.4032 36.7716 30.5991 38.2416 30.5991C39.7115 30.5991 40.9074 29.4032 40.9074 27.9333C40.9074 26.7177 40.0893 25.6904 38.9751 25.3709V10.5058C38.9751 10.5058 38.9751 10.5057 38.9751 10.5056C38.9751 9.87761 38.6313 9.30314 38.078 9.00602L26.1973 2.62661C25.6931 2.3556 25.0908 2.3556 24.5866 2.62651L12.7056 9.00602C12.1523 9.30314 11.8085 9.87781 11.8086 10.5059C11.8086 11.1339 12.1524 11.7085 12.7056 12.0055ZM39.4405 27.9333C39.4405 28.5943 38.9027 29.1321 38.2417 29.1321C37.5806 29.1321 37.0428 28.5943 37.0428 27.9333C37.0428 27.2723 37.5806 26.7345 38.2417 26.7345C38.9027 26.7345 39.4405 27.2724 39.4405 27.9333ZM13.3996 10.2984L25.2808 3.91894C25.3504 3.88168 25.4333 3.88158 25.5031 3.91904L37.384 10.2984C37.492 10.3564 37.5081 10.4533 37.5081 10.5058C37.5081 10.5583 37.492 10.655 37.384 10.713L25.503 17.0925C25.4334 17.13 25.3502 17.13 25.2806 17.0925L21.9144 15.2851C21.5575 15.0933 21.1129 15.2274 20.9212 15.5844C20.7295 15.9413 20.8635 16.3859 21.2205 16.5775L24.5866 18.385C24.8387 18.5204 25.1153 18.5881 25.3919 18.5881C25.6685 18.5881 25.945 18.5204 26.1971 18.385L34.9781 13.67V19.766C34.9781 21.4576 33.6019 22.8337 31.9103 22.8337H18.9713C17.2796 22.8337 15.9035 21.4576 15.9035 19.766V13.7224L18.3788 15.0515C18.7358 15.2434 19.1806 15.1092 19.372 14.7523C19.5637 14.3954 19.4297 13.9507 19.0727 13.7591L13.3996 10.7129C13.2916 10.655 13.2756 10.5583 13.2756 10.5058C13.2756 10.4533 13.2916 10.3564 13.3996 10.2984Z"
                              fill="#000959"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_400_602">
                              <rect
                                width={50}
                                height={50}
                                fill="white"
                                transform="translate(0.441406 0.140137)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <h3>
                        {trans.home.lear_stream}
                        <br />
                        {trans.home.sub_lear_stream}
                      </h3>
                      <svg
                        width={114}
                        height={3}
                        viewBox="0 0 114 3"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.441406"
                          y="0.140137"
                          width="113.543"
                          height="2.31721"
                          fill="#000959"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="col-6 col-md-4">
                    <div className="field-item">
                      <div className="icon">
                        <svg
                          width={57}
                          height={57}
                          viewBox="0 0 57 57"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_400_549)">
                            <path
                              d="M21.7314 25.3548C22.1758 25.3548 22.6102 25.2231 22.9797 24.9762C23.3493 24.7292 23.6373 24.3783 23.8073 23.9677C23.9774 23.5571 24.0219 23.1053 23.9352 22.6695C23.8485 22.2336 23.6345 21.8332 23.3202 21.519C23.006 21.2047 22.6056 20.9907 22.1697 20.904C21.7339 20.8173 21.2821 20.8618 20.8715 21.0319C20.4609 21.202 20.11 21.49 19.8631 21.8595C19.6162 22.229 19.4844 22.6634 19.4844 23.1078C19.485 23.7036 19.722 24.2747 20.1432 24.696C20.5645 25.1172 21.1356 25.3542 21.7314 25.3548ZM21.7314 22.1733C21.9162 22.1733 22.0969 22.2281 22.2506 22.3308C22.4042 22.4335 22.524 22.5795 22.5947 22.7502C22.6655 22.921 22.684 23.1089 22.6479 23.2902C22.6119 23.4714 22.5229 23.6379 22.3922 23.7686C22.2615 23.8993 22.095 23.9883 21.9137 24.0244C21.7324 24.0604 21.5445 24.0419 21.3738 23.9712C21.203 23.9005 21.057 23.7807 20.9544 23.627C20.8517 23.4733 20.7969 23.2927 20.7969 23.1078C20.7972 22.8601 20.8957 22.6226 21.0709 22.4474C21.2461 22.2722 21.4836 22.1736 21.7314 22.1733Z"
                              fill="#2AD3B5"
                            />
                            <path
                              d="M11.3789 27.4292C9.41016 27.4292 7.76953 29.0313 7.76953 31.0006V35.9141C7.77839 36.0909 7.85567 36.2574 7.98503 36.3783C8.11439 36.4992 8.2857 36.5651 8.46275 36.562H14.2931C14.6555 36.562 14.9883 36.2761 14.9883 35.9137V31.0003C14.9883 29.031 13.3482 27.4292 11.3789 27.4292ZM11.3779 28.7253C12.3951 28.7253 13.257 29.453 13.5388 30.328H9.21689C9.49886 29.4526 10.3605 28.725 11.3779 28.725V28.7253ZM13.6758 35.2495H9.08203V31.6401H13.6758V35.2495Z"
                              fill="#2AD3B5"
                            />
                            <path
                              d="M7.11328 44.8745V52.0933C7.11328 52.2673 7.18242 52.4342 7.30549 52.5573C7.42856 52.6804 7.59548 52.7495 7.76953 52.7495H11.5977C11.7717 52.7495 11.9386 52.6804 12.0617 52.5573C12.1848 52.4342 12.2539 52.2673 12.2539 52.0933V44.8745C12.2539 44.7005 12.1848 44.5335 12.0617 44.4105C11.9386 44.2874 11.7717 44.2183 11.5977 44.2183H7.76953C7.59548 44.2183 7.42856 44.2874 7.30549 44.4105C7.18242 44.5335 7.11328 44.7005 7.11328 44.8745ZM8.42578 45.5308H10.9414V51.437H8.42578V45.5308Z"
                              fill="#2AD3B5"
                            />
                            <path
                              d="M28.5513 35.9149C28.5479 35.9989 28.5616 36.0827 28.5915 36.1613C28.6213 36.2399 28.6668 36.3116 28.7251 36.3721C28.7834 36.4327 28.8533 36.4808 28.9307 36.5137C29.0081 36.5465 29.0913 36.5633 29.1754 36.5632H35.0057C35.0914 36.564 35.1764 36.5479 35.2558 36.5157C35.3352 36.4835 35.4075 36.4359 35.4684 36.3756C35.5293 36.3154 35.5776 36.2436 35.6106 36.1645C35.6436 36.0854 35.6606 36.0006 35.6607 35.9149V31.0015C35.6607 30.0587 35.2861 29.1546 34.6195 28.4879C33.9529 27.8213 33.0487 27.4468 32.106 27.4468C31.1632 27.4468 30.2591 27.8213 29.5924 28.4879C28.9258 29.1546 28.5513 30.0587 28.5513 31.0015V35.9149ZM32.0905 28.7261C33.1077 28.7261 33.9696 29.4538 34.2515 30.3288H29.9294C30.2115 29.4538 31.0732 28.7261 32.0905 28.7261ZM29.8638 31.6413H34.3482V35.2507H29.8638V31.6413Z"
                              fill="#2AD3B5"
                            />
                            <path
                              d="M31.832 52.7495H35.6602C35.8342 52.7495 36.0011 52.6804 36.1242 52.5573C36.2473 52.4342 36.3164 52.2673 36.3164 52.0933V44.8745C36.3164 44.7005 36.2473 44.5335 36.1242 44.4105C36.0011 44.2874 35.8342 44.2183 35.6602 44.2183H31.832C31.658 44.2183 31.4911 44.2874 31.368 44.4105C31.2449 44.5335 31.1758 44.7005 31.1758 44.8745V52.0933C31.1758 52.2673 31.2449 52.4342 31.368 52.5573C31.4911 52.6804 31.658 52.7495 31.832 52.7495ZM32.4883 45.5308H35.0039V51.437H32.4883V45.5308Z"
                              fill="#2AD3B5"
                            />
                            <path
                              d="M21.7149 27.4292C21.2469 27.43 20.7837 27.5231 20.3517 27.7031C19.9198 27.883 19.5275 28.1464 19.1974 28.478C18.8673 28.8097 18.6057 29.2031 18.4278 29.6359C18.2498 30.0687 18.1589 30.5323 18.1602 31.0003V35.9137C18.1604 35.9995 18.1776 36.0844 18.2107 36.1634C18.2439 36.2425 18.2923 36.3142 18.3533 36.3745C18.4143 36.4348 18.4867 36.4823 18.5661 36.5145C18.6456 36.5467 18.7307 36.5629 18.8164 36.562H24.6472C24.7312 36.5622 24.8144 36.5454 24.8917 36.5126C24.969 36.4797 25.0388 36.4316 25.097 36.371C25.1552 36.3104 25.2005 36.2386 25.2301 36.16C25.2598 36.0815 25.2732 35.9977 25.2695 35.9137V31.0003C25.2708 30.5323 25.1799 30.0687 25.0019 29.6359C24.824 29.2031 24.5624 28.8097 24.2323 28.478C23.9022 28.1464 23.5099 27.883 23.078 27.7031C22.646 27.5231 22.1828 27.43 21.7149 27.4292ZM21.732 28.7253C22.7492 28.7253 23.6111 29.453 23.8931 30.328H19.5711C19.853 29.4526 20.7147 28.725 21.732 28.725V28.7253ZM23.957 35.2495H19.4727V31.6401H23.957V35.2495Z"
                              fill="#2AD3B5"
                            />
                            <path
                              d="M6.12891 27.5972C5.95486 27.5972 5.78794 27.6663 5.66487 27.7894C5.5418 27.9124 5.47266 28.0794 5.47266 28.2534V28.7237C5.47266 28.8978 5.5418 29.0647 5.66487 29.1878C5.78794 29.3108 5.95486 29.38 6.12891 29.38C6.30295 29.38 6.46987 29.3108 6.59295 29.1878C6.71602 29.0647 6.78516 28.8978 6.78516 28.7237V28.2534C6.78516 28.0794 6.71602 27.9124 6.59295 27.7894C6.46987 27.6663 6.30295 27.5972 6.12891 27.5972Z"
                              fill="#2AD3B5"
                            />
                            <path
                              d="M6.12891 30.146C5.95486 30.146 5.78794 30.2151 5.66487 30.3382C5.5418 30.4613 5.47266 30.6282 5.47266 30.8022V35.9429C5.47266 36.1169 5.5418 36.2838 5.66487 36.4069C5.78794 36.53 5.95486 36.5991 6.12891 36.5991C6.30295 36.5991 6.46987 36.53 6.59295 36.4069C6.71602 36.2838 6.78516 36.1169 6.78516 35.9429V30.8022C6.78516 30.6282 6.71602 30.4613 6.59295 30.3382C6.46987 30.2151 6.30295 30.146 6.12891 30.146Z"
                              fill="#2AD3B5"
                            />
                            <path
                              d="M49.752 8.62136C48.7278 7.7419 47.4938 7.14189 46.1696 6.87946C46.2848 6.60873 46.3312 6.31365 46.3045 6.02062C46.2778 5.72759 46.1789 5.44575 46.0166 5.20031C45.8543 4.95486 45.6337 4.75346 45.3746 4.61412C45.1154 4.47479 44.8258 4.40186 44.5315 4.40186C44.2373 4.40186 43.9476 4.47479 43.6885 4.61412C43.4293 4.75346 43.2087 4.95486 43.0464 5.20031C42.8842 5.44575 42.7853 5.72759 42.7586 6.02062C42.7319 6.31365 42.7782 6.60873 42.8935 6.87946C41.5695 7.14193 40.3358 7.74174 39.3116 8.62082C38.0525 9.69195 37.2129 11.1739 36.9413 12.8045C36.6273 12.8946 36.3474 13.0765 36.1375 13.3267C35.9276 13.5769 35.7971 13.8841 35.7629 14.209C35.7287 14.5338 35.7923 14.8615 35.9455 15.1499C36.0987 15.4384 36.3346 15.6745 36.6229 15.8281L36.6746 16.1973C36.7463 16.7205 37.006 17.1997 37.4052 17.5454C37.8043 17.891 38.3157 18.0796 38.8437 18.0757H50.2062C50.7277 18.0781 51.2328 17.8934 51.6299 17.5552C52.0269 17.217 52.2895 16.7476 52.37 16.2323L52.433 15.8198C52.7225 15.6682 52.9598 15.4334 53.1144 15.1456C53.2689 14.8578 53.3337 14.5302 53.3001 14.2053C53.2666 13.8803 53.1365 13.5729 52.9264 13.3226C52.7164 13.0724 52.4361 12.891 52.1219 12.8017C51.8503 11.1721 51.0108 9.69127 49.752 8.62136ZM44.5315 5.71505C44.624 5.71503 44.7144 5.74245 44.7914 5.79384C44.8683 5.84522 44.9283 5.91828 44.9637 6.00375C44.9991 6.08923 45.0084 6.18329 44.9904 6.27404C44.9723 6.36479 44.9278 6.44816 44.8624 6.51359C44.797 6.57902 44.7136 6.62359 44.6229 6.64165C44.5321 6.65971 44.4381 6.65045 44.3526 6.61505C44.2671 6.57964 44.194 6.51968 44.1426 6.44275C44.0912 6.36582 44.0638 6.27537 44.0638 6.18285C44.0639 6.05885 44.1133 5.93998 44.2009 5.8523C44.2886 5.76461 44.4075 5.71525 44.5315 5.71505ZM51.0721 16.0278C51.0398 16.2338 50.9346 16.4214 50.7757 16.5563C50.6168 16.6913 50.4147 16.7647 50.2062 16.7632H38.8437C38.6327 16.7651 38.4283 16.6901 38.2686 16.5521C38.1089 16.4142 38.005 16.2227 37.9763 16.0137L37.9727 15.9976H51.0778L51.0721 16.0278ZM51.9966 14.3575C51.9966 14.4446 51.9621 14.528 51.9005 14.5896C51.839 14.6511 51.7555 14.6857 51.6685 14.6857H37.3951C37.308 14.6857 37.2246 14.6511 37.163 14.5896C37.1015 14.528 37.0669 14.4446 37.0669 14.3575C37.0669 14.2705 37.1015 14.1871 37.163 14.1255C37.2246 14.064 37.308 14.0294 37.3951 14.0294H51.6685C51.7554 14.0295 51.8388 14.0641 51.9002 14.1257C51.9617 14.1872 51.9962 14.2706 51.9962 14.3575H51.9966ZM38.2891 12.7164C38.8727 10.0914 41.4774 8.00383 44.5315 8.00383C47.5855 8.00383 50.1904 10.0914 50.7739 12.7164H38.2891Z"
                              fill="#2AD3B5"
                            />
                            <path
                              d="M44.5154 0.853027C41.5045 0.856443 38.6179 2.05404 36.4888 4.18309C34.3598 6.31213 33.1623 9.19875 33.1589 12.2097C33.1589 12.4547 33.1676 12.6977 33.1829 12.939H6.88819C6.76587 12.9375 6.64563 12.9706 6.54129 13.0344C6.43696 13.0983 6.35277 13.1903 6.29844 13.2999L1.07841 23.9923C1.02948 24.0953 1.00686 24.2088 1.01259 24.3226C1.01832 24.4365 1.05221 24.5472 1.11122 24.6447C1.16936 24.7413 1.25083 24.8217 1.34814 24.8786C1.44545 24.9354 1.55549 24.9669 1.66816 24.9702H2.84821V54.7749C2.84821 55.1373 3.13914 55.4858 3.5015 55.4858H39.8544C40.2167 55.4858 40.4732 55.1373 40.4732 54.7749V24.9702H40.8029C40.9143 24.966 41.023 24.9344 41.1194 24.8784C41.2158 24.8223 41.297 24.7434 41.3558 24.6487C41.4146 24.554 41.4492 24.4462 41.4567 24.335C41.4642 24.2237 41.4442 24.1123 41.3986 24.0106L40.9254 22.9843C42.4862 23.5043 44.1414 23.679 45.7764 23.4962C47.4114 23.3135 48.9871 22.7777 50.3947 21.9259C51.8022 21.0742 53.0078 19.9268 53.9282 18.5631C54.8486 17.1995 55.4617 15.6522 55.7251 14.0282C55.9885 12.4043 55.896 10.7425 55.4539 9.15782C55.0118 7.57316 54.2306 6.10348 53.1646 4.85047C52.0985 3.59745 50.7729 2.59102 49.2795 1.90081C47.7861 1.2106 46.1606 0.853094 44.5154 0.853027ZM27.4576 54.1733H15.7545V44.6577H27.4576V54.1733ZM27.4576 43.3452H15.7545V39.9546H27.4576V43.3452ZM39.1607 54.1733H28.7701V39.9546H39.1607V54.1733ZM39.1607 38.6421H10.5045C10.3304 38.6421 10.1635 38.7112 10.0404 38.8343C9.91735 38.9574 9.84821 39.1243 9.84821 39.2983C9.84821 39.4724 9.91735 39.6393 10.0404 39.7624C10.1635 39.8855 10.3304 39.9546 10.5045 39.9546H14.442V54.1733H4.16071V39.9546H6.78571C6.95975 39.9546 7.12667 39.8855 7.24974 39.7624C7.37282 39.6393 7.44196 39.4724 7.44196 39.2983C7.44196 39.1243 7.37282 38.9574 7.24974 38.8343C7.12667 38.7112 6.95975 38.6421 6.78571 38.6421H4.16071V24.9702H14.5164C14.6794 24.9633 14.8343 24.8977 14.9526 24.7855L21.7326 18.7435L28.5126 24.7902C28.6314 24.9011 28.7864 24.965 28.9488 24.9702H39.1607V38.6421ZM29.1985 23.6577L22.1689 17.3842C22.0476 17.2785 21.8917 17.2211 21.7309 17.2228C21.57 17.2245 21.4154 17.2853 21.2964 17.3935L14.267 23.6577H2.7186L7.29813 14.2515H33.3432C33.6513 15.9212 34.3287 17.501 35.326 18.8752C36.3233 20.2494 37.6152 21.3833 39.1072 22.1938L39.7767 23.6577H29.1985ZM44.5154 22.2537C42.5288 22.2537 40.5869 21.6646 38.9352 20.5609C37.2834 19.4573 35.996 17.8886 35.2358 16.0532C34.4756 14.2179 34.2767 12.1984 34.6643 10.25C35.0518 8.30162 36.0084 6.51193 37.4132 5.10724C38.8179 3.70254 40.6076 2.74594 42.5559 2.3584C44.5043 1.97086 46.5239 2.16978 48.3592 2.93001C50.1945 3.69025 51.7632 4.97764 52.8668 6.62941C53.9705 8.28117 54.5595 10.2231 54.5595 12.2097C54.5565 14.8726 53.4973 17.4256 51.6143 19.3086C49.7313 21.1915 47.1783 22.2507 44.5154 22.2537Z"
                              fill="#2AD3B5"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_400_549">
                              <rect
                                width={56}
                                height={56}
                                fill="white"
                                transform="translate(0.441406 0.140137)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <h3>
                        {trans.home.hotel}
                        <br /> {trans.home.restaurant}
                      </h3>
                      <svg
                        width={114}
                        height={3}
                        viewBox="0 0 114 3"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.441406"
                          y="0.140137"
                          width="113.543"
                          height="2.31721"
                          fill="#2AD3B5"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="col-6 col-md-4">
                    <div className="field-item">
                      <div className="icon">
                        <svg
                          width={51}
                          height={54}
                          viewBox="0 0 51 54"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_400_584)">
                            <path
                              d="M0.972281 53.6766C0.525229 53.3134 0.441406 52.8244 0.441406 52.2516C0.455377 46.0069 0.455377 39.7761 0.441406 33.5313C0.441406 32.8607 0.678903 32.4835 1.25169 32.1622C6.35088 29.3402 11.4501 26.5321 16.5353 23.6682C17.7647 22.9697 18.3794 23.6263 18.3514 24.7579C18.2816 27.0071 18.3375 29.2564 18.3375 31.5894C18.5889 31.4497 18.7845 31.3659 18.9661 31.2541C23.5345 28.7255 28.0888 26.1829 32.6571 23.6542C32.6851 23.6403 32.713 23.6263 32.7549 23.5984C33.7747 23.0395 34.3894 23.4028 34.4034 24.5903C34.4034 26.6998 34.4034 28.8093 34.4034 30.9188C34.4034 31.1144 34.4034 31.296 34.4034 31.6034C35.0321 31.2541 35.563 30.8909 36.1497 30.6674C36.946 30.36 37.1695 29.8292 37.1835 29.0049C37.2953 23.5285 37.4629 18.0661 37.6166 12.6037C37.7144 8.84564 37.8262 5.07363 37.9379 1.3156C37.9659 0.449438 38.2872 0.14209 39.1673 0.14209C41.0533 0.14209 42.9253 0.14209 44.8113 0.14209C45.6915 0.14209 45.9849 0.393557 46.0128 1.27369C46.1106 4.17953 46.1944 7.08537 46.2782 10.0052C46.4179 14.825 46.5576 19.6587 46.6973 24.4785C46.6973 24.5483 46.7113 24.6182 46.7253 24.7439C46.879 24.6741 47.0187 24.6182 47.1444 24.5483C47.801 24.1851 48.4436 23.8079 49.1142 23.4726C49.7988 23.1234 50.4414 23.5285 50.4694 24.2829C50.4694 24.4226 50.4694 24.5623 50.4694 24.702C50.4694 33.8806 50.4694 43.0731 50.4833 52.2516C50.4833 52.8244 50.4135 53.3134 49.9524 53.6766C33.6071 53.6766 17.2897 53.6766 0.972281 53.6766ZM48.6392 25.7917C48.3878 25.9174 48.2062 26.0152 48.0385 26.113C43.4283 28.6696 38.8181 31.2402 34.2218 33.7967C33.2439 34.3416 32.5873 33.9644 32.5873 32.8468C32.5873 30.7093 32.5873 28.5578 32.5873 26.4204C32.5873 26.2388 32.5873 26.0571 32.5873 25.7917C31.0645 26.6439 29.6395 27.4262 28.2006 28.2226C24.8197 30.0946 21.4529 31.9666 18.072 33.8526C17.6809 34.0761 17.2338 34.2159 16.9125 33.8806C16.675 33.6291 16.5353 33.21 16.5353 32.8607C16.5073 30.7233 16.5213 28.5718 16.5213 26.4343C16.5213 26.2527 16.5073 26.0711 16.4934 25.8476C16.3397 25.9174 16.2559 25.9454 16.186 25.9873C11.6596 28.502 7.11925 31.0166 2.57888 33.5313C2.27153 33.6989 2.24359 33.9225 2.24359 34.2159C2.24359 39.9437 2.24359 45.6855 2.24359 51.4134C2.24359 51.581 2.24359 51.7487 2.24359 51.9024C7.34278 51.9024 12.3442 51.9024 17.4015 51.9024C17.4015 51.6788 17.4015 51.4972 17.4015 51.3016C17.4015 49.8208 17.4015 48.3399 17.4015 46.859C17.4015 45.9929 17.7228 45.6716 18.6169 45.6716C23.1712 45.6716 27.7116 45.6716 32.2659 45.6716C33.188 45.6716 33.4953 45.9789 33.4953 46.887C33.4953 48.3679 33.4953 49.8487 33.4953 51.3296C33.4953 51.5112 33.4953 51.7068 33.4953 51.8884C38.5806 51.8884 43.5959 51.8884 48.6392 51.8884C48.6392 43.1709 48.6392 34.5372 48.6392 25.7917ZM44.2805 5.53466C42.6878 5.53466 41.1651 5.53466 39.6004 5.53466C39.3769 13.386 39.1533 21.1955 38.9298 29.0608C39.1394 28.963 39.2651 28.8931 39.4048 28.8233C41.0952 27.8873 42.7717 26.9373 44.4761 26.0152C44.7974 25.8476 44.9091 25.652 44.8952 25.2888C44.7136 19.3374 44.5459 13.386 44.3783 7.42066C44.3503 6.80596 44.3084 6.19127 44.2805 5.53466ZM24.4984 47.5157C24.4286 47.4877 24.3866 47.4598 24.3308 47.4598C22.7242 47.4598 21.1315 47.4598 19.525 47.4458C19.1757 47.4458 19.1897 47.6554 19.1897 47.8929C19.1897 48.9825 19.1897 50.0862 19.1897 51.1759C19.1897 51.4134 19.1897 51.6369 19.1897 51.8604C21.0198 51.8604 22.7521 51.8604 24.4844 51.8604C24.4984 50.3936 24.4984 48.9546 24.4984 47.5157ZM26.3984 47.4458C26.3984 48.9825 26.3984 50.4215 26.3984 51.8604C28.1726 51.8604 29.9049 51.8604 31.6792 51.8604C31.6792 50.4494 31.6792 49.0803 31.6652 47.7112C31.6652 47.6134 31.4836 47.4598 31.3858 47.4458C29.7373 47.4318 28.0888 47.4458 26.3984 47.4458ZM39.6982 1.94427C39.6982 2.55897 39.6982 3.13175 39.6982 3.6766C41.2349 3.6766 42.7298 3.6766 44.2665 3.6766C44.2386 3.07587 44.2106 2.51705 44.1827 1.94427C42.6599 1.94427 41.221 1.94427 39.6982 1.94427Z"
                              fill="#8A0ED6"
                            />
                            <path
                              d="M25.4354 41.2163C24.3596 41.2163 23.27 41.2163 22.1942 41.2163C21.3001 41.2163 20.9648 40.867 20.9648 39.9869C20.9648 38.995 20.9648 38.0031 20.9648 37.0112C20.9648 36.173 21.3141 35.8377 22.1384 35.8237C24.3457 35.8237 26.567 35.8237 28.7743 35.8237C29.5706 35.8237 29.9199 36.173 29.9199 36.9693C29.9338 38.0031 29.9338 39.023 29.9199 40.0568C29.9199 40.8531 29.5706 41.2023 28.7743 41.2163C27.6567 41.2163 26.553 41.2163 25.4354 41.2163ZM22.8229 39.3582C24.5832 39.3582 26.3155 39.3582 28.0618 39.3582C28.0618 38.7855 28.0618 38.2406 28.0618 37.6958C26.2876 37.6958 24.5552 37.6958 22.8229 37.6958C22.8229 38.2546 22.8229 38.7855 22.8229 39.3582Z"
                              fill="#8A0ED6"
                            />
                            <path
                              d="M9.39695 41.2163C8.32123 41.2163 7.23154 41.2163 6.15582 41.2163C5.21981 41.2163 4.91246 40.909 4.91246 39.959C4.91246 38.9671 4.89849 37.9752 4.91246 36.9833C4.92643 36.1451 5.24775 35.8237 6.09994 35.8237C8.29329 35.8237 10.4866 35.8237 12.68 35.8237C13.5182 35.8237 13.8395 36.159 13.8395 36.9972C13.8395 38.0031 13.8395 39.0229 13.8395 40.0288C13.8395 40.895 13.5182 41.2163 12.6381 41.2163C11.5624 41.2163 10.4727 41.2163 9.39695 41.2163ZM6.74258 39.3443C8.53078 39.3443 10.2771 39.3443 12.0094 39.3443C12.0094 38.7575 12.0094 38.2127 12.0094 37.6678C10.2352 37.6678 8.50284 37.6678 6.74258 37.6678C6.74258 38.2406 6.74258 38.7715 6.74258 39.3443Z"
                              fill="#8A0ED6"
                            />
                            <path
                              d="M41.5414 35.8241C42.6032 35.8241 43.6649 35.8241 44.7267 35.8241C45.6487 35.8241 45.9561 36.1314 45.9701 37.0255C45.984 38.0174 45.9701 39.0093 45.9701 40.0012C45.9701 40.8814 45.6487 41.2167 44.7826 41.2167C42.5892 41.2167 40.3959 41.2306 38.2025 41.2167C37.3643 41.2167 37.043 40.8814 37.043 40.0431C37.043 39.0373 37.043 38.0174 37.043 37.0116C37.043 36.1454 37.3643 35.8241 38.2444 35.8241C39.3481 35.8101 40.4518 35.8241 41.5414 35.8241ZM38.8452 39.3446C40.6334 39.3446 42.3797 39.3446 44.112 39.3446C44.112 38.7579 44.112 38.213 44.112 37.6682C42.3378 37.6682 40.6054 37.6682 38.8452 37.6682C38.8452 38.241 38.8452 38.7718 38.8452 39.3446Z"
                              fill="#8A0ED6"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_400_584">
                              <rect
                                width={50}
                                height="53.5345"
                                fill="white"
                                transform="translate(0.441406 0.140137)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <h3>{trans.home.factory}</h3>
                      <svg
                        width={114}
                        height={3}
                        viewBox="0 0 114 3"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.441406"
                          y="0.140137"
                          width="113.543"
                          height="2.31721"
                          fill="#8A0ED6"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="col-6 col-md-4">
                    <div className="field-item">
                      <div className="icon">
                        <svg
                          width={57}
                          height={48}
                          viewBox="0 0 57 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M55.5664 0.140137H38.0664C37.5825 0.140137 37.1914 0.531262 37.1914 1.01514V12.3901H35.4493V6.26864C35.4493 4.82139 34.2715 3.64364 32.8243 3.64364H11.8243C10.377 3.64364 9.19928 4.82139 9.19928 6.26864V12.3901H3.07778C3.07603 12.3901 3.07428 12.391 3.07166 12.391C3.06991 12.391 3.06816 12.3901 3.06641 12.3901C1.61916 12.3901 0.441406 13.5679 0.441406 15.0151V16.7651C0.441406 16.7923 0.454531 16.815 0.457156 16.8413V46.5151C0.457156 46.999 0.848281 47.3901 1.33216 47.3901H43.3322H43.333C43.4293 47.3901 43.5194 47.3639 43.6069 47.335C43.6279 47.328 43.6533 47.3306 43.6734 47.3219C43.6979 47.3105 43.7154 47.2895 43.739 47.2773C44.0138 47.1294 44.2072 46.8494 44.2072 46.5151C44.2072 46.5143 44.2072 46.5143 44.2072 46.5143L44.1923 21.1209L55.5647 21.141H55.5664C55.7983 21.141 56.0205 21.0491 56.1842 20.8855C56.3495 20.721 56.4414 20.4988 56.4414 20.266V1.01514C56.4414 0.531262 56.0503 0.140137 55.5664 0.140137ZM42.4423 21.6651L42.4563 45.6401H38.9493V41.392C38.9493 41.3701 38.9379 41.3509 38.9362 41.329C38.9379 41.3071 38.9493 41.2879 38.9493 41.266C38.9493 37.4064 35.8089 34.266 31.9493 34.266H28.4493V31.8659C32.6073 29.6609 35.4484 25.292 35.4493 20.2669V17.6401H37.1914V22.891C37.1914 23.1946 37.3489 23.4773 37.6079 23.6365C37.7479 23.7231 37.9072 23.766 38.0664 23.766C38.2012 23.766 38.3368 23.7354 38.4602 23.6724L42.4423 21.6651ZM24.4663 45.6401L28.1745 36.0151H28.9235L25.2153 45.6401H24.4663ZM21.213 45.6401L18.6309 37.2305L19.2137 37.6181C19.2557 37.6461 19.302 37.661 19.3458 37.6803C19.3773 37.6943 19.4062 37.7135 19.4394 37.724C19.5252 37.7503 19.6118 37.7651 19.6984 37.7651H19.6993H19.7019C19.7859 37.7643 19.8682 37.7476 19.9495 37.724C19.9583 37.7214 19.967 37.7223 19.9758 37.7196L22.3243 36.9365L24.6728 37.7196C24.6824 37.7223 24.6912 37.7214 24.6999 37.724C24.7804 37.7476 24.8635 37.7643 24.9467 37.7651H24.9493H24.9502C25.0368 37.7651 25.1234 37.7503 25.2083 37.724C25.2415 37.7135 25.2704 37.6943 25.3028 37.6794C25.3474 37.6601 25.3929 37.6453 25.434 37.6181L25.7665 37.3968L22.5903 45.6401H21.213ZM18.5845 45.6401L15.6297 36.0151H16.4268L19.3817 45.6401H18.5845ZM7.43616 41.3281C7.43791 41.3063 7.44928 41.287 7.44928 41.2651C7.44928 38.3698 9.80391 36.0151 12.6993 36.0151H13.7992L16.754 45.6401H7.44928V41.392C7.44928 41.3693 7.43791 41.3509 7.43616 41.3281ZM10.9493 20.245V15.8901H33.6993V16.7354C33.6993 16.7468 33.6932 16.7546 33.6932 16.7651C33.6932 16.7756 33.6993 16.7835 33.6993 16.7949V20.2651C33.6993 26.5371 28.5963 31.6401 22.3243 31.6401C16.0523 31.6401 10.9493 26.5371 10.9493 20.2651C10.9493 20.2616 10.9475 20.2581 10.9475 20.2546C10.9475 20.2511 10.9493 20.2476 10.9493 20.245ZM22.3243 33.3901C23.8599 33.3901 25.329 33.1119 26.6993 32.6245V34.672L24.8198 35.925L22.6017 35.1856C22.5702 35.1751 22.5395 35.1804 22.508 35.1734C22.4477 35.1603 22.3882 35.1506 22.3252 35.1506C22.2622 35.1506 22.2027 35.1611 22.1432 35.1734C22.1117 35.1804 22.0802 35.1751 22.0487 35.1856L19.8305 35.925L17.951 34.672V32.6245C19.3195 33.1119 20.7887 33.3901 22.3243 33.3901ZM30.7995 36.0151H31.9484C34.8438 36.0151 37.1984 38.3698 37.1984 41.2651C37.1984 41.287 37.2098 41.3063 37.2115 41.3281C37.2098 41.35 37.1984 41.3693 37.1984 41.3911V45.6401H27.0913L30.7995 36.0151ZM37.1914 15.8901H35.4493V14.1401H37.1914V15.8901ZM10.9493 6.26864C10.9493 5.78564 11.3413 5.39364 11.8243 5.39364H32.8243C33.3073 5.39364 33.6993 5.78564 33.6993 6.26864V13.2669V13.2678V13.2686V14.1401H10.9493V13.2669V6.26864ZM3.06641 14.1401C3.06816 14.1401 3.06991 14.1393 3.07166 14.1393C3.07428 14.1393 3.07603 14.1401 3.07778 14.1401H9.19928V15.8901H2.19141V15.0151C2.19141 14.5321 2.58341 14.1401 3.06641 14.1401ZM2.20716 17.6401H9.19928V20.245C9.19928 20.2485 9.20103 20.252 9.20103 20.2555C9.20103 20.259 9.19928 20.2616 9.19928 20.2651C9.19928 25.2903 12.0413 29.66 16.1993 31.865V34.2651H12.6993C8.83966 34.2651 5.69928 37.4055 5.69928 41.2651C5.69928 41.287 5.71066 41.3063 5.71241 41.3281C5.71066 41.35 5.69928 41.3693 5.69928 41.3911V45.6401H2.20716V17.6401ZM54.6914 19.3893L43.3182 19.37H43.3173H43.3164C43.3164 19.37 43.3164 19.37 43.3155 19.37C43.3129 19.37 43.3103 19.3718 43.3077 19.3718C43.2149 19.3849 43.1248 19.4006 43.0373 19.4269C43.0093 19.4365 42.9795 19.4426 42.9515 19.454C42.9419 19.4584 42.9314 19.4593 42.9218 19.4645L38.9414 21.47V1.89014H54.6914V19.3893Z"
                            fill="#1999F4"
                          />
                        </svg>
                      </div>
                      <h3>
                        {trans.home.healthy}
                        <br /> {trans.home.medical}
                      </h3>
                      <svg
                        width={114}
                        height={3}
                        viewBox="0 0 114 3"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.441406"
                          y="0.140137"
                          width="113.543"
                          height="2.31721"
                          fill="#1999F4"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <a href='true' className='read-more d-flex d-md-none'>
              {trans.text_button.read_more}
              <svg width={33} height={32} viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle cx='16.4414' cy={16} r={16} fill='#0063AA' />
                <path fillRule='evenodd' clipRule='evenodd' d='M5.44141 16.2491C5.44141 16.0501 5.52042 15.8594 5.66108 15.7187C5.80173 15.5781 5.99249 15.4991 6.19141 15.4991L23.8809 15.4991L19.1604 10.7801C19.0196 10.6392 18.9405 10.4482 18.9405 10.2491C18.9405 10.0499 19.0196 9.85888 19.1604 9.71805C19.3012 9.57722 19.4922 9.49811 19.6914 9.49811C19.8906 9.49811 20.0816 9.57722 20.2224 9.71805L26.2224 15.7181C26.2923 15.7877 26.3477 15.8705 26.3855 15.9616C26.4233 16.0527 26.4427 16.1504 26.4427 16.2491C26.4427 16.3477 26.4233 16.4454 26.3855 16.5365C26.3477 16.6276 26.2923 16.7104 26.2224 16.7801L20.2224 22.7801C20.0816 22.9209 19.8906 23 19.6914 23C19.4922 23 19.3012 22.9209 19.1604 22.7801C19.0196 22.6392 18.9405 22.4482 18.9405 22.2491C18.9405 22.0499 19.0196 21.8589 19.1604 21.7181L23.8809 16.9991L6.19141 16.9991C5.99249 16.9991 5.80173 16.92 5.66108 16.7794C5.52042 16.6387 5.44141 16.448 5.44141 16.2491Z' fill='white' />
              </svg>
            </a> */}
          </div>
        </div>
        {/* end fields */}
        {/* featured project */}
        <div className="r-featured-project">
          <div className="container">
            {/* <div className="label">
              <svg
                width="109"
                height="455"
                viewBox="0 0 109 455"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M83.2859 14.1145L83.2859 39.7614C83.2859 47.4573 81.2901 53.8885 77.5089 58.4237C73.7015 62.9905 68.2027 65.488 61.5439 65.488C54.922 65.488 49.4434 62.9883 45.6473 58.4221C41.8774 53.8875 39.8816 47.4573 39.8816 39.7614L39.8816 30.0247L24.5009 30.0247L24.5009 14.1145L83.2859 14.1145ZM26.0009 28.5247L26.0009 15.6145L81.7859 15.6145L81.7859 39.7614C81.7859 54.664 74.0557 63.988 61.5439 63.988C49.1118 63.988 41.3816 54.664 41.3816 39.7614L41.3816 28.5247L26.0009 28.5247ZM53.4011 30.0247L53.4011 39.0442C53.4011 42.7881 54.2548 45.3628 55.6031 46.9791C56.9154 48.5523 58.8644 49.4184 61.5439 49.4184C64.2692 49.4184 66.2375 48.5483 67.5573 46.9757C68.9126 45.3607 69.7664 42.7884 69.7664 39.0442L69.7664 30.0247L53.4011 30.0247ZM24.5009 125.49L24.5009 107.962L40.041 97.2036L40.041 87.6152L24.5009 87.6152L24.5009 71.705L83.2859 71.705L83.2859 97.3519C83.2859 105.048 81.2901 111.479 77.5089 116.014C73.7015 120.581 68.2027 123.079 61.5439 123.079C53.227 123.079 46.8816 119.138 43.3366 112.347L24.5009 125.49ZM43.9318 110.103C44.1343 110.575 44.3496 111.035 44.5776 111.481C47.8488 117.887 53.7213 121.579 61.5439 121.579C74.0557 121.579 81.7859 112.254 81.7859 97.3519L81.7859 73.205L26.0009 73.205L26.0009 86.1152L41.541 86.1152L41.541 97.9895L26.0009 108.748L26.0009 122.615L43.9318 110.103ZM55.5576 104.563C56.8905 106.142 58.8632 107.009 61.5439 107.009C64.2692 107.009 66.2375 106.139 67.5573 104.566C68.9126 102.951 69.7664 100.379 69.7664 96.6347L69.7664 87.6152L53.3214 87.6152L53.3214 96.6347C53.3214 100.371 54.1917 102.945 55.5576 104.563ZM53.8934 190.845C36.3278 190.845 23.5446 177.1 23.5446 158.823C23.5446 140.461 36.4126 126.801 53.8934 126.801C71.3741 126.801 84.2422 140.461 84.2422 158.823C84.2422 177.1 71.459 190.845 53.8934 190.845ZM53.8934 142.87C44.1136 142.87 37.5422 149.699 37.5422 158.823C37.5422 167.947 44.1136 174.776 53.8934 174.776C63.6731 174.776 70.2446 167.947 70.2446 158.823C70.2446 149.699 63.6731 142.87 53.8934 142.87ZM83.2859 229.744L45.6053 229.744C38.4784 229.744 32.895 227.951 29.1005 224.2C25.3028 220.447 23.5446 214.978 23.5446 208.161C23.5446 200.295 26.563 193.203 32.2561 188.804L33.2087 188.068L44.2022 197.229L42.6763 198.366C38.8487 201.218 37.1437 204.167 37.1437 207.524C37.1437 209.805 37.8165 211.307 38.9416 212.272C40.1084 213.274 42.0095 213.913 44.8881 213.913L69.9258 213.913L69.9258 194.309L83.2859 194.309L83.2859 229.744ZM40.5802 198.116C37.3083 200.893 35.6437 203.952 35.6437 207.524C35.6437 212.704 38.7517 215.413 44.8881 215.413L71.4258 215.413L71.4258 195.809L81.7859 195.809L81.7859 228.244L45.6053 228.244C31.8185 228.244 25.0446 221.31 25.0446 208.161C25.0446 200.67 27.9135 194.055 33.1732 189.991L41.7801 197.163C41.3586 197.477 40.9586 197.795 40.5802 198.116ZM36.361 284.189L26.0009 284.189L26.0009 240.996L81.7859 240.996L81.7859 283.153L71.4258 283.153L71.4258 253.826L59.3125 253.826L59.3125 279.726L49.2712 279.726L49.2712 253.826L36.361 253.826L36.361 284.189ZM37.861 255.326L37.861 285.689L24.5009 285.689L24.5009 239.496L83.2859 239.496L83.2859 284.653L69.9258 284.653L69.9258 255.326L60.8125 255.326L60.8125 281.226L47.7712 281.226L47.7712 255.326L37.861 255.326ZM35.1519 346.088L34.0587 345.197C27.1967 339.606 23.5446 331.097 23.5446 321.003C23.5446 302.957 36.1756 289.299 53.8934 289.299C71.6136 289.299 84.2422 302.96 84.2422 321.083C84.2422 330.643 80.9139 338.827 74.7184 344.412L83.2859 344.412L83.2859 396.025L69.7664 396.025L69.7664 378.173L24.5009 378.173L24.5009 362.263L69.7664 362.263L69.7664 344.412L71.1676 344.412L63.06 335.629L64.225 334.615C68.2187 331.139 70.2446 326.842 70.2446 321.72C70.2446 316.86 68.5439 312.79 65.7014 309.939C62.8597 307.088 58.7908 305.369 53.8934 305.369C48.996 305.369 44.9271 307.088 42.0853 309.939C39.2428 312.79 37.5422 316.86 37.5422 321.72C37.5422 326.839 39.5656 331.132 43.6312 334.606L44.816 335.618L35.1519 346.088ZM71.2664 345.912L71.2664 363.763L26.0009 363.763L26.0009 376.673L71.2664 376.673L71.2664 394.525L81.7859 394.525L81.7859 345.912L71.2664 345.912ZM41.549 334.735C41.9015 335.079 42.2708 335.416 42.6567 335.746L35.0062 344.034C28.5511 338.774 25.0446 330.725 25.0446 321.003C25.0446 303.71 37.0782 290.799 53.8934 290.799C70.7086 290.799 82.7422 303.71 82.7422 321.083C82.7422 330.725 79.2357 338.774 72.8603 344.034L65.21 335.746C65.55 335.45 65.8769 335.148 66.1909 334.84C69.8518 331.252 71.7446 326.858 71.7446 321.72C71.7446 311.28 64.4128 303.869 53.8934 303.869C43.3739 303.869 36.0422 311.28 36.0422 321.72C36.0422 326.808 37.898 331.166 41.549 334.735ZM65.8488 437.45L66.6954 435.962C69.53 430.983 70.8821 425.897 70.8821 421.244C70.8821 417.572 70.1878 415.266 69.2703 413.921C68.4028 412.65 67.2796 412.145 66.0067 412.145C65.1811 412.145 64.5515 412.446 63.9734 413.064C63.3476 413.732 62.7856 414.777 62.262 416.224C61.5668 418.144 61.0449 420.43 60.4681 422.955C60.1569 424.318 59.8298 425.751 59.4509 427.234C58.4075 431.317 56.9929 435.633 54.4129 438.935C51.7626 442.328 47.9355 444.58 42.3379 444.58C37.2323 444.58 32.4752 442.45 29.026 438.163C25.5962 433.9 23.5446 427.618 23.5446 419.411C23.5446 410.346 26.2252 401.061 30.3136 395.78L31.0378 394.845L43.5219 400.473L42.4344 401.965C39.1978 406.406 36.9046 413.109 36.9046 419.491C36.9046 423.189 37.5277 425.558 38.3858 426.953C39.1888 428.259 40.2081 428.749 41.3816 428.749C42.2353 428.749 42.8835 428.442 43.4729 427.822C44.1097 427.152 44.6806 426.108 45.2125 424.663C45.7392 423.232 46.1846 421.533 46.6369 419.638C46.7782 419.046 46.9208 418.433 47.0665 417.806C47.3793 416.459 47.7068 415.05 48.0682 413.656C49.1268 409.572 50.5601 405.254 53.1713 401.952C55.8528 398.561 59.7186 396.314 65.3691 396.314C70.5427 396.314 75.3219 398.416 78.7771 402.677C82.2114 406.913 84.2422 413.159 84.2422 421.324C84.2422 428.538 82.527 436.009 79.0699 441.489L78.3999 442.552L65.8488 437.45ZM31.4997 396.699L41.2222 401.082C40.9284 401.485 40.6422 401.905 40.3645 402.341C37.403 406.984 35.4046 413.371 35.4046 419.491C35.4046 427.141 37.9548 430.249 41.3816 430.249C45.7156 430.249 47.0142 424.659 48.5333 418.121C50.6734 408.909 53.2508 397.814 65.3691 397.814C74.8526 397.814 82.7422 405.465 82.7422 421.324C82.7422 428.337 81.0686 435.509 77.8012 440.689L67.999 436.704C68.2501 436.263 68.4902 435.821 68.7193 435.378C71.1815 430.618 72.3821 425.764 72.3821 421.244C72.3821 413.594 69.5132 410.645 66.0067 410.645C61.7436 410.645 60.468 416.223 58.9747 422.752C56.8671 431.968 54.3258 443.08 42.3379 443.08C33.0139 443.08 25.0446 435.35 25.0446 419.411C25.0446 410.565 27.6744 401.64 31.4997 396.699ZM51.9011 39.0442C51.9011 46.9338 55.4872 50.9184 61.5439 50.9184C67.6802 50.9184 71.2664 46.9338 71.2664 39.0442L71.2664 28.5247L51.9011 28.5247L51.9011 39.0442ZM51.8214 96.6347C51.8214 104.524 55.4872 108.509 61.5439 108.509C67.6802 108.509 71.2664 104.524 71.2664 96.6347L71.2664 86.1152L51.8214 86.1152L51.8214 96.6347ZM53.8934 189.345C37.2376 189.345 25.0446 176.356 25.0446 158.823C25.0446 141.211 37.3173 128.301 53.8934 128.301C70.4695 128.301 82.7422 141.211 82.7422 158.823C82.7422 176.356 70.5492 189.345 53.8934 189.345ZM53.8934 141.37C43.2942 141.37 36.0422 148.862 36.0422 158.823C36.0422 168.785 43.2942 176.276 53.8934 176.276C64.4925 176.276 71.7446 168.785 71.7446 158.823C71.7446 148.862 64.4925 141.37 53.8934 141.37Z"
                  fill="#DEDEDE"
                />
              </svg>
            </div> */}
            <div className="title-left">
              <h3>{trans.home.feature_project}</h3>
              <p className="desc">{trans.home.feature_project_description}</p>
              <div id="counter">
                <span class="current">{countSlider}</span>
                <span class="separate"></span>
                <span class="total">{list_project.length}</span>
              </div>
            </div>
            {/* <div>{list_project.id}/{list_project.length}</div> */}

            <Slider
              className="project"
              ref={slider_feature}
              {...setting_project_feature}
            >
              {list_project.length &&
                list_project.map((item, index) => {
                  return (
                    <div key={index} className="item">
                      <div className="inner">
                        <div className="col-left">
                          <img src={item?.logo} alt="eyefire" />
                          <h3>{item?.name}</h3>
                          <p>{item?.description}</p>
                        </div>
                        <div className="col-right">
                          <div className="image img-eyefire">
                            <Link href={`/project/${item.seo_url}`}>
                              <a className="image">
                                <img
                                  src={item?.background_image}
                                  alt="eyefire web"
                                />
                              </a>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </Slider>
            <div className="owl-nav">
              <button
                onClick={() => slider_feature?.current?.slickPrev()}
                type="button"
                role="presentation"
                className="owl-prev disabled"
              >
                <svg
                  width={33}
                  height={33}
                  viewBox="0 0 33 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_400_758)">
                    <path
                      d="M16.4414 0.14014C25.2778 0.140138 32.4414 7.30376 32.4414 16.1401C32.4414 24.9765 25.2778 32.1401 16.4414 32.1401C7.60504 32.1401 0.441412 24.9765 0.441411 16.1401C0.441409 7.30377 7.60503 0.140141 16.4414 0.14014ZM16.4414 29.4735C23.805 29.4734 29.7747 23.5038 29.7747 16.1401C29.7747 8.77651 23.805 2.80683 16.4414 2.80683C9.07778 2.80683 3.1081 8.77652 3.1081 16.1401C3.1081 23.5038 9.07779 29.4735 16.4414 29.4735Z"
                      fill="#0063AA"
                    />
                    <path
                      d="M18.1653 8.53065C18.686 8.00997 19.5302 8.00996 20.0509 8.53065C20.5716 9.05134 20.5716 9.89559 20.0509 10.4163L14.327 16.1402L20.0509 21.864C20.5716 22.3847 20.5716 23.229 20.0509 23.7497C19.5302 24.2703 18.686 24.2703 18.1653 23.7497L11.4986 17.083C10.9779 16.5623 10.9779 15.718 11.4986 15.1973L18.1653 8.53065Z"
                      fill="#0063AA"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_400_758">
                      <rect
                        width={32}
                        height={32}
                        fill="white"
                        transform="matrix(-1 1.74846e-07 1.74846e-07 1 32.4414 0.140137)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <button
                onClick={() => slider_feature?.current?.slickNext()}
                type="button"
                role="presentation"
                className="owl-next"
              >
                <svg
                  width={33}
                  height={33}
                  viewBox="0 0 33 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_400_751)">
                    <path
                      d="M16.4414 0.14014C7.60503 0.140138 0.441405 7.30376 0.441403 16.1401C0.441402 24.9765 7.60502 32.1401 16.4414 32.1401C25.2778 32.1401 32.4414 24.9765 32.4414 16.1401C32.4414 7.30377 25.2778 0.140141 16.4414 0.14014ZM16.4414 29.4735C9.07778 29.4734 3.10809 23.5038 3.10809 16.1401C3.10809 8.77651 9.07778 2.80683 16.4414 2.80683C23.805 2.80683 29.7747 8.77652 29.7747 16.1401C29.7747 23.5038 23.805 29.4735 16.4414 29.4735Z"
                      fill="#0063AA"
                    />
                    <path
                      d="M14.7175 8.53065C14.1969 8.00997 13.3526 8.00996 12.8319 8.53065C12.3112 9.05134 12.3112 9.89559 12.8319 10.4163L18.5558 16.1402L12.8319 21.864C12.3112 22.3847 12.3112 23.229 12.8319 23.7497C13.3526 24.2703 14.1969 24.2703 14.7175 23.7497L21.3842 17.083C21.9049 16.5623 21.9049 15.718 21.3842 15.1973L14.7175 8.53065Z"
                      fill="#0063AA"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_400_751">
                      <rect
                        width={32}
                        height={32}
                        fill="white"
                        transform="translate(0.441406 0.140137)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
            <Link href="/project">
              <a className="read-more d-flex d-md-none">
                {trans.text_button.read_more}
                <svg
                  width={33}
                  height={32}
                  viewBox="0 0 33 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="16.4414" cy={16} r={16} fill="#0063AA" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.44141 16.2491C5.44141 16.0501 5.52042 15.8594 5.66108 15.7187C5.80173 15.5781 5.99249 15.4991 6.19141 15.4991L23.8809 15.4991L19.1604 10.7801C19.0196 10.6392 18.9405 10.4482 18.9405 10.2491C18.9405 10.0499 19.0196 9.85888 19.1604 9.71805C19.3012 9.57722 19.4922 9.49811 19.6914 9.49811C19.8906 9.49811 20.0816 9.57722 20.2224 9.71805L26.2224 15.7181C26.2923 15.7877 26.3477 15.8705 26.3855 15.9616C26.4233 16.0527 26.4427 16.1504 26.4427 16.2491C26.4427 16.3477 26.4233 16.4454 26.3855 16.5365C26.3477 16.6276 26.2923 16.7104 26.2224 16.7801L20.2224 22.7801C20.0816 22.9209 19.8906 23 19.6914 23C19.4922 23 19.3012 22.9209 19.1604 22.7801C19.0196 22.6392 18.9405 22.4482 18.9405 22.2491C18.9405 22.0499 19.0196 21.8589 19.1604 21.7181L23.8809 16.9991L6.19141 16.9991C5.99249 16.9991 5.80173 16.92 5.66108 16.7794C5.52042 16.6387 5.44141 16.448 5.44141 16.2491Z"
                    fill="white"
                  />
                </svg>
              </a>
            </Link>
          </div>
        </div>
        {/* end featured project */}
        {/* member */}
        <div className="r-member">
          <div className="container">
            {/* <div className="label">
              <svg
                width="62"
                height="438"
                viewBox="0 0 62 438"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.38924 16.1409L4.39419 16.1319C7.01468 11.3369 10.624 7.52856 15.2099 4.73228L15.219 4.72672L15.2283 4.72128C19.8871 1.97088 25.1217 0.608031 30.8934 0.608031C36.6649 0.608031 41.8761 1.97086 46.4857 4.72536L46.4903 4.7281C51.1323 7.52451 54.7475 11.3366 57.318 16.1412C59.9429 21.0014 61.2422 26.4292 61.2422 32.3913C61.2422 37.4028 60.3606 41.9675 58.5672 46.06C56.777 50.1984 54.1937 53.6842 50.8206 56.4952L49.7252 57.408L40.0573 46.9344L41.2279 45.9208C45.2678 42.4228 47.2446 38.1559 47.2446 33.0288C47.2446 29.8067 46.5283 26.9858 45.1295 24.5259L45.124 24.5162L45.1186 24.5064C43.7676 22.0455 41.8717 20.1228 39.4061 18.7185C36.945 17.3696 34.1202 16.6777 30.8934 16.6777C27.6666 16.6777 24.8418 17.3697 22.3807 18.7185C19.9138 20.1235 17.9881 22.0492 16.5831 24.5161C15.2342 26.9772 14.5422 29.802 14.5422 33.0288C14.5422 38.1491 16.5399 42.4147 20.6318 45.9149L21.8155 46.9275L12.1491 57.3995L11.0553 56.5029C7.62529 53.6914 5.01082 50.2022 3.21797 46.0563C1.42674 41.9141 0.544585 37.3248 0.544585 32.3116C0.544585 26.4043 1.81647 21.0068 4.38441 16.1501L4.38924 16.1409ZM15.2736 23.7845C16.8143 21.0749 18.9395 18.9498 21.649 17.4091C24.3586 15.9215 27.44 15.1777 30.8934 15.1777C34.3467 15.1777 37.4282 15.9215 40.1378 17.4091C42.8473 18.9498 44.9459 21.0749 46.4335 23.7845C47.9742 26.494 48.7446 29.5755 48.7446 33.0288C48.7446 38.1301 46.9231 42.4761 43.28 46.0669C42.9392 46.4028 42.5825 46.7321 42.2098 47.0548L49.8603 55.3428C53.048 52.6864 55.4919 49.3924 57.192 45.4609C58.8921 41.5825 59.7422 37.226 59.7422 32.3913C59.7422 26.6534 58.4937 21.4734 55.9966 16.8512C53.5527 12.2821 50.1259 8.66941 45.7163 6.01298C41.3597 3.40968 36.4188 2.10803 30.8934 2.10803C25.368 2.10803 20.4005 3.40968 15.9908 6.01298C11.6343 8.66941 8.2075 12.2821 5.71046 16.8512C3.26654 21.4734 2.04459 26.6269 2.04458 32.3116C2.04458 37.1463 2.89464 41.5294 4.59476 45.4609C6.29487 49.3924 8.76535 52.6864 12.0062 55.3428L19.6567 47.0548C19.2706 46.7245 18.9014 46.3873 18.5491 46.0432C14.8778 42.457 13.0422 38.1189 13.0422 33.0288C13.0422 29.5755 13.786 26.494 15.2736 23.7845ZM4.46703 73.5034L4.4704 73.4971C7.08974 68.6486 10.6995 64.8104 15.2896 62.0115L15.2987 62.0059L15.308 62.0005C19.9645 59.2514 25.172 57.8872 30.8934 57.8872C36.6146 57.8872 41.7987 59.2514 46.406 62.0046L46.4106 62.0073C51.0549 64.8051 54.6946 68.6441 57.3164 73.4972L57.3198 73.5034C59.9434 78.4159 61.2422 83.8954 61.2422 89.9096C61.2422 95.9235 59.9435 101.379 57.3164 106.242C54.6953 111.094 51.057 114.932 46.4147 117.73C41.8065 120.539 36.6192 121.932 30.8934 121.932C25.1663 121.932 19.9547 120.538 15.2965 117.732L15.2896 117.728C10.6995 114.929 7.08974 111.091 4.47042 106.242C1.84328 101.379 0.544582 95.9235 0.544582 89.9096C0.544583 83.8954 1.84334 78.4159 4.46703 73.5034ZM22.3807 103.742L22.3905 103.747C24.8503 105.146 27.6713 105.862 30.8934 105.862C34.1155 105.862 36.9364 105.146 39.3963 103.747L39.406 103.742L39.4159 103.736C41.8831 102.382 43.7766 100.51 45.1247 98.1023L45.1303 98.0924L45.1359 98.0826C46.5344 95.6714 47.2446 92.9591 47.2446 89.9096C47.2446 86.8601 46.5344 84.1478 45.1359 81.7366L45.1303 81.7268L45.1247 81.7169C43.7757 79.308 41.8792 77.4062 39.4061 75.9978C36.945 74.6489 34.1202 73.9569 30.8934 73.9569C27.6666 73.9569 24.8418 74.6489 22.3807 75.9978C19.9065 77.4068 17.9799 79.3115 16.5768 81.7267C15.2284 84.1386 14.5422 86.8548 14.5422 89.9096C14.5422 92.9645 15.2285 95.6807 16.577 98.0926C17.9791 100.506 19.9026 102.381 22.3709 103.736L22.3807 103.742ZM15.2736 80.984C16.8143 78.3276 18.9395 76.229 21.649 74.6883C24.3586 73.2007 27.44 72.4569 30.8934 72.4569C34.3467 72.4569 37.4282 73.2007 40.1378 74.6883C42.8473 76.229 44.9459 78.3276 46.4335 80.984C47.9742 83.6404 48.7446 86.6156 48.7446 89.9096C48.7446 93.2036 47.9742 96.1788 46.4335 98.8352C44.9459 101.492 42.8473 103.564 40.1378 105.051C37.4282 106.592 34.3467 107.362 30.8934 107.362C27.44 107.362 24.3586 106.592 21.649 105.051C18.9395 103.564 16.8143 101.492 15.2736 98.8352C13.786 96.1788 13.0422 93.2036 13.0422 89.9096C13.0422 86.6156 13.786 83.6404 15.2736 80.984ZM1.50089 179.402L31.042 179.332L7.39816 165.255L7.39816 157.742L30.4026 143.748L1.50089 143.748L1.50089 128.635L60.2859 128.635L60.2859 141.661L27.0432 161.683L60.2859 181.399L60.2859 194.349L1.50089 194.516L1.50089 179.402ZM58.7859 182.254L58.7859 192.853L3.00089 193.012L3.00089 180.899L36.4719 180.819L8.89816 164.402L8.89816 158.585L35.7546 142.248L3.00089 142.248L3.00089 130.135L58.7859 130.135L58.7859 140.813L24.1195 161.693L58.7859 182.254ZM26.9786 252.937L26.9686 252.931C23.6716 250.79 21.1555 247.738 19.4041 243.84L19.4 243.83C17.7037 239.985 16.8816 235.493 16.8816 230.394L16.8816 220.658L1.50089 220.658L1.50089 204.747L60.2859 204.747L60.2859 230.394C60.2859 235.497 59.4358 239.994 57.682 243.843C55.9307 247.74 53.4151 250.791 50.1191 252.93C46.8132 255.076 42.9338 256.121 38.5439 256.121C34.2023 256.121 30.3291 255.074 26.9786 252.937ZM56.3154 243.225C57.9624 239.612 58.7859 235.335 58.7859 230.394L58.7859 206.247L3.00089 206.247L3.00089 219.158L18.3816 219.158L18.3816 230.394C18.3816 235.335 19.1785 239.612 20.7724 243.225C22.4194 246.891 24.757 249.707 27.7854 251.672C30.8668 253.638 34.453 254.621 38.5439 254.621C42.6879 254.621 46.2741 253.638 49.3024 251.672C52.3307 249.707 54.6684 246.891 56.3154 243.225ZM44.5613 237.566L44.5689 237.557C45.9553 235.91 46.7664 233.363 46.7664 229.677L46.7664 220.658L30.4011 220.658L30.4011 229.677C30.4011 233.366 31.1867 235.918 32.5263 237.566C33.8919 239.182 35.8275 240.051 38.5439 240.051C41.3291 240.051 43.2502 239.173 44.5539 237.575L44.5613 237.566ZM31.3715 238.523C29.7245 236.504 28.9011 233.555 28.9011 229.677L28.9011 219.158L48.2664 219.158L48.2664 229.677C48.2664 233.555 47.4164 236.504 45.7162 238.523C44.0693 240.542 41.6785 241.551 38.5439 241.551C35.4624 241.551 33.0716 240.542 31.3715 238.523ZM58.7859 278.569L58.7859 291.319L3.00089 316.263L3.00089 302.716L14.9548 297.775L14.9548 271.874L3.00089 266.933L3.00089 253.704L58.7859 278.569ZM13.4548 272.878L1.50089 267.937L1.50089 251.394L60.2859 277.595L60.2859 292.292L1.50089 318.577L1.50089 301.712L13.4548 296.772L13.4548 272.878ZM46.1147 284.864L24.757 276.018L24.757 293.71L46.1147 284.864ZM42.1947 284.864L26.257 278.263L26.257 291.465L42.1947 284.864ZM60.2859 374.714L1.50088 374.714L1.50088 361.905L32.6801 336.302L1.50089 336.302L1.50089 320.551L60.2859 320.551L60.2859 333.44L29.116 358.963L60.2859 358.963L60.2859 374.714ZM58.7859 360.463L58.7859 373.214L3.00088 373.214L3.00088 362.615L36.8703 334.802L3.00089 334.802L3.00089 322.051L58.7859 322.051L58.7859 332.73L24.9164 360.463L58.7859 360.463ZM22.7647 413.189L3.00088 413.189L3.00088 400.279L22.9241 400.279L58.7859 378.682L58.7859 392.389L34.0014 407.292L58.7859 422.194L58.7859 434.866L22.7647 413.189ZM36.9123 407.292L60.2859 421.346L60.2859 437.519L22.3482 414.689L1.50088 414.689L1.50088 398.779L22.5073 398.779L60.2859 376.028L60.2859 393.238L36.9123 407.292ZM5.79014 74.2101C3.2931 78.8854 2.04458 84.1186 2.04458 89.9096C2.04458 95.7006 3.2931 100.907 5.79014 105.529C8.28719 110.152 11.714 113.791 16.0705 116.447C20.4802 119.104 25.4211 120.432 30.8934 120.432C36.3656 120.432 41.28 119.104 45.6366 116.447C50.0462 113.791 53.4996 110.152 55.9966 105.529C58.4937 100.907 59.7422 95.7006 59.7422 89.9096C59.7422 84.1186 58.4937 78.8854 55.9966 74.2101C53.4996 69.5879 50.0462 65.9486 45.6366 63.2922C41.28 60.6889 36.3656 59.3872 30.8934 59.3872C25.4211 59.3872 20.4802 60.6889 16.0705 63.2922C11.714 65.9486 8.28719 69.5879 5.79014 74.2101Z"
                  fill="#DEDEDE"
                />
              </svg>
            </div> */}
            <div className="title-center">
              <h3>{trans.home.member}</h3>
              {/* <div
                dangerouslySetInnerHTML={{ __html: trans.about.subTitle }}
              ></div> */}
            </div>
            <div className="image-logo text-center">
              <img src="/assets/images/home/logo.svg" alt="tcom" />
            </div>
            <div className="row" id="system-company">
              <a
                className="col-4"
                id="item_company"
                href="https://tsoft.vn/"
                target="_blank"
              >
                <div className="box">
                  <div className="content-box">
                    <div className="logo tsoft">
                      <img
                        src="/assets/images/home/logo-tcom-software.svg"
                        alt="tcom software"
                      />
                    </div>
                    <ul>
                      <li>{trans.home.sub01_TSoft}</li>
                      <li>{trans.home.sub02_TSoft}</li>
                      <li>{trans.home.sub03_TSoft}</li>
                    </ul>
                  </div>

                  <div className="webdetail">
                    <a
                      href="https://tsoft.vn/"
                      target="_blank"
                      className="btnDetail"
                    >
                      {trans.home.read_more}
                    </a>
                    <a
                      href="https://tsoft.vn/"
                      target="_blank"
                      className="btnDetail"
                    >
                      <svg
                        width={20}
                        height={20}
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M1.25 10.0008C1.25 9.83503 1.31585 9.67606 1.43306 9.55885C1.55027 9.44164 1.70924 9.37579 1.875 9.37579H16.6163L12.6825 5.44329C12.5651 5.32593 12.4992 5.16676 12.4992 5.00079C12.4992 4.83482 12.5651 4.67565 12.6825 4.55829C12.7999 4.44093 12.959 4.375 13.125 4.375C13.291 4.375 13.4501 4.44093 13.5675 4.55829L18.5675 9.55829C18.6257 9.61635 18.6719 9.68532 18.7034 9.76125C18.7349 9.83718 18.7511 9.91858 18.7511 10.0008C18.7511 10.083 18.7349 10.1644 18.7034 10.2403C18.6719 10.3163 18.6257 10.3852 18.5675 10.4433L13.5675 15.4433C13.4501 15.5606 13.291 15.6266 13.125 15.6266C12.959 15.6266 12.7999 15.5606 12.6825 15.4433C12.5651 15.3259 12.4992 15.1668 12.4992 15.0008C12.4992 14.8348 12.5651 14.6756 12.6825 14.5583L16.6163 10.6258H1.875C1.70924 10.6258 1.55027 10.5599 1.43306 10.4427C1.31585 10.3255 1.25 10.1666 1.25 10.0008Z"
                          fill="#0063AA"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </a>
              <a
                id="item_company"
                className="col-4"
                href="https://tcom-japan.com/"
                target="_blank"
              >
                <div className="box">
                  <div className="content-box">
                    <div className="logo t-japan">
                      <img
                        src="/assets/images/home/logo-tcom-japan.svg"
                        alt="tcom japan"
                      />
                    </div>
                    <ul>
                      <li>{trans.home.sub01_TJapan}</li>
                      <li>{trans.home.sub02_TJapan}</li>
                    </ul>
                  </div>
                  <div className="webdetail">
                    <a
                      href="https://tcom-japan.com/"
                      target="_blank"
                      className="btnDetail"
                    >
                      {trans.home.read_more}
                    </a>
                    <a
                      href="https://tcom-japan.com/"
                      target="_blank"
                      className="btnDetail"
                    >
                      <svg
                        width={20}
                        height={20}
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M1.25 10.0008C1.25 9.83503 1.31585 9.67606 1.43306 9.55885C1.55027 9.44164 1.70924 9.37579 1.875 9.37579H16.6163L12.6825 5.44329C12.5651 5.32593 12.4992 5.16676 12.4992 5.00079C12.4992 4.83482 12.5651 4.67565 12.6825 4.55829C12.7999 4.44093 12.959 4.375 13.125 4.375C13.291 4.375 13.4501 4.44093 13.5675 4.55829L18.5675 9.55829C18.6257 9.61635 18.6719 9.68532 18.7034 9.76125C18.7349 9.83718 18.7511 9.91858 18.7511 10.0008C18.7511 10.083 18.7349 10.1644 18.7034 10.2403C18.6719 10.3163 18.6257 10.3852 18.5675 10.4433L13.5675 15.4433C13.4501 15.5606 13.291 15.6266 13.125 15.6266C12.959 15.6266 12.7999 15.5606 12.6825 15.4433C12.5651 15.3259 12.4992 15.1668 12.4992 15.0008C12.4992 14.8348 12.5651 14.6756 12.6825 14.5583L16.6163 10.6258H1.875C1.70924 10.6258 1.55027 10.5599 1.43306 10.4427C1.31585 10.3255 1.25 10.1666 1.25 10.0008Z"
                          fill="#0063AA"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </a>
              <a
                className="col-4"
                id="item_company"
                href="https://eyefire.vn/"
                target="_blank"
              >
                <div className="box">
                  <div className="content-box">
                    <div className="logo eyefire">
                      <img
                        src="/assets/images/home/logo-eyefire.svg"
                        alt="eyefire"
                      />
                    </div>
                    <ul>
                      <li>{trans.home.sub01_TEyefire}</li>
                      <li>{trans.home.sub02_TEyefire}</li>
                    </ul>
                  </div>
                  <div className="webdetail">
                    <a
                      href="https://eyefire.vn/"
                      target="_blank"
                      className="btnDetail"
                    >
                      {trans.home.read_more}
                    </a>
                    <a
                      href="https://eyefire.vn/"
                      target="_blank"
                      className="btnDetail"
                    >
                      <svg
                        width={20}
                        height={20}
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M1.25 10.0008C1.25 9.83503 1.31585 9.67606 1.43306 9.55885C1.55027 9.44164 1.70924 9.37579 1.875 9.37579H16.6163L12.6825 5.44329C12.5651 5.32593 12.4992 5.16676 12.4992 5.00079C12.4992 4.83482 12.5651 4.67565 12.6825 4.55829C12.7999 4.44093 12.959 4.375 13.125 4.375C13.291 4.375 13.4501 4.44093 13.5675 4.55829L18.5675 9.55829C18.6257 9.61635 18.6719 9.68532 18.7034 9.76125C18.7349 9.83718 18.7511 9.91858 18.7511 10.0008C18.7511 10.083 18.7349 10.1644 18.7034 10.2403C18.6719 10.3163 18.6257 10.3852 18.5675 10.4433L13.5675 15.4433C13.4501 15.5606 13.291 15.6266 13.125 15.6266C12.959 15.6266 12.7999 15.5606 12.6825 15.4433C12.5651 15.3259 12.4992 15.1668 12.4992 15.0008C12.4992 14.8348 12.5651 14.6756 12.6825 14.5583L16.6163 10.6258H1.875C1.70924 10.6258 1.55027 10.5599 1.43306 10.4427C1.31585 10.3255 1.25 10.1666 1.25 10.0008Z"
                          fill="#0063AA"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </a>
              {/* <div className="col-4">
                <div className="box">
                  <div className="content-box">
                    <div className="logo sky-live">
                      <img
                        src="/assets/images/home/logo-sky-live.svg"
                        alt="sky live"
                      />
                    </div>
                    <ul>
                      <li>{trans.home.sub01_TSkylive}</li>
                      <li>{trans.home.sub02_TSkylive}</li>
                    </ul>
                  </div>
                  <div className="webdetail">
                    <a
                      href="https://skylive.vn/"
                      target="_blank"
                      className="btnDetail"
                    >
                      {trans.home.read_more}
                    </a>
                    <a
                      href="https://skylive.vn/"
                      target="_blank"
                      className="btnDetail"
                    >
                      <svg
                        width={20}
                        height={20}
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M1.25 10.0008C1.25 9.83503 1.31585 9.67606 1.43306 9.55885C1.55027 9.44164 1.70924 9.37579 1.875 9.37579H16.6163L12.6825 5.44329C12.5651 5.32593 12.4992 5.16676 12.4992 5.00079C12.4992 4.83482 12.5651 4.67565 12.6825 4.55829C12.7999 4.44093 12.959 4.375 13.125 4.375C13.291 4.375 13.4501 4.44093 13.5675 4.55829L18.5675 9.55829C18.6257 9.61635 18.6719 9.68532 18.7034 9.76125C18.7349 9.83718 18.7511 9.91858 18.7511 10.0008C18.7511 10.083 18.7349 10.1644 18.7034 10.2403C18.6719 10.3163 18.6257 10.3852 18.5675 10.4433L13.5675 15.4433C13.4501 15.5606 13.291 15.6266 13.125 15.6266C12.959 15.6266 12.7999 15.5606 12.6825 15.4433C12.5651 15.3259 12.4992 15.1668 12.4992 15.0008C12.4992 14.8348 12.5651 14.6756 12.6825 14.5583L16.6163 10.6258H1.875C1.70924 10.6258 1.55027 10.5599 1.43306 10.4427C1.31585 10.3255 1.25 10.1666 1.25 10.0008Z"
                          fill="#0063AA"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div> */}
              <a
                className="col-4"
                id="item_company"
                href="https://tcomglobal.com"
                target="_blank"
              >
                <div className="box">
                  <div className="content-box">
                    <div className="logo blockchain">
                      <img
                        src="/assets/images/home/logo_tcom_global.svg"
                        alt="blockchain"
                      />
                    </div>
                    <ul>
                      <li>{trans.home.sub01_TGo}</li>
                      {trans.home.sub02_TGo ? (
                        <li>{trans.home.sub02_TGo}</li>
                      ) : (
                        ''
                      )}
                    </ul>
                  </div>
                  <div className="webdetail">
                    <a
                      href="https://tcomglobal.com"
                      className="btnDetail"
                      target="_blank"
                    >
                      {trans.home.read_more}
                    </a>
                    <a
                      href="https://tcomglobal.com"
                      className="btnDetail"
                      target="_blank"
                    >
                      <svg
                        width={20}
                        height={20}
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M1.25 10.0008C1.25 9.83503 1.31585 9.67606 1.43306 9.55885C1.55027 9.44164 1.70924 9.37579 1.875 9.37579H16.6163L12.6825 5.44329C12.5651 5.32593 12.4992 5.16676 12.4992 5.00079C12.4992 4.83482 12.5651 4.67565 12.6825 4.55829C12.7999 4.44093 12.959 4.375 13.125 4.375C13.291 4.375 13.4501 4.44093 13.5675 4.55829L18.5675 9.55829C18.6257 9.61635 18.6719 9.68532 18.7034 9.76125C18.7349 9.83718 18.7511 9.91858 18.7511 10.0008C18.7511 10.083 18.7349 10.1644 18.7034 10.2403C18.6719 10.3163 18.6257 10.3852 18.5675 10.4433L13.5675 15.4433C13.4501 15.5606 13.291 15.6266 13.125 15.6266C12.959 15.6266 12.7999 15.5606 12.6825 15.4433C12.5651 15.3259 12.4992 15.1668 12.4992 15.0008C12.4992 14.8348 12.5651 14.6756 12.6825 14.5583L16.6163 10.6258H1.875C1.70924 10.6258 1.55027 10.5599 1.43306 10.4427C1.31585 10.3255 1.25 10.1666 1.25 10.0008Z"
                          fill="#0063AA"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        {/* end member */}
        {/* achievement */}
        <div className="r-achievement">
          <div className="container">
            {/* <div className="label">
              <svg
                width="61"
                height="246"
                viewBox="0 0 61 246"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.19231 18.0898L46.4578 18.0898L46.4578 0.238647L59.9773 0.238647L59.9773 51.8513L46.4578 51.8513L46.4578 34.0001L1.19231 34.0001L1.19231 18.0898ZM2.69231 32.5001L2.69231 19.5898L47.9578 19.5898L47.9578 1.73865L58.4773 1.73865L58.4773 50.3513L47.9578 50.3513L47.9578 32.5001L2.69231 32.5001ZM11.8433 108.301L10.7501 107.411C3.88809 101.819 0.235988 93.3105 0.235989 83.2165C0.23599 65.1708 12.8671 51.5129 30.5848 51.5129C48.3051 51.5129 60.9336 65.1735 60.9336 83.2962C60.9336 93.3117 57.2811 101.816 50.5063 107.405L49.4118 108.308L39.7514 97.8422L40.9164 96.8282C44.9101 93.3522 46.936 89.0555 46.936 83.9337C46.936 79.0738 45.2353 75.0036 42.3928 72.1522C39.5511 69.3014 35.4822 67.5825 30.5848 67.5825C25.6874 67.5825 21.6185 69.3014 18.7767 72.1522C15.9343 75.0036 14.2336 79.0738 14.2336 83.9337C14.2336 89.0529 16.257 93.3451 20.3226 96.8193L21.5075 97.8318L11.8433 108.301ZM18.2405 96.9481C18.593 97.2927 18.9622 97.6299 19.3481 97.9596L11.6976 106.248C5.24247 100.988 1.73599 92.939 1.73599 83.2165C1.73599 65.9231 13.7696 53.0129 30.5848 53.0129C47.4 53.0129 59.4336 65.9231 59.4336 83.2962C59.4336 92.939 55.9271 100.988 49.5517 106.248L41.9012 97.9596C42.2412 97.6637 42.5682 97.3618 42.8823 97.054C46.5432 93.4656 48.436 89.0715 48.436 83.9337C48.436 73.4939 41.1042 66.0825 30.5848 66.0825C20.0653 66.0825 12.7336 73.4939 12.7336 83.9337C12.7336 89.021 14.5894 93.3793 18.2405 96.9481ZM30.5848 172.837C13.0192 172.837 0.235985 159.091 0.235986 140.814C0.235987 122.452 13.104 108.792 30.5848 108.792C48.0655 108.792 60.9336 122.452 60.9336 140.814C60.9336 159.091 48.1504 172.837 30.5848 172.837ZM30.5848 124.862C20.805 124.862 14.2336 131.69 14.2336 140.814C14.2336 149.939 20.805 156.767 30.5848 156.767C40.3645 156.767 46.936 149.939 46.936 140.814C46.936 131.69 40.3645 124.862 30.5848 124.862ZM1.1923 245.421L1.1923 230.307L30.7334 230.237L7.08957 216.16L7.08957 208.646L30.0939 194.653L1.1923 194.653L1.1923 179.539L59.9773 179.539L59.9773 192.566L26.7346 212.588L59.9773 232.304L59.9773 245.253L1.1923 245.421ZM23.8109 212.598L58.4773 191.718L58.4773 181.039L2.6923 181.039L2.6923 193.153L35.446 193.153L8.58957 209.49L8.58957 215.307L36.1633 231.724L2.6923 231.804L2.6923 243.917L58.4773 243.758L58.4773 233.158L23.8109 212.598ZM30.5848 171.337C13.929 171.337 1.73599 158.347 1.73599 140.814C1.73599 123.202 14.0087 110.292 30.5848 110.292C47.1609 110.292 59.4336 123.202 59.4336 140.814C59.4336 158.347 47.2406 171.337 30.5848 171.337ZM30.5848 123.362C19.9856 123.362 12.7336 130.853 12.7336 140.814C12.7336 150.776 19.9856 158.267 30.5848 158.267C41.1839 158.267 48.436 150.776 48.436 140.814C48.436 130.853 41.1839 123.362 30.5848 123.362Z"
                  fill="white"
                />
              </svg>
            </div> */}
            <div className="row">
              <div className="col-12 col-md-6 col-left">
                <div className="title-left">
                  <h3>{trans.home.achievement}</h3>
                  <p className="desc">{trans.home.member_description}</p>
                  <div className="image">
                    <img
                      src="/assets/images/home/achievement-img-1.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-right">
                <div className="row">
                  <div className="col-6">
                    <div className="box box-1">
                      <div className="icon">
                        <img
                          src="/assets/images/home/icon-project.png"
                          alt=""
                        />
                      </div>
                      <div className="number">500+</div>
                      <h3>{trans.home.project}</h3>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="box box-2">
                      <div className="icon">
                        <img
                          src="/assets/images/home/icon-customer.png"
                          alt=""
                        />
                      </div>
                      <div className="number">200+</div>
                      <h3>{trans.home.customer}</h3>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="box box-3">
                      <div className="icon">
                        <img
                          src="/assets/images/home/icon-engineer.png"
                          alt=""
                        />
                      </div>
                      <div className="number">100+</div>
                      <h3>{trans.home.engineer}</h3>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="box box-4">
                      <div className="icon">
                        <img src="/assets/images/home/icon-expert.png" alt="" />
                      </div>
                      <div className="number">10+</div>
                      <h3>{trans.home.expert}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end achievement */}

        <div className='r-certificate'>
          <div className="fade-overlay left" />
          <div className="container">
            <div className='title-center'>
              <h3>{trans.home.certificate_title}</h3>
            </div>

            <div className="image-gallery-wrapper">
              <div className="image-gallery">
                <div className="image-row row-1">
                  <img src="/assets/images/home/award-01.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-02.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-03.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-04.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-05.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-06.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-07.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-08.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-09.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-10.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-11.jpg" alt="Office Image" className="gallery-img" />
                  {/* Duplicated for seamless scroll */}
                  <img src="/assets/images/home/award-01.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-02.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-03.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-04.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-05.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-06.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-07.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-08.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-09.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-10.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-11.jpg" alt="Office Image" className="gallery-img" />
                </div>
                <div className="image-row row-2">
                  <img src="/assets/images/home/award-12.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-13.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-14.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-15.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-16.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-17.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-18.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-19.jpg" alt="Office Image" className="gallery-img" />
                  {/* Duplicated for seamless scroll */}
                  <img src="/assets/images/home/award-12.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-13.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-14.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-15.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-16.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-17.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-18.jpg" alt="Office Image" className="gallery-img" />
                  <img src="/assets/images/home/award-19.jpg" alt="Office Image" className="gallery-img" />
                </div>
              </div>
            </div>
            <div className="cards-wrapper">
              <div className="card certifications-card">
                <h3 className="card-title">Certifications</h3>
                <div className="cert-items">
                  <div className="cert-item">
                    <div className="icon-wrapper merged-icon">
                      <img
                        src="/assets/images/home/LOGO-SMG-ISO-9001.png"
                        alt="Certification Icon part"
                      />
                    </div>
                    <p className="cert-name">SMG</p>
                    <p className="cert-standard">ISO 9001:2015</p>
                  </div>
                  <div className="cert-item">
                    <div className="icon-wrapper merged-icon">
                      <img
                        src="/assets/images/home/LOGO-SMG-ISO-27001.png"
                        alt="Certification Icon part"
                      />
                    </div>
                    <p className="cert-name dark">SMG</p>
                    <p className="cert-standard dark">ISO 27001:2022</p>
                  </div>
                </div>
              </div>
              <div className="card awards-card">
                <h3 className="card-title">Awards</h3>
                <div className="award-items">
                  <div className="award-item">
                    <div className="icon-wrapper merged-icon-small">
                      <img
                        src="/assets/images/home/sao-khue-2023.png"
                        alt="Award icon part"
                      />
                    </div>
                    <p className="award-text">
                      <strong>{trans.home.sao_khue_2023}</strong>
                      <br />
                      EYEFIRE School
                    </p>
                  </div>
                  <div className="award-item">
                    <div className="icon-wrapper">
                      <img
                        src="/assets/images/home/sao-khue-2024.png"
                        alt="Sao Khuê 2024 Award"
                      />
                    </div>
                    <p className="award-text">
                      <strong>{trans.home.sao_khue_2024}</strong>
                      <br />
                      EYEFIRE Face Recognition
                    </p>
                  </div>
                  <div className="award-item">
                    <div className="icon-wrapper">
                      <img
                        src="/assets/images/home/sao-khue-2024.png"
                        alt="Sao Khuê 2024 Award"
                      />
                    </div>
                    <p className="award-text">
                      <strong>Sao Khuê 2024</strong>
                      <br />
                      EYEFIRE Safety
                    </p>
                  </div>
                  <div className="award-item">
                    <div className="icon-wrapper">
                      <img
                        src="/assets/images/home/vn-top.png"
                        alt="Top10ICT 2025 Award"
                      />
                    </div>
                    <p className="award-text">
                      <strong>Top10ICT 2025</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <img src="/assets/images/home/deco-01.png" alt="Decorative swirl" class="deco-img-1"></img>
              <img src="/assets/images/home/deco-02.png" alt="Decorative swirl" class="deco-img-2"></img>
          </div>
          <div className="fade-overlay right" />
        </div>

        {/* customer */}
        <div className="r-customer">
          <div className="container">
            {/* <div className="label">
              <svg
                width="61"
                height="524"
                viewBox="0 0 61 524"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.8433 56.8173L10.7501 55.9266C3.88809 50.3353 0.235991 41.8265 0.235991 31.7325C0.235992 13.6868 12.8671 0.0289133 30.5848 0.0289141C48.3051 0.0289149 60.9336 13.6895 60.9336 31.8122C60.9336 41.8277 57.2811 50.3315 50.5063 55.9208L49.4118 56.8237L39.7514 46.3582L40.9164 45.3442C44.9101 41.8682 46.936 37.5715 46.936 32.4497C46.936 27.5898 45.2353 23.5197 42.3928 20.6682C39.5511 17.8174 35.4822 16.0985 30.5848 16.0985C25.6874 16.0985 21.6185 17.8174 18.7767 20.6682C15.9343 23.5197 14.2336 27.5898 14.2336 32.4497C14.2336 37.569 16.257 41.8611 20.3226 45.3353L21.5075 46.3478L11.8433 56.8173ZM18.2405 45.4641C18.593 45.8087 18.9622 46.1459 19.3481 46.4757L11.6976 54.7637C5.24248 49.504 1.73599 41.455 1.73599 31.7325C1.73599 14.4391 13.7696 1.52891 30.5848 1.52891C47.4 1.52891 59.4336 14.4392 59.4336 31.8122C59.4336 41.455 55.9271 49.504 49.5517 54.7637L41.9012 46.4757C41.9012 46.4756 41.9011 46.4757 41.9012 46.4757C42.2411 46.1798 42.5683 45.8778 42.8823 45.57C46.5432 41.9817 48.436 37.5875 48.436 32.4497C48.436 22.01 41.1042 14.5985 30.5848 14.5985C20.0653 14.5985 12.7336 22.01 12.7336 32.4497C12.7336 37.5371 14.5894 41.8953 18.2405 45.4641ZM59.9773 114.562L27.2377 114.562C18.7458 114.562 11.9453 112.125 7.26869 107.437C2.59304 102.751 0.235988 96.0115 0.235989 87.7995C0.235989 79.5875 2.59304 72.8481 7.26869 68.1617C11.9453 63.4743 18.7458 61.0369 27.2377 61.0369L59.9773 61.0369L59.9773 76.9471L27.7158 76.9471C22.6004 76.9471 19.2775 78.067 17.2414 79.8602C15.2425 81.6205 14.2336 84.2539 14.2336 87.8792C14.2336 91.5481 15.2445 94.1777 17.2388 95.9258C19.2728 97.7087 22.5945 98.8113 27.7158 98.8113L59.9773 98.8113L59.9773 114.562ZM27.2377 62.5369C10.821 62.5369 1.73599 71.9406 1.73599 87.7995C1.73599 103.658 10.821 113.062 27.2377 113.062L58.4773 113.062L58.4773 100.311L27.7158 100.311C17.1167 100.311 12.7336 95.7688 12.7336 87.8792C12.7336 80.0693 17.1167 75.4471 27.7158 75.4471L58.4773 75.4471L58.4773 62.5369L27.2377 62.5369ZM42.5403 162.188L43.3868 160.7C46.2214 155.721 47.5735 150.635 47.5735 145.982C47.5735 142.31 46.8792 140.004 45.9617 138.659C45.0942 137.388 43.971 136.883 42.6981 136.883C41.8726 136.883 41.2429 137.184 40.6648 137.802C40.039 138.47 39.477 139.515 38.9534 140.962C38.2582 142.882 37.7363 145.168 37.1595 147.693C36.8483 149.056 36.5212 150.489 36.1423 151.972C35.0989 156.055 33.6843 160.371 31.1043 163.673C28.454 167.066 24.627 169.318 19.0293 169.318C13.9237 169.318 9.16658 167.188 5.71744 162.901C2.28763 158.638 0.235986 152.356 0.235986 144.149C0.235987 135.084 2.91658 125.799 7.00502 120.518L7.72917 119.583L20.2133 125.211L19.1258 126.703C15.8893 131.144 13.5961 137.847 13.5961 144.229C13.5961 147.927 14.2191 150.296 15.0772 151.691C15.8802 152.997 16.8996 153.487 18.073 153.487C18.9267 153.487 19.5749 153.18 20.1643 152.56C20.8011 151.89 21.3721 150.846 21.9039 149.401C22.4307 147.97 22.876 146.271 23.3283 144.376C23.4697 143.784 23.6122 143.171 23.758 142.543C24.0708 141.197 24.3982 139.788 24.7596 138.394C25.8182 134.31 27.2515 129.992 29.8627 126.69C32.5442 123.299 36.41 121.052 42.0606 121.052C47.2341 121.052 52.0133 123.154 55.4685 127.415C58.9028 131.651 60.9336 137.897 60.9336 146.062C60.9336 153.276 59.2184 160.747 55.7613 166.227L55.0913 167.29L42.5403 162.188ZM8.1911 121.437L17.9136 125.82C17.6198 126.223 17.3336 126.643 17.0559 127.079C14.0945 131.722 12.0961 138.109 12.0961 144.229C12.0961 151.879 14.6462 154.987 18.073 154.987C22.407 154.987 23.7057 149.397 25.2247 142.859C27.3648 133.647 29.9423 122.552 42.0606 122.552C51.544 122.552 59.4336 130.203 59.4336 146.062C59.4336 153.075 57.76 160.247 54.4926 165.427L44.6904 161.443C44.9415 161.001 45.1816 160.559 45.4108 160.116C47.8729 155.356 49.0735 150.502 49.0735 145.982C49.0735 138.332 46.2046 135.383 42.6981 135.383C38.435 135.383 37.1594 140.961 35.6662 147.49C33.5585 156.706 31.0172 167.818 19.0293 167.818C9.70527 167.818 1.73599 160.088 1.73599 144.149C1.73599 135.303 4.36585 126.378 8.1911 121.437ZM1.1923 185.917L46.4578 185.917L46.4578 168.066L59.9773 168.066L59.9773 219.678L46.4578 219.678L46.4578 201.827L1.1923 201.827L1.1923 185.917ZM2.6923 200.327L2.6923 187.417L47.9578 187.417L47.9578 169.566L58.4773 169.566L58.4773 218.178L47.9578 218.178L47.9578 200.327L2.6923 200.327ZM30.5848 283.385C13.0192 283.385 0.235981 269.639 0.235981 251.362C0.235982 233 13.104 219.34 30.5848 219.34C48.0655 219.34 60.9336 233 60.9336 251.362C60.9336 269.639 48.1504 283.385 30.5848 283.385ZM30.5848 235.409C20.805 235.409 14.2336 242.238 14.2336 251.362C14.2336 260.486 20.805 267.315 30.5848 267.315C40.3645 267.315 46.936 260.486 46.936 251.362C46.936 242.238 40.3645 235.409 30.5848 235.409ZM1.19229 355.969L1.19229 340.855L30.7334 340.785L7.08956 326.708L7.08956 319.194L30.0939 305.2L1.19229 305.2L1.19229 290.087L59.9773 290.087L59.9773 303.114L26.7346 323.136L59.9773 342.852L59.9773 355.801L1.19229 355.969ZM23.8109 323.145L58.4773 302.266L58.4773 291.587L2.69229 291.587L2.69229 303.7L35.446 303.7L8.58956 320.037L8.58956 325.855L36.1633 342.272L2.69229 342.351L2.69229 354.465L58.4773 354.305L58.4773 343.706L23.8109 323.145ZM13.0524 410.893L2.69229 410.893L2.69229 367.7L58.4773 367.7L58.4773 409.857L48.1172 409.857L48.1172 380.531L36.0039 380.531L36.0039 406.431L25.9626 406.431L25.9626 380.531L13.0524 380.531L13.0524 410.893ZM14.5524 382.031L14.5524 412.393L1.19229 412.393L1.19229 366.2L59.9773 366.2L59.9773 411.357L46.6172 411.357L46.6172 382.031L37.5039 382.031L37.5039 407.931L24.4626 407.931L24.4626 382.031L14.5524 382.031ZM1.19229 473.451L1.19229 455.923L16.7324 445.164L16.7324 435.576L1.19229 435.576L1.19229 419.666L59.9773 419.666L59.9773 445.313C59.9773 453.009 57.9815 459.44 54.2003 463.975C50.3928 468.542 44.8941 471.039 38.2353 471.039C29.9183 471.039 23.573 467.099 20.028 460.308L1.19229 473.451ZM20.6232 458.064C20.8257 458.536 21.041 458.996 21.2689 459.442C24.5402 465.848 30.4127 469.539 38.2353 469.539C50.7471 469.539 58.4773 460.215 58.4773 445.313L58.4773 421.166L2.69229 421.166L2.69229 434.076L18.2324 434.076L18.2324 445.95L2.69229 456.709L2.69229 470.575L20.6232 458.064ZM32.2489 452.524C33.5818 454.102 35.5546 454.97 38.2353 454.97C40.9606 454.97 42.9289 454.1 44.2487 452.527C45.6039 450.912 46.4578 448.34 46.4578 444.595L46.4578 435.576L30.0128 435.576L30.0128 444.595C30.0128 448.332 30.8831 450.906 32.2489 452.524ZM42.5402 516.136L43.3868 514.649C46.2214 509.669 47.5735 504.583 47.5735 499.93C47.5735 496.258 46.8792 493.952 45.9617 492.607C45.0942 491.336 43.971 490.831 42.6981 490.831C41.8725 490.831 41.2429 491.132 40.6648 491.75C40.039 492.418 39.477 493.463 38.9534 494.91C38.2582 496.83 37.7363 499.116 37.1595 501.642C36.8483 503.004 36.5212 504.437 36.1423 505.92C35.0989 510.003 33.6843 514.32 31.1043 517.622C28.454 521.014 24.6269 523.266 19.0293 523.266C13.9237 523.266 9.16657 521.136 5.71742 516.849C2.28761 512.586 0.23597 506.304 0.235971 498.097C0.235971 489.032 2.91657 479.748 7.00501 474.467L7.72916 473.531L20.2133 479.159L19.1258 480.651C15.8892 485.092 13.596 491.795 13.596 498.177C13.596 501.875 14.2191 504.244 15.0772 505.64C15.8802 506.945 16.8995 507.436 18.073 507.436C18.9267 507.436 19.5749 507.128 20.1643 506.508C20.8011 505.839 21.372 504.794 21.9039 503.349C22.4306 501.919 22.876 500.219 23.3283 498.325C23.4696 497.733 23.6122 497.119 23.7579 496.492C24.0707 495.145 24.3982 493.736 24.7596 492.342C25.8182 488.258 27.2515 483.94 29.8627 480.638C32.5442 477.247 36.41 475.001 42.0605 475.001C47.2341 475.001 52.0133 477.102 55.4685 481.364C58.9028 485.6 60.9336 491.845 60.9336 500.01C60.9336 507.224 59.2184 514.695 55.7613 520.176L55.0913 521.238L42.5402 516.136ZM8.19109 475.385L17.9136 479.768C17.6198 480.171 17.3336 480.591 17.0559 481.027C14.0944 485.67 12.096 492.057 12.096 498.177C12.096 505.828 14.6462 508.936 18.073 508.936C22.407 508.936 23.7057 503.346 25.2247 496.807C27.3648 487.595 29.9422 476.501 42.0605 476.501C51.544 476.501 59.4336 484.151 59.4336 500.01C59.4336 507.023 57.76 514.195 54.4926 519.375L44.6904 515.391C44.9415 514.95 45.1816 514.507 45.4108 514.064C47.8729 509.304 49.0735 504.451 49.0735 499.93C49.0735 492.28 46.2046 489.331 42.6981 489.331C38.435 489.331 37.1594 494.909 35.6661 501.438C33.5585 510.654 31.0172 521.766 19.0293 521.766C9.70525 521.766 1.73597 514.036 1.73597 498.097C1.73597 489.251 4.36583 480.326 8.19109 475.385ZM30.5848 281.885C13.929 281.885 1.73598 268.895 1.73598 251.362C1.73598 233.75 14.0087 220.84 30.5848 220.84C47.1609 220.84 59.4336 233.75 59.4336 251.362C59.4336 268.895 47.2406 281.885 30.5848 281.885ZM30.5848 233.909C19.9856 233.909 12.7336 241.401 12.7336 251.362C12.7336 261.324 19.9856 268.815 30.5848 268.815C41.1839 268.815 48.436 261.324 48.436 251.362C48.436 241.401 41.1839 233.909 30.5848 233.909ZM28.5128 444.595C28.5128 452.485 32.1786 456.47 38.2353 456.47C44.3716 456.47 47.9578 452.485 47.9578 444.595L47.9578 434.076L28.5128 434.076L28.5128 444.595Z"
                  fill="#DEDEDE"
                />
              </svg>
            </div> */}
            <div className="title-center">
              <h3>{trans.home.customer_title}</h3>
              <p className="desc">{trans.home.customer_description}</p>
            </div>
          </div>
          <div className="container-fluid">
            <ul className="brands-list">
              <li>
                <img
                  src="/assets/images/about/customer/fujitsu.svg"
                  alt="Fujitsu"
                />
              </li>
              <li>
                <img
                  src="/assets/images/about/customer/viettel.svg"
                  alt="Viettel"
                />
              </li>
              <li>
                <img
                  src="/assets/images/about/customer/ricoh.svg"
                  alt="Ricoh"
                />
              </li>
              <li>
                <img
                  src="/assets/images/about/customer/qualcom.svg"
                  alt="QUALCOMM"
                />
              </li>
              <li>
                <img
                  src="/assets/images/about/customer/intel.svg"
                  alt="Intel"
                />
              </li>
              <li>
                <img
                  src="/assets/images/about/customer/robot.svg"
                  alt="Robot&Facom"
                />
              </li>
              <li>
                <img src="/assets/images/about/customer/fpt.svg" alt="FPT" />
              </li>
              <li>
                <img
                  src="/assets/images/about/customer/luvina.svg"
                  alt="Luvina"
                />
              </li>
              <li>
                <img
                  src="/assets/images/about/customer/trinam.svg"
                  alt="Tri nam group"
                />
              </li>
              <li>
                <img
                  src="/assets/images/about/customer/tueduc.svg"
                  alt="Tue duc"
                />
              </li>
              <li>
                <img src="/assets/images/about/customer/nhg.svg" alt="NHG" />
              </li>
              <li>
                <img
                  src="/assets/images/about/customer/dhvinh.svg"
                  alt="Vinh university"
                />
              </li>
              <li>
                <img
                  src="/assets/images/about/customer/bogddt.svg"
                  alt="Bộ GD-ĐT"
                />
              </li>
              <li>
                <img
                  src="/assets/images/about/customer/bkhn.svg"
                  alt="Dai hoc bach khoa"
                />
              </li>
              <li>
                <img
                  src="/assets/images/about/customer/uneti.svg"
                  alt="UNETI"
                />
              </li>
            </ul>
          </div>
          <div
            className="map"
            // style={{ textAlign: 'center' }}
          >
            <img
              className="w-100"
              src="/assets/images/map-new.webp"
              alt="map"
            />
            {/* <img className='w-100' src='/public/assets/images/home/map.svg' alt='map' /> */}
            {/* ảnh SVG phần map ở  */}
          </div>
        </div>
        {/* end customer */}

        {/* news */}
        {trans.seoVN && (
          <div className="r-news">
            <div className="container">
              {/* <div className="label">
                <svg
                  width="61"
                  height="254"
                  viewBox="0 0 61 254"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M59.7429 38.4119L59.7429 54.1628L0.957929 54.1628L0.95793 41.3545L32.1371 15.7509L0.957931 15.7508L0.957932 -2.61137e-06L59.7429 -4.18016e-08L59.7429 12.8893L28.573 38.4119L59.7429 38.4119ZM24.3735 39.9119L58.2429 12.1788L58.2429 1.5L2.45793 1.5L2.45793 14.2509L36.3274 14.2509L2.45793 42.0636L2.45793 52.6628L58.2429 52.6628L58.2429 39.9119L24.3735 39.9119ZM12.818 109.055L2.45793 109.055L2.45793 65.8613L58.2429 65.8613L58.2429 108.019L47.8828 108.019L47.8828 78.6918L35.7695 78.6918L35.7695 104.592L25.7282 104.592L25.7282 78.6918L12.818 78.6918L12.818 109.055ZM14.318 80.1918L14.318 110.555L0.957927 110.555L0.957929 64.3613L59.7429 64.3613L59.7429 109.519L46.3828 109.519L46.3828 80.1918L37.2695 80.1918L37.2695 106.092L24.2282 106.092L24.2282 80.1918L14.318 80.1918ZM59.7429 189.425L59.7429 204.933L0.957923 185.702L0.957924 169.658L35.4479 158.452L0.957925 146.883L0.957926 130.931L59.7429 111.616L59.7429 128.17L23.8437 139.698L59.7429 151.738L59.7429 165.863L23.5601 177.535L59.7429 189.425ZM18.7153 177.522L58.2429 164.771L58.2429 152.817L19.034 139.667L58.2429 127.076L58.2429 113.688L2.45793 132.017L2.45793 145.804L40.2323 158.475L2.45792 170.748L2.45792 184.614L58.2429 202.864L58.2429 190.511L18.7153 177.522ZM42.3059 246.439L43.1524 244.952C45.987 239.972 47.3391 234.886 47.3391 230.233C47.3391 226.561 46.6448 224.255 45.7273 222.91C44.8598 221.639 43.7366 221.134 42.4637 221.134C41.6382 221.134 41.0086 221.435 40.4304 222.053C39.8046 222.722 39.2426 223.766 38.719 225.213C38.0238 227.133 37.5019 229.419 36.9251 231.945C36.614 233.307 36.2868 234.74 35.9079 236.223C34.8645 240.306 33.45 244.623 30.87 247.925C28.2196 251.317 24.3926 253.569 18.7949 253.569C13.6893 253.569 8.9322 251.439 5.48306 247.152C2.05325 242.889 0.00160709 236.607 0.00160745 228.4C0.00160784 219.335 2.6822 210.051 6.77064 204.77L7.4948 203.834L19.9789 209.462L18.8915 210.955C15.6549 215.395 13.3617 222.098 13.3617 228.48C13.3617 232.178 13.9847 234.547 14.8428 235.943C15.6458 237.248 16.6652 237.739 17.8386 237.739C18.6924 237.739 19.3405 237.431 19.9299 236.811C20.5667 236.142 21.1377 235.097 21.6695 233.652C22.1963 232.222 22.6416 230.522 23.0939 228.628C23.2353 228.036 23.3779 227.422 23.5236 226.795C23.8364 225.448 24.1638 224.039 24.5253 222.645C25.5838 218.561 27.0171 214.243 29.6283 210.941C32.3099 207.55 36.1757 205.304 41.8262 205.304C46.9997 205.304 51.7789 207.405 55.2342 211.667C58.6684 215.903 60.6992 222.148 60.6992 230.313C60.6992 237.527 58.984 244.998 55.527 250.479L54.8569 251.541L42.3059 246.439ZM7.95672 205.688L17.6793 210.071C17.3854 210.474 17.0992 210.894 16.8215 211.33C13.8601 215.973 11.8617 222.36 11.8617 228.48C11.8617 236.131 14.4118 239.239 17.8386 239.239C22.1726 239.239 23.4713 233.649 24.9903 227.11C27.1304 217.898 29.7079 206.804 41.8262 206.804C51.3096 206.804 59.1992 214.454 59.1992 230.313C59.1992 237.326 57.5257 244.498 54.2583 249.678L44.456 245.694C44.7071 245.253 44.9472 244.81 45.1764 244.367C47.6386 239.607 48.8391 234.754 48.8391 230.233C48.8391 222.583 45.9702 219.634 42.4637 219.634C38.2006 219.634 36.925 225.212 35.4318 231.741C33.3241 240.957 30.7828 252.069 18.7949 252.069C9.47089 252.069 1.50161 244.339 1.50161 228.4C1.50161 219.554 4.13147 210.629 7.95672 205.688Z"
                    fill="#DEDEDE"
                  />
                </svg>
              </div> */}
              <div className="title-center">
                <h3>{trans.home.news_title}</h3>
              </div>
              <div className="top">
                <h5>{trans.home.news_ask}</h5>
                {total_new_post > 3 ? (
                  <Link href="/news">
                    <a className="btn-readmore">
                      {trans.text_button.read_more}
                      <svg
                        width={33}
                        height={33}
                        viewBox="0 0 33 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="16.4414"
                          cy="16.1406"
                          r={16}
                          fill="#0063AA"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M5.44141 16.3897C5.44141 16.1908 5.52042 16 5.66108 15.8593C5.80173 15.7187 5.99249 15.6397 6.19141 15.6397L23.8809 15.6397L19.1604 10.9207C19.0196 10.7798 18.9405 10.5888 18.9405 10.3897C18.9405 10.1905 19.0196 9.99951 19.1604 9.85868C19.3012 9.71785 19.4922 9.63873 19.6914 9.63873C19.8906 9.63873 20.0816 9.71785 20.2224 9.85868L26.2224 15.8587C26.2923 15.9283 26.3477 16.0111 26.3855 16.1022C26.4233 16.1933 26.4427 16.291 26.4427 16.3897C26.4427 16.4883 26.4233 16.586 26.3855 16.6771C26.3477 16.7682 26.2923 16.851 26.2224 16.9207L20.2224 22.9207C20.0816 23.0615 19.8906 23.1406 19.6914 23.1406C19.4922 23.1406 19.3012 23.0615 19.1604 22.9207C19.0196 22.7798 18.9405 22.5888 18.9405 22.3897C18.9405 22.1905 19.0196 21.9995 19.1604 21.8587L23.8809 17.1397L6.19141 17.1397C5.99249 17.1397 5.80173 17.0607 5.66108 16.92C5.52042 16.7794 5.44141 16.5886 5.44141 16.3897Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </Link>
                ) : (
                  ''
                )}
              </div>
              {list_new_post &&
                list_new_post.map((item, index) => {
                  return (
                    <div className="news-item">
                      <div className="content">
                        <Link href={`/news/${item.seo_url}`}>
                          <a className="title">{item.title}</a>
                        </Link>
                        <div className="date">
                          <img
                            src="/assets/images/home/icon-calendar.png"
                            alt="calendar"
                          />
                          {moment(item?.show_date || item?.createdAt).format(
                            'DD/MM/YYYY',
                          )}
                        </div>
                        <p>{stripHtml(item.html_content)}</p>
                        <Link href={`/news/${item.seo_url}`}>
                          <a className="readmore">
                            {trans.text_button.read_more}
                          </a>
                        </Link>
                      </div>
                      <Link href={`/news/${item.seo_url}`}>
                        <div className="image">
                          <img
                            style={{ cursor: 'pointer' }}
                            src={item.image}
                            alt={item.html_content}
                          />
                        </div>
                      </Link>
                    </div>
                  );
                })}
              <Link href="/news">
                <a className="read-more d-flex d-md-none">
                  {trans.text_button.read_more}
                  <svg
                    width={33}
                    height={32}
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="16.4414" cy={16} r={16} fill="#0063AA" />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.44141 16.2491C5.44141 16.0501 5.52042 15.8594 5.66108 15.7187C5.80173 15.5781 5.99249 15.4991 6.19141 15.4991L23.8809 15.4991L19.1604 10.7801C19.0196 10.6392 18.9405 10.4482 18.9405 10.2491C18.9405 10.0499 19.0196 9.85888 19.1604 9.71805C19.3012 9.57722 19.4922 9.49811 19.6914 9.49811C19.8906 9.49811 20.0816 9.57722 20.2224 9.71805L26.2224 15.7181C26.2923 15.7877 26.3477 15.8705 26.3855 15.9616C26.4233 16.0527 26.4427 16.1504 26.4427 16.2491C26.4427 16.3477 26.4233 16.4454 26.3855 16.5365C26.3477 16.6276 26.2923 16.7104 26.2224 16.7801L20.2224 22.7801C20.0816 22.9209 19.8906 23 19.6914 23C19.4922 23 19.3012 22.9209 19.1604 22.7801C19.0196 22.6392 18.9405 22.4482 18.9405 22.2491C18.9405 22.0499 19.0196 21.8589 19.1604 21.7181L23.8809 16.9991L6.19141 16.9991C5.99249 16.9991 5.80173 16.92 5.66108 16.7794C5.52042 16.6387 5.44141 16.448 5.44141 16.2491Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </Link>
            </div>
          </div>
        )}

        {/* end news */}
        <div id="about">
          <div className="r-office-tcom">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 col-xl-3 col-left">
                  <div className="circle circle-1" />
                  <div className="circle circle-2" />
                  <div className="circle circle-3" />
                  <div className="inner">
                    <p>{trans.home.Image} &amp; Video</p>
                    <h3>{trans.home.office}</h3>
                    <a
                      ref={refClickYoutobe}
                      onClick={() => setIsShowModal(true)}
                      className="btn-start"
                    >
                      {trans.home.start}
                      <svg
                        width={40}
                        height={40}
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 2.5C10.3359 2.5 2.5 10.3359 2.5 20C2.5 29.6641 10.3359 37.5 20 37.5C29.6641 37.5 37.5 29.6641 37.5 20C37.5 10.3359 29.6641 2.5 20 2.5ZM25.6289 20.2695L17.0977 26.4766C17.0509 26.5102 16.9958 26.5302 16.9383 26.5346C16.8809 26.5389 16.8234 26.5273 16.7721 26.501C16.7208 26.4748 16.6778 26.4349 16.6477 26.3858C16.6176 26.3367 16.6017 26.2803 16.6016 26.2227V13.8164C16.6014 13.7587 16.6172 13.7021 16.6472 13.6528C16.6772 13.6035 16.7203 13.5635 16.7717 13.5372C16.8231 13.5109 16.8807 13.4994 16.9382 13.5038C16.9958 13.5083 17.051 13.5286 17.0977 13.5625L25.6289 19.7656C25.6692 19.7941 25.7021 19.8319 25.7248 19.8757C25.7475 19.9196 25.7593 19.9682 25.7593 20.0176C25.7593 20.0669 25.7475 20.1156 25.7248 20.1594C25.7021 20.2033 25.6692 20.241 25.6289 20.2695Z"
                          fill="#0063AA"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="col-12 col-xl-9 col-right">
                  <div className="tcom-image">
                    <Slider {...setting_office}>
                      {list_image_office &&
                        list_image_office.map(item => {
                          return (
                            <div className="item">
                              <img
                                src={item.url}
                                alt={item.name}
                                style={{ borderRadius: '25px' }}
                              />
                            </div>
                          );
                        })}

                      {/* <div className='item'>
                      <img src='./assets/images/about/gallery-2.png' alt='' />
                    </div>
                    <div className='item'>
                      <img src='./assets/images/about/gallery-1.png' alt='' />
                    </div>
                    <div className='item'>
                      <img src='./assets/images/about/gallery-2.png' alt='' />
                    </div>
                    <div className='item'>
                      <img src='./assets/images/about/gallery-1.png' alt='' />
                    </div>
                    <div className='item'>
                      <img src='./assets/images/about/gallery-2.png' alt='' />
                    </div> */}
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isShowModal && (
          <div class="c-lightbox-video ">
            <div class="c-lightbox-video__transaction"></div>
            <div class="c-lightbox-video__inner">
              <div ref={refYoutobe} class="c-lightbox-video__inner__form">
                <iframe
                  width="100%"
                  height="600"
                  src="https://www.youtube.com/embed/elZzejeEeSo?autoplay=1"
                  title="YouTube video player"
                  frameBorder={0}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
